/* tslint:disable */
/* eslint-disable */
/**
 * MWS.CatalogService.WebApp | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AddEventsToCategoryRequest {
    'eventIds'?: Array<string> | null;
}
export interface AddImageUrlToProductRequest {
    'imageUrl'?: string | null;
}
export interface AddressRequest {
    'name': string;
    'companyName'?: string | null;
    'street1': string;
    'street2'?: string | null;
    'city': string;
    'state'?: string | null;
    'zip': string;
    'country': string;
    'phone': string;
    'email'?: string | null;
    'eori'?: string | null;
    'vat'?: string | null;
    'easypostCarrierAccountId'?: string | null;
}
export interface AdminBeneficiaryDto {
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
    'id': string;
    'name'?: string | null;
    'description'?: string | null;
    'logoUrl'?: string | null;
    'websiteUrl'?: string | null;
    'percentage': number;
    'title'?: string | null;
    'isCharity': boolean;
}
export interface AdminBeneficiaryResponse {
    'id': string;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
    'name'?: string | null;
    'percentage': number;
    'isCharity': boolean;
    'title'?: string | null;
    'description'?: string | null;
    'logoUrl'?: string | null;
    'websiteUrl'?: string | null;
}
export interface AdminBidDto {
    'userId': string;
    'isDeleted': boolean;
    'deletedAt'?: Date | null;
    'deletedBy'?: string | null;
    'id': string;
    'skuId': string;
    'platformId': string;
    'userCountryIso'?: string | null;
    'previousBidId'?: string | null;
    'obfuscatedUserId': number;
    'amounts'?: { [key: string]: number; } | null;
    'bidType': BidType;
    'currency'?: string | null;
    'dateCreated': Date;
    'bidReceivedAt': Date;
    'bidTrust': BidTrust;
    'highestBid'?: boolean | null;
    'highestTiedBid'?: boolean | null;
}


export interface AdminCategoryReadModel {
    'id': string;
    'name': string;
    'slug': string;
    'priorityScore': number;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
    'externalReference'?: ExternalReferenceReadModel | null;
    'logoUrl'?: string | null;
    'bannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'defaultMatchScoredBallImageUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'description'?: string | null;
    'menuHierarchiesCount': number;
    'followersCount': number;
    'eventsCount': number;
    'participatingTeamsCount': number;
    'productsCount': number;
    'synonyms': Array<string>;
    'sendNotifications': boolean;
}
/**
 * Contains basic information about a category. An example of a category is \"Men\'s Football\".
 */
export interface AdminCategoryResponse {
    'id': string;
    'name': string;
    'slug': string;
    'priorityScore': number;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
    'externalReference'?: ExternalReferenceResponse | null;
    'logoUrl'?: string | null;
    'bannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'defaultMatchScoredBallImageUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'description'?: string | null;
    'sendNotifications': boolean;
}
export interface AdminEventParticipantResponse {
    'name'?: string | null;
    'eventId': string;
    'participantId': string;
    'isFeatured': boolean;
    'isHome': boolean;
}
export interface AdminEventPickupResponse {
    'id': string;
    'eventId': string;
    'shippingDetails': ShippingDetailsResponse;
    'pickupDetails': PickupDetailsResponse;
    'estimatedDeliveryDate'?: Date | null;
    'status'?: string | null;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy'?: string | null;
    'dateModified'?: Date | null;
    'isEmailSent'?: boolean | null;
}
export interface AdminEventPickupsListResponse {
    'id': string;
    'eventId': string;
    'eventName': string;
    'eventStatus': EventStatus;
    'teamName'?: string | null;
    'teamTier'?: number | null;
    'eventStartDate': Date;
    'eventEndDate': Date;
    'deliveryTime': Date;
    'deliveryStatus'?: string | null;
    'trackingUrl'?: string | null;
    'deliveredOn'?: Date | null;
    'isPriority': boolean;
}


export interface AdminEventProductSettingsResponse {
    'defaultSalesMethod': SalesMethod;
    'authenticityMethod': AuthenticityMethod;
    'basePriceInEuroCents': number;
    'defaultLabelIds': Array<string>;
    'defaultShippingType'?: ShippingType | null;
    'starterProductTypeId'?: string | null;
    'substituteProductTypeId'?: string | null;
    'goalBallProductTypeId'?: string | null;
    'benchProductTypeId'?: string | null;
    'defaultProductImages': Array<ImageWithPlayerPosition>;
    'kitReferences': Array<KitReference>;
}


export interface AdminEventResponse {
    'id': string;
    'externalId': string;
    'name': string;
    'forceEventName': boolean;
    'externalType': string;
    'status': string;
    'eventType': string;
    'slug': string;
    'heroBannerOverlayColor'?: string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'mediaVisibility': boolean;
    'highlightedProductIds': Array<string>;
    'dateCreated': Date;
    'featuredTeamCategories': Array<TeamCategoryDto>;
    'labels': Array<LabelDto>;
    'participatingTeamCategories': Array<TeamCategoryDto>;
    'productPublishSettings': ProductPublishSettingsDto;
    'headerImageUrl'?: string | null;
    'matchScoredBallImageUrl'?: string | null;
    'logoUrl': string;
    'highlightedInCategory'?: boolean | null;
    'priorityScore': number;
    'beneficiary'?: AdminBeneficiaryResponse | null;
    'financeSettings': EventFinanceSettingsResponse;
    'marketingSettings'?: EventMarketingSettingsResponse | null;
    'teamTier'?: number | null;
    'odooEventUrl'?: string | null;
    'odooProjectUrl'?: string | null;
    'odooInboundTaskUrl'?: string | null;
    'defaultFrameMockupSetId': string;
    'manualPredictedYield'?: number | null;
    'predictedYield': number;
    'predictedYieldProductAmount': number;
    'syncProductDates': boolean;
    'hidePartner': boolean;
    'categories'?: Array<CategoryDto> | null;
    'excludeFromHomePage': boolean;
    'excludeFromWeb': boolean;
    'excludeFromNowLive': boolean;
    'endingNoticeSent': boolean;
    'dateModified': Date;
    'modifiedBy': string;
    'createdBy': string;
    'highlightedOnHomepage': boolean;
    'eventPublicationResponses'?: Array<EventPublicationResponse> | null;
    'onFixtureResult': OnFixtureResult;
    'goLiveTiming': GoLiveTiming;
    'allowedStatus': Array<string>;
    'productSettings'?: AdminEventProductSettingsResponse | null;
    'switchedToPhotoMediaTimestamp'?: Date | null;
    'switchedToPhotoMediaBy'?: string | null;
}


export interface AdminExpectedInboundProduct {
    'productId': string;
    'isSigned': boolean;
    'signatureStandard': SignatureStandard;
    'size'?: string | null;
    'isReceived': boolean;
    'description'?: string | null;
    'countryOfOrigin'?: string | null;
    'condition': InboundProductConditionType;
    'wornDuring'?: InboundProductWornDuringType | null;
    'mediaContent'?: Array<MediaContentDto> | null;
    'image360Url'?: string | null;
}


export interface AdminExtraInboundProduct {
    'id'?: string | null;
    'name': string;
    'number': number;
    'isSigned': boolean;
    'signatureStandard': SignatureStandard;
    'isReceived': boolean;
    'size'?: string | null;
    'description'?: string | null;
    'countryOfOrigin'?: string | null;
    'condition': InboundProductConditionType;
    'wornDuring'?: InboundProductWornDuringType | null;
    'mediaContent'?: Array<MediaContentDto> | null;
    'image360Url'?: string | null;
}


export interface AdminInboundReportItemResponse {
    'id': string;
    'type': InboundReportType;
    'numberOfUpdated': number;
    'numberOfReceived': number;
    'numberOfCollected': number;
    'numberOfMatched': number;
    'numberOfProducts': number;
    'numberOfExtra': number;
    'createdOn': Date;
    'submittedOn'?: Date | null;
    'submittedBy'?: string | null;
    'odooReportId'?: number | null;
    'odooReportUrl'?: string | null;
}


export interface AdminMenuHierarchyResponse {
    'id': string;
    'name': string;
    'platformId': string;
    'parentId'?: string | null;
    'isVisible': boolean;
    'priorityScore': number;
    'category'?: CategoryResponse | null;
    'childrenIds'?: Array<string> | null;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
}
export interface AdminMenuHierarchyTreeResponse {
    'id': string;
    'name': string;
    'platformId': string;
    'parentId'?: string | null;
    'isVisible': boolean;
    'category': CategoryResponse;
    'priorityScore': number;
    'children': Array<AdminMenuHierarchyTreeResponse>;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
}
export interface AdminProductEventDto {
    'skuId': string;
    'eventId': string;
    'startDate': Date;
    'endDate': Date;
    'featuredTeams': Array<TeamCategoryDto>;
}
export interface AdminProductSkuDto {
    'athleteId': string;
    'productId': string;
    'internalName': string;
    'createdBy': string;
    'dateCreated': Date;
    'modifiedBy': string;
    'dateModified': Date;
    'collectionIds': Array<string>;
    'frameMockupSetId': string;
    'formalProductDescription': string;
    'event'?: AdminEventResponse | null;
    'teamId'?: string | null;
    'teamLogo'?: string | null;
    'countryOfOrigin'?: string | null;
    'inventoryInboundStatus': PublicProductInventoryInboundStatus;
    'inventoryReceivedStatus': PublicProductReceivedStatus;
    'inventoryReceivedAt'?: Date | null;
    'replacedByProductId'?: string | null;
    'replacedProductId'?: string | null;
    'serial'?: string | null;
    'signatureStandard': SignatureStandard;
    'framedProductId'?: string | null;
    'location'?: string | null;
    'setupProgress'?: ProductSetupProgressDto | null;
    'odooFrameSerialNumber'?: string | null;
    'sweepstakeId': string;
    'details'?: { [key: string]: string; } | null;
    'beneficiary'?: BeneficiaryDto | null;
    'productCategory': ProductCategory;
    'framingStatus': FramingType;
    'shippingType': ShippingType;
    'shippingOfficeId': string;
    'shippingDescription'?: string | null;
    'contractId': string;
    'eventLogoUrl'?: string | null;
    'eventName'?: string | null;
    'inStock': boolean;
    'hasBid': boolean;
    'isFollowedByUser': boolean;
    'isEventExcludedFromWeb': boolean;
    'fixtureDate'?: Date | null;
    'highestBid': boolean;
    'displayNameTranslation'?: string | null;
    'functionalDescription'?: string | null;
    'hasAiGeneratedDescription': boolean;
    'specialTierTitle'?: string | null;
    'specialTierDescription'?: string | null;
    'tierType': TierType;
    'id': string;
    'fabricksTrackableProductId'?: string | null;
    'type': string;
    'slug': string;
    'salesMethod': string;
    'eventId': string;
    'price': { [key: string]: number; };
    'quickBids': Array<{ [key: string]: number; }>;
    'startDate': Date;
    'endDate': Date;
    'displayName': string;
    'visibility': SkuVisibility;
    'labels': Array<LabelDto>;
    'media': Array<MediaContentDto>;
    'imageUrl'?: string | null;
    'secondaryImageUrl'?: string | null;
    'gallery': Array<MediaContentDto>;
    'finished': boolean;
    'priorityScore': number;
    'productDetails': { [key: string]: string; };
    'certificateNumber': string;
    'partnerLegalName': string;
    'partnerId': string;
    'description': string;
    'beneficiaryPercentage': number;
    'showBeneficiaryPercentage': boolean;
    'stock': number;
    'shortName'?: string | null;
    'authenticityMethod': AuthenticityMethod;
    'categories': Array<CategoryDto>;
    'customizable': boolean;
    'isWon'?: boolean | null;
    'productTypeId': string;
    'image360Url'?: string | null;
    'isMwsPartner'?: boolean | null;
}


export interface AdminUpdateMultipleProductListingsRequest {
    'updateProducts'?: Array<UpdateProductSkuRequestDto> | null;
}

export enum AuthenticityMethod {
    CertificateNumber = 'certificateNumber',
    Fabricks = 'fabricks',
    None = 'none'
}


export interface BeneficiaryDto {
    'id': string;
    'name'?: string | null;
    'description'?: string | null;
    'logoUrl'?: string | null;
    'websiteUrl'?: string | null;
    'percentage': number;
    'title'?: string | null;
    'isCharity': boolean;
}

export enum BidTrust {
    NotEstablished = 'notEstablished',
    Suspicious = 'suspicious',
    Trusted = 'trusted'
}



export enum BidType {
    Quickbid = 'quickbid',
    Bid = 'bid',
    AutomatiCBID = 'automatiCBID'
}


export interface BulkUpdateEventsRequest {
    'events': Array<string>;
    'newStatus'?: EventStatus | null;
    'newStartDate'?: Date | null;
    'newEndDate'?: Date | null;
    'newShippingType'?: ShippingType | null;
    'newBeneficiaryId'?: string | null;
    'changeBeneficiary': boolean;
    'manualPredictedYield'?: number | null;
}


export interface BulkUploadKitMockupImagesRequest {
    'images': Array<string>;
}
export interface CalendarEventResponse {
    'id': string;
    'name': string;
    'forceEventName': boolean;
    'status': string;
    'startDate': Date;
    'endDate': Date;
    'participants': Array<AdminEventParticipantResponse>;
    'marketingSettings'?: EventMarketingSettingsResponse | null;
    'teamTier'?: number | null;
}
export interface CategoryDto {
    'id': string;
    'name': string;
    'canonicalName': string;
    'slug': string;
    'logoUrl'?: string | null;
    'categoryBannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'defaultMatchScoredBallImageUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'externalReference'?: ExternalReferenceDto | null;
    'createdBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'modifiedBy': string;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'priorityScore': number;
    'description'?: string | null;
    'sendNotifications': boolean;
    'isFollowedByUser'?: boolean | null;
}
export interface CategoryExternalTypeRequest {
    'externalId'?: string | null;
    'type': PublicCategoryType;
}


export interface CategoryResponse {
    'id': string;
    'canonicalName': string;
    'slug': string;
    'externalReference'?: ExternalReferenceResponse | null;
    'logoUrl'?: string | null;
    'bannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'priorityScore': number;
    'description'?: string | null;
    'sendNotifications': boolean;
    'nameTranslation'?: TranslationResponse | null;
    'liveEventCount'?: number | null;
    'upcomingEventCount'?: number | null;
    'historicalEventCount'?: number | null;
    'name': string;
    'relatedCategories'?: Array<RelatedCategoryResponse> | null;
}
export interface ChannableEventFeedDto {
    'firstProduct'?: ChannableProductDto | null;
    'secondProduct'?: ChannableProductDto | null;
    'thirdProduct'?: ChannableProductDto | null;
    'shirtsCountInEvent'?: number | null;
    'sportsCategory'?: string | null;
    'clubName'?: string | null;
    'clubTier'?: number | null;
    'clubUrl'?: string | null;
    'competitionName'?: string | null;
    'startDate': Date;
    'endDate': Date;
    'eventLink'?: string | null;
    'teamId': string;
    'eventId': string;
    'matchDate'?: string | null;
    'matchName'?: string | null;
    'matchUrl'?: string | null;
    'oppositionName'?: string | null;
    'teamCountryName'?: string | null;
    'teamLogo'?: string | null;
    'predictedYield'?: string | null;
    'matchResult'?: string | null;
    'matchScore'?: string | null;
    'remainingDay'?: number | null;
    'roundName'?: string | null;
    'stageName'?: string | null;
}
export interface ChannableProductDto {
    'id': string;
    'additionalImageLinks'?: Array<string> | null;
    'availability'?: string | null;
    'brand'?: string | null;
    'condition'?: string | null;
    'currentBid'?: string | null;
    'currentBidGbp'?: string | null;
    'currentBidUsd'?: string | null;
    'framingStatus'?: string | null;
    'gender'?: string | null;
    'mainImageUrl'?: string | null;
    'squareImageUrl'?: string | null;
    'isSigned'?: string | null;
    'playerName'?: string | null;
    'productTypeName'?: string | null;
    'photoType'?: string | null;
    'displayName'?: string | null;
    'description'?: string | null;
    'video360Url'?: string | null;
}
export interface ChannableProductFeedDto {
    'productId': string;
    'isBuyNow': boolean;
    'isLegend': boolean;
    'playerName'?: string | null;
    'clubName'?: string | null;
    'matchName'?: string | null;
    'playerNumberOnBack'?: string | null;
    'currentHighestBidInEuros': number;
    'priceInEur'?: number | null;
    'priceInGbp'?: number | null;
    'priceInUsd'?: number | null;
    'minimumBidThresholdInEuros': number;
    'productUrl'?: string | null;
    'matchUrl'?: string | null;
    'clubUrl'?: string | null;
    'imageUrl'?: string | null;
    'squareImageUrl'?: string | null;
    'startDate': Date;
    'endDate': Date;
    'amountOfShirtsInThisAuction': number;
    'stock': number;
    'category'?: string | null;
    'brand'?: string | null;
    'itemGroupId'?: string | null;
    'gender'?: string | null;
    'additionalImageLinks'?: Array<string> | null;
    'shippingCountry'?: string | null;
    'productTypeName'?: string | null;
    'productCondition'?: string | null;
    'isSigned'?: string | null;
    'framingStatus'?: string | null;
    'competitionName'?: string | null;
    'oppositionName'?: string | null;
    'teamCountryName'?: string | null;
    'matchDate'?: string | null;
    'eventLink'?: string | null;
    'teamLogo'?: string | null;
    'teamTier'?: number | null;
    'primaryColour'?: string | null;
    'specialProductType'?: string | null;
    'displayName'?: string | null;
    'remainingDay'?: number | null;
    'remainingHour'?: number | null;
    'matchResult'?: string | null;
    'matchScore'?: string | null;
    'eventPredictedYield'?: string | null;
    'isGoalScorer': boolean;
    'roundName'?: string | null;
    'stageName'?: string | null;
    'description'?: string | null;
    'video360Url'?: string | null;
}
export interface CreateBeneficiaryRequestDto {
    'name': string;
    'title'?: string | null;
    'description'?: string | null;
    'logoUrl'?: string | null;
    'websiteUrl'?: string | null;
    'percentage': number;
    'isCharity': boolean;
}
export interface CreateCategoryRequest {
    'name': string;
    'slug': string;
    'externalReference'?: CategoryExternalTypeRequest | null;
    'platformId': string;
    'logoUrl'?: string | null;
    'bannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'priorityScore': number;
    'sendNotifications': boolean;
}
export interface CreateDowngradeProductRequest {
    'productTypeId': string;
    'replacedProductListingId': string;
    'price': number;
    'salesMethod'?: SalesMethod | null;
    'stock'?: number | null;
    'shippingType'?: ShippingType | null;
    'displayName'?: string | null;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
    'authenticityMethod'?: AuthenticityMethod | null;
    'notifyBidders': boolean;
    'productReceivedStatus': PublicProductReceivedStatus;
}


export interface CreateEventPickupRequest {
    'parcel': ParcelRequest;
    'minDatetime': Date;
    'maxDatetime': Date;
    'reference': string;
    'instructions'?: string | null;
    'fromAddress': AddressRequest;
    'toAddress': AddressRequest;
    'customsItems'?: Array<CustomsItemRequest> | null;
}
export interface CreateEventRequest {
    'partnerId': string;
    'name': string;
    'startDate': Date;
    'endDate': Date;
    'shippingOfficeId'?: string | null;
    'contractId'?: string | null;
    'sportSlug'?: string | null;
    'fixtureId'?: string | null;
    'settingsId'?: string | null;
    'teams': Array<CreateEventTeam>;
}
export interface CreateEventScheduleContractRequest {
    'financeContractId': string;
    'teamId': string;
    'teamName'?: string | null;
    'leagueId'?: string | null;
    'leagueName'?: string | null;
    'isAlwaysOn': boolean;
    'excludeGoalkeeperProducts': boolean;
    'startingElevenProductTypeId'?: string | null;
    'substitutionProductTypeId'?: string | null;
    'benchProductTypeId'?: string | null;
    'publishOnFixtureResult'?: OnFixtureResult | null;
    'goLiveTiming'?: GoLiveTiming | null;
    'otherProducts'?: { [key: string]: number; } | null;
    'beneficiaryId'?: string | null;
    'settingsId'?: string | null;
}


export interface CreateEventTeam {
    'name'?: string | null;
    'externalId': string;
    'isFeatured': boolean;
}
export interface CreateInboundProductRequest {
    'productId'?: string | null;
    'name': string;
    'playerNumber'?: string | null;
    'productTypeId'?: string | null;
    'isReceived': boolean;
    'signatureStandard': SignatureStandard;
    'size'?: string | null;
    'countryOfOrigin'?: string | null;
    'description'?: string | null;
    'receivedDate'?: Date | null;
}


export interface CreateInboundProductRequestV2 {
    'name': string;
    'condition': InboundProductConditionType;
    'isSigned': boolean;
    'signatureStandard': SignatureStandard;
    'number': number;
    'availability': InboundProductAvailabilityType;
    'wornDuring'?: InboundProductWornDuringType | null;
}


export interface CreateInboundReportRequest {
    'products': Array<CreateInboundProductRequest>;
    'comment': string;
}
export interface CreateKitMockupRequest {
    'athleteId'?: string | null;
    'shirtName'?: string | null;
    'shirtNumber'?: number | null;
    'images': Array<string>;
}
export interface CreateKitRequest {
    'description'?: string | null;
    'type': KitType;
    'isSpecialEdition': boolean;
    'colour': KitColour;
    'kitPlayerPosition': KitPlayerPosition;
    'teamId': string;
    'leagueId'?: string | null;
    'seasonId'?: string | null;
    'defaultFrameMockupSetId'?: string | null;
    'leagueName'?: string | null;
    'seasonName'?: string | null;
    'dueDate'?: Date | null;
    'note'?: string | null;
    'createAsanaTicket': boolean;
    'assetsUrl'?: string | null;
    'squadListUrl'?: string | null;
    'fontType': KitFontType;
    'fontColour'?: string | null;
    'assetsZipUrl'?: string | null;
    'customPassepartoutImageId'?: string | null;
}


export interface CreateLabelRequestDto {
    'text'?: string | null;
    'description'?: string | null;
}
export interface CreateListingForProductRequest {
    'eventId': string;
    'priceInEuroCents': number;
}
export interface CreateMenuHierarchyRequest {
    'name': string;
    'priorityScore': number;
    'platformId': string;
    'parentId'?: string | null;
    'isVisible': boolean;
    'childrenIds'?: Array<string> | null;
    'categoryId': string;
}
export interface CreateProductForEventRequest {
    'athleteId'?: string | null;
    'playerNumber'?: string | null;
    'platformKeys': Array<string>;
    'price'?: number | null;
    'stock'?: number | null;
    'salesMethod': SalesMethod;
    'displayName'?: string | null;
    'priorityScore': number;
    'productCategory'?: ProductCategory | null;
    'shippingType'?: ShippingType | null;
    'authenticityMethod': AuthenticityMethod;
    'productTypeId': string;
    'details'?: { [key: string]: string; } | null;
    'inventoryInboundStatus': PublicProductInventoryInboundStatus;
    'inventoryReceivedStatus': PublicProductReceivedStatus;
    'framedProductId'?: string | null;
    'shippingOfficeId'?: string | null;
    'linkedProductTypeId'?: string | null;
    'linkedProductName'?: string | null;
    'linkedProductSerial'?: ProductSerialType | null;
    'linkedProductStock'?: number | null;
    'applyKitMockup': boolean;
    'isSetupProduct': boolean;
}


export interface CreateProductListingRequest {
    'salesMethod': SalesMethod;
    'serialType': ProductSerialType;
    'stock'?: number | null;
    'shippingType': ShippingType;
    'displayName'?: string | null;
    'productTypeId': string;
    'startDate': Date;
    'endDate': Date;
    'contractId': string;
    'settingsId': string;
    'shippingOfficeId': string;
    'partnerId': string;
    'teamId'?: string | null;
    'frameMockupSetId'?: string | null;
    'isCustomizable'?: boolean | null;
    'price': number;
    'athleteId'?: string | null;
    'platformId': string;
    'authenticityMethod': AuthenticityMethod;
    'framedProductId'?: string | null;
    'linkedProductTypeId'?: string | null;
    'linkedProductName'?: string | null;
    'linkedProductSerial'?: ProductSerialType | null;
    'linkedProductStock'?: number | null;
    'supplierVendorId'?: string | null;
    'odooFrameSerialNumber'?: string | null;
}


export interface CreateUpgradeProductRequest {
    'productTypeId': string;
    'replacedProductListingId': string;
    'displayName'?: string | null;
    'notifyBidders': boolean;
    'productReceivedStatus': PublicProductReceivedStatus;
}


export interface CustomsItemRequest {
    'description'?: string | null;
    'hsTariffNumber'?: string | null;
    'originCountry'?: string | null;
    'expectedProductQuantity'?: number | null;
    'totalValue'?: number | null;
    'currency'?: string | null;
    'totalWeight'?: number | null;
}
export interface CustomsItemResponse {
    'description'?: string | null;
    'hsTariffNumber'?: string | null;
    'expectedProductQuantity'?: number | null;
    'totalValue'?: number | null;
    'totalWeight'?: number | null;
}
export interface DesignAngleResponse {
    'eventStartVisuals': boolean;
    'eventLiveVisuals': boolean;
    'eventClosingSoonVisuals': boolean;
    'directEmailBanner': boolean;
    'newsLetterImage': boolean;
    'isFootageAvailable': boolean;
    'assetsUrl'?: string | null;
    'asanaUrl'?: string | null;
    'comment'?: string | null;
    'dueDate'?: Date | null;
}
export interface EnrichedBidEntity {
    'skuId': string;
    'userId': string;
    'platformId': string;
    'userCountryIso'?: string | null;
    'previousBidId'?: string | null;
    'obfuscatedUserId': number;
    'amounts'?: { [key: string]: number; } | null;
    'currency'?: string | null;
    'bidType': BidType;
    'bidReceivedAt': Date;
    'isDeleted': boolean;
    'deletedAt': Date;
    'deletedBy': string;
    'bidTrust': BidTrust;
    'eventId': string;
    'eventName'?: string | null;
    'productName'?: string | null;
    'bidAmountInEur': number;
    'customerEmail'?: string | null;
    'customerCountry'?: string | null;
    'partnerName'?: string | null;
    'id': string;
    'dateCreated': Date;
    'createdBy': string;
    'dateModified': Date;
    'modifiedBy': string;
}


export interface EntityTagHeaderValue {
    'tag': StringSegment;
    'isWeak': boolean;
}
export interface EventDetailsDto {
    'categories': Array<CategoryDto>;
    'preferences': Array<EventPreferenceDto>;
    'isFollowedByUser': boolean;
    'isEventExcludedFromWeb': boolean;
    'legendId'?: string | null;
    'id': string;
    'shortId': ShortGuid;
    'externalId': string;
    'name': string;
    'translatedName'?: string | null;
    'canonicalName': string;
    'forceEventName': boolean;
    'externalType': string;
    'status': string;
    'eventType': string;
    'slug': string;
    'heroBannerOverlayColor'?: string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'mediaVisibility': boolean;
    'highlightedProductIds': Array<string>;
    'dateCreated': Date;
    'featuredTeamCategories': Array<TeamCategoryDto>;
    'labels': Array<LabelDto>;
    'participatingTeamCategories': Array<TeamCategoryDto>;
    'productPublishSettings': ProductPublishSettingsDto;
    'headerImageUrl'?: string | null;
    'matchScoredBallImageUrl'?: string | null;
    'logoUrl': string;
    'highlightedInCategory'?: boolean | null;
    'priorityScore': number;
    'beneficiary'?: BeneficiaryDto | null;
    'financeSettings': EventFinanceSettingsResponse;
    'marketingSettings'?: EventMarketingSettingsResponse | null;
    'teamTier'?: number | null;
    'odooEventUrl'?: string | null;
    'odooProjectUrl'?: string | null;
    'odooInboundTaskUrl'?: string | null;
}
export interface EventDto {
    'id': string;
    'shortId': ShortGuid;
    'externalId': string;
    'name': string;
    'translatedName'?: string | null;
    'canonicalName': string;
    'forceEventName': boolean;
    'externalType': string;
    'status': string;
    'eventType': string;
    'slug': string;
    'heroBannerOverlayColor'?: string | null;
    'startDate': Date;
    'endDate': Date;
    'isFinished': boolean;
    'mediaVisibility': boolean;
    'highlightedProductIds': Array<string>;
    'dateCreated': Date;
    'featuredTeamCategories': Array<TeamCategoryDto>;
    'labels': Array<LabelDto>;
    'participatingTeamCategories': Array<TeamCategoryDto>;
    'productPublishSettings': ProductPublishSettingsDto;
    'headerImageUrl'?: string | null;
    'matchScoredBallImageUrl'?: string | null;
    'logoUrl': string;
    'highlightedInCategory'?: boolean | null;
    'priorityScore': number;
    'beneficiary'?: BeneficiaryDto | null;
    'financeSettings': EventFinanceSettingsResponse;
    'marketingSettings'?: EventMarketingSettingsResponse | null;
    'teamTier'?: number | null;
    'odooEventUrl'?: string | null;
    'odooProjectUrl'?: string | null;
    'odooInboundTaskUrl'?: string | null;
}
export interface EventFinanceSettingsResponse {
    'partnerId'?: string | null;
    'partnerName'?: string | null;
    'partnerRegion'?: PartnerRegion | null;
    'partnerManagerUserId'?: string | null;
    'contractId'?: string | null;
    'settingsId'?: string | null;
    'shippingOfficeId'?: string | null;
    'isAdditional': boolean;
    'proformaFinancialResult'?: FinancialResultResponse | null;
    'finalFinancialResult'?: FinancialResultResponse | null;
}


export interface EventMarketingSettingsResponse {
    'marketingAngle': MarketingAngleResponse;
    'designAngle': DesignAngleResponse;
}
export interface EventPickupPrefillDataResponse {
    'weight': number;
    'reference': string;
    'shippingOfficeId': string;
    'customsItems': Array<CustomsItemResponse>;
}

export enum EventPickupStatus {
    PreTransit = 'preTransit',
    InTransit = 'inTransit',
    Delivered = 'delivered',
    Cancelled = 'cancelled'
}


export interface EventPreferenceDto {
    'id': string;
    'slug'?: string | null;
    'name'?: string | null;
    'featuredTeam'?: string | null;
    'logoUrl'?: string | null;
    'categoryIds'?: Array<string> | null;
    'productIds'?: Array<string> | null;
}
export interface EventProgressResponse {
    'id': string;
    'name': string;
    'manualPredictedYield'?: number | null;
    'predictedYield': number;
    'status': EventStatus;
    'startDate': Date;
    'originalEndDate': Date;
    'endDate': Date;
    'isAdditional': boolean;
    'products': Array<ProductTypeResponse>;
    'startingElevenProductTypeId'?: string | null;
    'substitutesProductTypeId'?: string | null;
    'benchedProductTypeId'?: string | null;
}


export interface EventPublicationResponse {
    'eventId': string;
    'platformId': string;
    'highlighted': boolean;
    'priorityScore': number;
    'excludeFromHomePage': boolean;
    'excludeFromWeb': boolean;
    'excludeFromNowLive': boolean;
}
export interface EventReportItemResponse {
    'id'?: string | null;
    'name': string;
    'number'?: number | null;
    'originalIsSigned': boolean;
    'isSigned': boolean;
    'signatureStandard': SignatureStandard;
    'size'?: string | null;
    'isReceived': boolean;
    'isChanged': boolean;
    'description'?: string | null;
    'countryOfOrigin'?: string | null;
    'condition': InboundProductConditionType;
    'availability': InboundProductAvailabilityType;
    'wornDuring'?: InboundProductWornDuringType | null;
    'changes': Array<string>;
    'isStored': boolean;
    'locationType'?: PublicInventoryLocationType | null;
    'section'?: number | null;
    'subSection'?: string | null;
    'productId'?: string | null;
    'productListingId'?: string | null;
    'productTypeId'?: string | null;
    'mediaContents': Array<MediaContentDto>;
    'image360Url'?: string | null;
}


export interface EventReportItemWithProductResponse {
    'id': string;
    'originalIsSigned': boolean;
    'isChanged': boolean;
    'availability': InboundProductAvailabilityType;
    'wornDuring'?: InboundProductWornDuringType | null;
    'changes': Array<string>;
    'productId': string;
    'productListingId'?: string | null;
    'productName': string;
    'productNumber'?: number | null;
    'productSize'?: string | null;
    'productDescription'?: string | null;
    'productFunctionalDescription'?: string | null;
    'productCountryOfOrigin'?: string | null;
    'productCondition': InboundProductConditionType;
    'productIsReplaced': boolean;
    'productIsExtra': boolean;
    'productIsReceived': boolean;
    'productHasPublishedListing': boolean;
    'productIsSigned': boolean;
    'productSignature': SignatureStandard;
    'productTypeId': string;
    'productLocation': string;
    'productIsStored': boolean;
    'productInventorySerial'?: string | null;
    'productInventorySection'?: number | null;
    'productInventorySubSection'?: string | null;
    'productInventoryLocationType': PublicInventoryLocationType;
    'productTypeIsSpecial': boolean;
    'mediaContents': Array<MediaContentDto>;
    'image360Url'?: string | null;
}


export interface EventScheduleContractResponse {
    'id': string;
    'financeContractId': string;
    'teamId': string;
    'teamName'?: string | null;
    'leagueId'?: string | null;
    'leagueName'?: string | null;
    'isAlwaysOn': boolean;
    'excludeGoalkeeperProducts': boolean;
    'startingElevenProductTypeId'?: string | null;
    'substitutionProductTypeId'?: string | null;
    'benchProductTypeId'?: string | null;
    'publishOnFixtureResult'?: OnFixtureResult | null;
    'goLiveTiming'?: GoLiveTiming | null;
    'otherProducts'?: { [key: string]: number; } | null;
    'beneficiaryId'?: string | null;
    'settingsId'?: string | null;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
}



export enum EventStatus {
    Draft = 'draft',
    Published = 'published',
    Unpublished = 'unpublished',
    Cancelled = 'cancelled',
    Confirmed = 'confirmed'
}


export interface ExportEventsToNewPlatformsRequest {
    'eventIds': Array<string>;
    'platformId': string;
}
export interface ExtendEventRequest {
    'endDate': Date;
    'extendReason': PublicEventDurationChangedReason;
}


export interface ExternalReferenceDto {
    'type': PublicCategoryType;
    'externalId'?: string | null;
}


export interface ExternalReferenceReadModel {
    'externalId'?: string | null;
    'type': PublicCategoryType;
}


export interface ExternalReferenceResponse {
    'externalId'?: string | null;
    'type': PublicCategoryType;
}


export interface FileResult {
    'contentType'?: string | null;
    'fileDownloadName'?: string | null;
    'lastModified'?: Date | null;
    'entityTag'?: EntityTagHeaderValue | null;
    'enableRangeProcessing': boolean;
}
export interface FinancialResultResponse {
    'grossProceeds': number;
    'netProceeds': number;
    'totalExternalCosts': number;
}

export enum FramingType {
    NotFrameable = 'notFrameable',
    Frameable = 'frameable',
    Framed = 'framed'
}


export interface GeneratePreSignedUrlRequest {
    'fileName'?: string | null;
}

export enum GoLiveTiming {
    PartnershipManagerApproval = 'partnershipManagerApproval',
    KickOff = 'kickOff',
    FinalWhistle = 'finalWhistle',
    RealShirtsLive = 'realShirtsLive'
}



export enum ImageOrigin {
    Mockup = 'mockup',
    Photo = 'photo',
    Unknown = 'unknown',
    Filler = 'filler',
    Gallery = 'gallery'
}


export interface ImageWithPlayerPosition {
    'image': string;
    'position': KitPlayerPosition;
}



export enum InboundProductAvailabilityType {
    Unknown = 'unknown',
    Collected = 'collected',
    ToBeCollected = 'toBeCollected',
    Unavailable = 'unavailable'
}



export enum InboundProductConditionType {
    Worn = 'worn',
    Issued = 'issued',
    Other = 'other'
}


export interface InboundProductResponse {
    'productSkuId'?: string | null;
    'productId'?: string | null;
    'name': string;
    'playerNumber': string;
    'productTypeId'?: string | null;
    'isReceived'?: boolean | null;
    'isSigned'?: boolean | null;
    'signatureStandard'?: SignatureStandard | null;
    'size': string;
    'countryOfOrigin'?: string | null;
    'description'?: string | null;
    'isInboundOnly': boolean;
    'receivedDate'?: Date | null;
    'mediaContents': Array<MediaContentDto>;
    'image360Url'?: string | null;
}



export enum InboundProductWornDuringType {
    Unknown = 'unknown',
    FirstHalf = 'firstHalf',
    SecondHalf = 'secondHalf',
    BothHalves = 'bothHalves'
}


export interface InboundProductsResponse {
    'actualProducts': Array<InboundProductResponse>;
    'unexpectedProducts'?: Array<InboundProductResponse> | null;
    'reportNote'?: ReportNote | null;
}
export interface InboundReportResponse {
    'id': string;
    'dateCreated': Date;
    'createdBy': string;
    'productsResponse'?: InboundProductsResponse | null;
}

export enum InboundReportType {
    Expected = 'expected',
    Kitman = 'kitman',
    Admin = 'admin',
    Storage = 'storage',
    Inbound = 'inbound',
    Photo = 'photo',
    Authenticity = 'authenticity'
}


export interface InboundReportsResponse {
    'id': string;
    'dateCreated': Date;
    'createdBy'?: string | null;
    'percentage': number;
    'comment'?: ReportNote | null;
}

export enum KitColour {
    Red = 'red',
    Blue = 'blue',
    Green = 'green',
    Yellow = 'yellow',
    Orange = 'orange',
    Pink = 'pink',
    Purple = 'purple',
    White = 'white',
    Grey = 'grey',
    Black = 'black',
    Brown = 'brown'
}



export enum KitFontType {
    Domestic = 'domestic',
    European = 'european',
    Unique = 'unique'
}


export interface KitMockupFrameAssetResponse {
    'id': string;
    'frontWithSleevesImageUrl'?: string | null;
    'frontNoSleevesImageUrl'?: string | null;
    'backWithSleevesImageUrl'?: string | null;
    'backNoSleevesImageUrl'?: string | null;
}
export interface KitMockupResponse {
    'id': string;
    'kitId': string;
    'athleteId'?: string | null;
    'shirtName'?: string | null;
    'shirtNumber'?: number | null;
    'images': Array<string>;
    'isArchived': boolean;
    'isApproved': boolean;
    'mockupSetId'?: string | null;
}

export enum KitPlayerPosition {
    Other = 'other',
    Player = 'player',
    Goalkeeper = 'goalkeeper'
}


export interface KitReference {
    'id': string;
    'position': KitPlayerPosition;
}


export interface KitResponse {
    'id': string;
    'name'?: string | null;
    'description'?: string | null;
    'type'?: KitType | null;
    'isSpecialEdition': boolean;
    'colour'?: KitColour | null;
    'kitPlayerPosition': KitPlayerPosition;
    'defaultImage'?: string | null;
    'teamId': string;
    'rosterId'?: string | null;
    'leagueId'?: string | null;
    'seasonId'?: string | null;
    'defaultFrameMockupSetId'?: string | null;
    'customPassepartoutImageId'?: string | null;
    'nsPid'?: string | null;
    'sPid'?: string | null;
    'note'?: string | null;
    'asanaUrl'?: string | null;
    'assetsUrl'?: string | null;
    'fontType'?: KitFontType | null;
    'fontColour'?: string | null;
    'squadListUrl'?: string | null;
    'dueDate'?: Date | null;
    'mockups': Array<KitMockupResponse>;
    'dateCreated': Date;
    'dateModified': Date;
    'createdBy': string;
    'modifiedBy': string;
    'isArchived': boolean;
    'assetsZipUrl'?: string | null;
    'workFilesZipUrl'?: string | null;
}



export enum KitType {
    Home = 'home',
    Away = 'away',
    Third = 'third',
    Unique = 'unique',
    Goalkeeper = 'goalkeeper'
}


export interface KitmanInboundProductResponse {
    'id': string;
    'name': string;
    'condition': InboundProductConditionType;
    'isSigned': boolean;
    'signatureStandard': SignatureStandard;
    'number'?: number | null;
    'availability': InboundProductAvailabilityType;
    'wornDuring'?: InboundProductWornDuringType | null;
}


export interface KitmanInboundReportResponse {
    'id': string;
    'name': string;
    'date': Date;
    'products': Array<KitmanInboundProductResponse>;
}
export interface LabelDto {
    'id': string;
    'createdBy': string;
    'modifiedBy': string;
    'dateCreated': Date;
    'dateModified': Date;
    'text'?: string | null;
    'description'?: string | null;
    'isReservedByProductType': boolean;
}
export interface LatestEventReportResponse {
    'id': string;
    'type': InboundReportType;
    'teamAbbreviation': string;
    'expectedProducts': Array<EventReportItemWithProductResponse>;
    'extraItems': Array<EventReportItemResponse>;
    'submittedOn'?: Date | null;
}


export interface MarketingAngleResponse {
    'description'?: string | null;
    'isHighlighted': boolean;
    'hasMarketingAngle': boolean;
}
export interface MediaContentDto {
    'type': PublicMediaType;
    'url': string;
    'visibility': boolean;
    'metaData': MetaDataDto;
}


export interface MetaDataDto {
    'origin': ImageOrigin;
    'applyPadding': boolean;
}



export enum OnFixtureResult {
    None = 'none',
    Win = 'win',
    Draw = 'draw',
    Noloss = 'noloss',
    Loss = 'loss',
    Nodraw = 'nodraw',
    Nowin = 'nowin'
}


export interface PaginatedListOfAdminBeneficiaryDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminBeneficiaryDto>;
}
export interface PaginatedListOfAdminCategoryResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminCategoryResponse>;
}
export interface PaginatedListOfAdminEventPickupResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminEventPickupResponse>;
}
export interface PaginatedListOfAdminEventPickupsListResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminEventPickupsListResponse>;
}
export interface PaginatedListOfAdminEventResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminEventResponse>;
}
export interface PaginatedListOfAdminInboundReportItemResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminInboundReportItemResponse>;
}
export interface PaginatedListOfAdminProductSkuDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<AdminProductSkuDto>;
}
export interface PaginatedListOfBeneficiaryDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<BeneficiaryDto>;
}
export interface PaginatedListOfEnrichedBidEntity {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<EnrichedBidEntity>;
}
export interface PaginatedListOfEventDto {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<EventDto>;
}
export interface PaginatedListOfInboundReportsResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<InboundReportsResponse>;
}
export interface PaginatedListOfKitResponse {
    'totalCount': number;
    'resultCount': number;
    'offset': number;
    'pageSize': number;
    'results': Array<KitResponse>;
}
export interface ParcelRequest {
    'length': number;
    'width': number;
    'height': number;
    'weight': number;
}

export enum PartnerRegion {
    France = 'france',
    Belgium = 'belgium',
    Italy = 'italy',
    Netherlands = 'netherlands',
    UnitedKingdom = 'unitedKingdom',
    Turkey = 'turkey',
    EasternEurope = 'easternEurope',
    Nordics = 'nordics',
    Spain = 'spain',
    Portugal = 'portugal',
    MexicoSouthAmerica = 'mexicoSouthAmerica',
    Brazil = 'brazil',
    Germany = 'germany',
    AustraliaNewZealand = 'australiaNewZealand',
    SouthEastAsia = 'southEastAsia',
    MiddleEast = 'middleEast',
    NorthAmerica = 'northAmerica',
    AustraliaAmsterdam = 'australiaAmsterdam',
    Cycling = 'cycling',
    Legends = 'legends',
    Resales = 'resales',
    FramingProjects = 'framingProjects',
    Africa = 'africa'
}


export interface PartnerSandboxFixtureResponse {
    'fixtureId': string;
    'eventId': string;
    'partnerId': string;
    'eventName': string;
    'startDate': Date;
    'endDate': Date;
    'keptAt': Date;
    'productCount': number;
}
export interface PartnerSandboxOverviewResponse {
    'partners': Array<PartnerSandboxPartnerResponse>;
    'warnings': Array<string>;
}
export interface PartnerSandboxPartnerResponse {
    'partnerId': string;
    'partnerName'?: string | null;
    'markedAt': Date;
    'fixtures': Array<PartnerSandboxFixtureResponse>;
}
export interface PartnerSandboxReplayOutcome {
    'key': string;
    'fixtureId'?: string | null;
    'status': PartnerSandboxReplayStatus;
    'reason'?: string | null;
    'eventId'?: string | null;
    'productsCreated': number;
    'productsSkipped': number;
    'warnings'?: Array<string> | null;
}



export enum PartnerSandboxReplayStatus {
    Replayed = 'replayed',
    Skipped = 'skipped',
    Failed = 'failed'
}


export interface PartnerSandboxReplaySummary {
    'enabled': boolean;
    'replayed': number;
    'skipped': number;
    'failed': number;
    'fixtures': Array<PartnerSandboxReplayOutcome>;
}
export interface PartnerSandboxSnapshotSummary {
    'enabled': boolean;
    'written': number;
    'pruned': number;
    'warnings': Array<string>;
}
export interface PickupDetailsResponse {
    'pickupId'?: string | null;
    'status'?: string | null;
    'confirmation'?: string | null;
    'pickupWindow'?: PickupWindowResponse | null;
}
export interface PickupWindowResponse {
    'fromTime'?: Date | null;
    'toTime'?: Date | null;
}
export interface ProblemDetails {
    'type'?: string | null;
    'title'?: string | null;
    'status'?: number | null;
    'detail'?: string | null;
    'instance'?: string | null;
}

export enum ProductCategory {
    Normal = 'normal',
    Special = 'special'
}


export interface ProductPublishSettingsDto {
    'publishingDisabled': boolean;
    'autoPublishNonParticipatingLineup': boolean;
    'autoPublishParticipationChanges': boolean;
    'autoPublishInitialLineup': boolean;
    'featureGoalBallProducts': boolean;
    'excludeGoalkeeperProducts': boolean;
    'featureGoalBallsOnPlatformIds'?: Array<string> | null;
}

export enum ProductSerialType {
    Serial = 'serial',
    Lot = 'lot'
}


export interface ProductSetupProgressDto {
    'mediaUploaded': boolean;
    'productTypeSelected': boolean;
    'sportsDataLinked': boolean;
}
export interface ProductSkuDto {
    'id': string;
    'fabricksTrackableProductId'?: string | null;
    'type': string;
    'slug': string;
    'salesMethod': string;
    'eventId': string;
    'price': { [key: string]: number; };
    'quickBids': Array<{ [key: string]: number; }>;
    'startDate': Date;
    'endDate': Date;
    'displayName': string;
    'visibility': SkuVisibility;
    'labels': Array<LabelDto>;
    'media': Array<MediaContentDto>;
    'imageUrl'?: string | null;
    'secondaryImageUrl'?: string | null;
    'gallery': Array<MediaContentDto>;
    'finished': boolean;
    'priorityScore': number;
    'productDetails': { [key: string]: string; };
    'certificateNumber': string;
    'partnerLegalName': string;
    'partnerId': string;
    'description': string;
    'beneficiaryPercentage': number;
    'showBeneficiaryPercentage': boolean;
    'stock': number;
    'shortName'?: string | null;
    'authenticityMethod': AuthenticityMethod;
    'categories': Array<CategoryDto>;
    'customizable': boolean;
    'isWon'?: boolean | null;
    'productTypeId': string;
    'image360Url'?: string | null;
    'isMwsPartner'?: boolean | null;
}


export interface ProductTypeResponse {
    'productId': string;
    'productTypeId': string;
}

export enum ProductUnpublishReason {
    Cancelled = 'cancelled',
    Duplicated = 'duplicated',
    NotReceived = 'notReceived'
}



export enum PublicCategoryType {
    Country = 'country',
    League = 'league',
    Team = 'team',
    Sport = 'sport',
    Other = 'other',
    Gender = 'gender',
    Athlete = 'athlete',
    Condition = 'condition',
    Highlight = 'highlight',
    Campaign = 'campaign'
}



export enum PublicEventDurationChangedReason {
    ExtendedBecauseProductsHaveNotArrived = 'extendedBecauseProductsHaveNotArrived',
    ExtendedBecauseInternationalBreaks = 'extendedBecauseInternationalBreaks',
    ExtendedBecauseCargoDelays = 'extendedBecauseCargoDelays',
    ExtendedBecausePreSeasonInternationalTours = 'extendedBecausePreSeasonInternationalTours',
    ExtendedBecauseBidPlaced = 'extendedBecauseBidPlaced',
    FixtureRescheduled = 'fixtureRescheduled',
    Other = 'other'
}



export enum PublicInventoryLocationType {
    Unknown = 'unknown',
    Processing = 'processing',
    Short = '_short',
    Special = 'special',
    Shipping = 'shipping',
    Long = '_long',
    Framing = 'framing',
    Shipped = 'shipped',
    ToLong = 'toLong',
    Odoo = 'odoo',
    Box = 'box',
    Rack = 'rack'
}



export enum PublicMediaType {
    Video = 'video',
    Image = 'image'
}



export enum PublicProductInventoryInboundStatus {
    Expected = 'expected',
    Duplicate = 'duplicate',
    Cancelled = 'cancelled',
    Extra = 'extra',
    Upgraded = 'upgraded'
}



export enum PublicProductReceivedStatus {
    Received = 'received',
    NotReceived = 'notReceived',
    NotApplicable = 'notApplicable',
    Unknown = 'unknown'
}


export interface RelatedCategoryResponse {
    'id': string;
    'name': string;
    'slug': string;
    'externalReference'?: ExternalReferenceResponse | null;
    'logoUrl'?: string | null;
}
export interface ReportNote {
    'dateCreated': Date;
    'createdBy': string;
    'content'?: string | null;
}

export enum SalesMethod {
    Sweepstakes = 'sweepstakes',
    Bidding = 'bidding',
    Fixedprice = 'fixedprice',
    Addon = 'addon'
}


export interface SetEventBeneficiaryRequest {
    'beneficiaryId'?: string | null;
}
export interface ShippingDetailsResponse {
    'shippingId'?: string | null;
    'trackingCode': string;
    'trackingUrl': string;
    'commercialInvoiceUrl'?: string | null;
    'labelUrl': string;
    'rate': string;
    'carrier': string;
}

export enum ShippingType {
    PaidShipping = 'paidShipping',
    FreeShipping = 'freeShipping',
    NoShipping = 'noShipping',
    FreeDomesticShipping = 'freeDomesticShipping'
}


export interface ShortGuid {
    'guid': string;
    'value'?: string | null;
}

export enum SignatureStandard {
    NotApplicable = 'notApplicable',
    Golden = 'golden',
    Faulty = 'faulty',
    Missing = 'missing'
}



export enum SkuVisibility {
    Published = 'published',
    Unpublished = 'unpublished'
}



export enum SortDirection {
    Ascending = 'ascending',
    Descending = 'descending'
}



export enum SortEventOn {
    StartDate = 'startDate',
    EndDate = 'endDate',
    EndDateClosestToNow = 'endDateClosestToNow'
}



export enum SortEventPickupOn {
    DateCreated = 'dateCreated',
    DeliveredOn = 'deliveredOn',
    TeamTier = 'teamTier',
    EventEndDate = 'eventEndDate'
}



export enum SortProductListingOn {
    Name = 'name',
    Visibility = 'visibility',
    Price = 'price',
    Team = 'team',
    Location = 'location',
    EventStatus = 'eventStatus',
    StartDate = 'startDate',
    EndDate = 'endDate',
    EventName = 'eventName',
    Number = 'number'
}


export interface StorableProduct {
    'productId': string;
    'locationType'?: PublicInventoryLocationType | null;
    'isStored': boolean;
    'section'?: number | null;
    'subSection'?: string | null;
}


export interface StringSegment {
    'buffer'?: string | null;
    'offset': number;
    'length': number;
    'value'?: string | null;
    'hasValue': boolean;
}
export interface TeamCategoryDto {
    'teamId': string;
    'categoryId': string;
    'name': string;
    'slug': string;
    'logoUrl'?: string | null;
    'categoryBannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
}

export enum TierType {
    Normal = 'normal',
    Gold = 'gold',
    Silver = 'silver',
    Bronze = 'bronze'
}


export interface TranslationResponse {
    'value'?: string | null;
    'isAiGenerated': boolean;
}
export interface UnpublishProductRequest {
    'reason'?: ProductUnpublishReason | null;
    'notifyBidders': boolean;
}


export interface UpdateAndSubmitAdminInboundReportRequest {
    'reportId': string;
    'expectedProducts'?: Array<AdminExpectedInboundProduct> | null;
    'extraProducts'?: Array<AdminExtraInboundProduct> | null;
}
export interface UpdateAndSubmitPhotoReportRequest {
    'reportId': string;
}
export interface UpdateAndSubmitStorageInboundReportRequest {
    'reportId': string;
    'storedProducts': Array<StorableProduct>;
}
export interface UpdateBeneficiaryRequestDto {
    'name'?: string | null;
    'description'?: string | null;
    'logoUrl'?: string | null;
    'websiteUrl'?: string | null;
    'percentage': number;
    'isCharity': boolean;
    'title'?: string | null;
}
export interface UpdateCategoryRequest {
    'name': string;
    'slug': string;
    'priorityScore'?: number | null;
    'logoUrl'?: string | null;
    'bannerUrl'?: string | null;
    'defaultEventBannerUrl'?: string | null;
    'defaultMatchScoredBallImageUrl'?: string | null;
    'cutoutImageUrl'?: string | null;
    'mobileCutoutImageUrl'?: string | null;
    'primaryColor'?: string | null;
    'secondaryColor'?: string | null;
    'platformId': string;
    'externalReference'?: CategoryExternalTypeRequest | null;
    'showUpcomingEvents': boolean;
    'showAsCardView': boolean;
    'showTotalRaised': boolean;
    'description'?: string | null;
    'synonyms'?: Array<string> | null;
    'sendNotifications': boolean;
}
export interface UpdateDesignAngleRequest {
    'eventStartVisuals': boolean;
    'eventLiveVisuals': boolean;
    'eventClosingSoonVisuals': boolean;
    'directEmailBanner': boolean;
    'newsletterImage': boolean;
    'isFootageAvailable': boolean;
    'assetsUrl'?: string | null;
    'comment'?: string | null;
    'dueDate'?: Date | null;
}
export interface UpdateEventContractRequestDto {
    'partnerId': string;
    'contractId'?: string | null;
    'shippingOfficeId'?: string | null;
    'settingsId'?: string | null;
    'regenerateCustomerInvoices': boolean;
    'overrideEventPropertiesFromContract': boolean;
}
export interface UpdateEventHidePartnerRequest {
    'hidePartner': boolean;
}
export interface UpdateEventPartnerManagerRequest {
    'partnerManagerUserId'?: string | null;
}
export interface UpdateEventPredictedYieldRequest {
    'eventId': string;
    'predictedYield': number;
}
export interface UpdateEventProductSettingsRequest {
    'defaultSalesMethod': SalesMethod;
    'authenticityMethod': AuthenticityMethod;
    'basePriceInEuroCents': number;
    'defaultLabelIds': Array<string>;
    'defaultShippingType'?: ShippingType | null;
    'starterProductTypeId'?: string | null;
    'substituteProductTypeId'?: string | null;
    'benchProductTypeId'?: string | null;
    'goalBallProductTypeId'?: string | null;
    'defaultProductImages': Array<ImageWithPlayerPosition>;
    'kitReferences': Array<KitReference>;
}


export interface UpdateEventPublicationsRequest {
    'excludeFromNowLive': boolean;
    'highlightOnHomePage': boolean;
    'excludeFromHomePage': boolean;
    'excludeFromWeb': boolean;
    'priorityScore': number;
}
export interface UpdateEventRequestDto {
    'name'?: string | null;
    'forceEventName': boolean;
    'syncProductDates'?: boolean | null;
    'slug'?: string | null;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
    'heroBannerOverlayColor'?: string | null;
    'autoPublishNonParticipatingLineup': boolean;
    'autoPublishParticipationChanges': boolean;
    'autoPublishInitialLineup': boolean;
    'featureGoalBallProducts': boolean;
    'excludeGoalkeeperProducts': boolean;
    'featureGoalBallsOnPlatformIds'?: Array<string> | null;
    'defaultFrameMockupSetId'?: string | null;
    'categoryIds'?: Array<string> | null;
    'headerImageUrl'?: string | null;
    'logoImageUrl'?: string | null;
    'matchScoredBallImageUrl'?: string | null;
    'onFixtureResult'?: OnFixtureResult | null;
    'goLiveTiming'?: GoLiveTiming | null;
}


export interface UpdateEventScheduleContractRequest {
    'isAlwaysOn': boolean;
    'startDate': Date;
    'endDate': Date;
    'excludeGoalkeeperProducts': boolean;
    'startingElevenProductTypeId'?: string | null;
    'substitutionProductTypeId'?: string | null;
    'benchProductTypeId'?: string | null;
    'publishOnFixtureResult'?: OnFixtureResult | null;
    'goLiveTiming'?: GoLiveTiming | null;
    'otherProducts'?: { [key: string]: number; } | null;
    'beneficiaryId'?: string | null;
    'settingsId'?: string | null;
}


export interface UpdateEventStatusRequest {
    'status': EventStatus;
}


export interface UpdateInboundProductRequest {
    'condition': InboundProductConditionType;
    'isSigned': boolean;
    'availability': InboundProductAvailabilityType;
    'wornDuring'?: InboundProductWornDuringType | null;
    'number'?: number | null;
}


export interface UpdateKitAssetFilesRequest {
    'assetsZipUrl'?: string | null;
    'workFilesZipUrl'?: string | null;
}
export interface UpdateKitDetailsRequest {
    'name'?: string | null;
    'description'?: string | null;
    'type': KitType;
    'isSpecialEdition': boolean;
    'colour': KitColour;
    'kitPlayerPosition': KitPlayerPosition;
    'defaultImage'?: string | null;
    'defaultFrameMockupSetId'?: string | null;
    'customPassepartoutImageId'?: string | null;
    'nsPid'?: string | null;
    'sPid'?: string | null;
}


export interface UpdateKitMockupFrameAssetRequest {
    'frontWithNoSleevesUrl': string;
    'frontWithSleevesUrl': string;
    'backWithNoSleevesUrl': string;
    'backWithSleevesUrl': string;
    'teamId'?: string | null;
    'mockupSetId'?: string | null;
}
export interface UpdateKitMockupImagesRequest {
    'id': string;
    'images': Array<string>;
}
export interface UpdateKitMockupRequest {
    'id': string;
    'shirtName'?: string | null;
    'shirtNumber'?: number | null;
    'images': Array<string>;
}
export interface UpdateKitMockupsImagesRequest {
    'kitMockups': Array<UpdateKitMockupImagesRequest>;
}
export interface UpdateLabelRequestDto {
    'text'?: string | null;
    'description'?: string | null;
}
export interface UpdateMarketingAngleRequest {
    'description'?: string | null;
    'isHighlighted': boolean;
}
export interface UpdateMenuHierarchyRequest {
    'name': string;
    'priorityScore': number;
    'platformId': string;
    'parentId'?: string | null;
    'childrenIds'?: Array<string> | null;
    'categoryId': string;
    'isVisible': boolean;
}
export interface UpdateProductCategoriesRequest {
    'productId': string;
    'categoryIds'?: Array<string> | null;
}
export interface UpdateProductPriceRequest {
    'prices': { [key: string]: number; };
}
export interface UpdateProductSetupProgressRequest {
    'mediaUploaded'?: boolean | null;
    'productTypeSelected'?: boolean | null;
    'sportsDataLinked'?: boolean | null;
}
export interface UpdateProductSkuRequestDto {
    'id'?: string | null;
    'stock'?: number | null;
    'internalName'?: string | null;
    'visibility'?: SkuVisibility | null;
    'unpublishReason'?: ProductUnpublishReason | null;
    'priceInEuroCents'?: number | null;
    'priorityScore'?: number | null;
    'certificateNumber'?: string | null;
    'productCategory'?: ProductCategory | null;
    'shippingType'?: ShippingType | null;
    'authenticityMethod'?: AuthenticityMethod | null;
    'productTypeId'?: string | null;
    'startDate'?: Date | null;
    'endDate'?: Date | null;
    'description'?: string | null;
    'beneficiaryPercentage'?: number | null;
    'details'?: { [key: string]: string; } | null;
    'labelIds'?: Array<string> | null;
    'teamId'?: string | null;
    'teamLogo'?: string | null;
    'shortName'?: string | null;
    'shippingOfficeId'?: string | null;
    'contractId'?: string | null;
    'settingsId'?: string | null;
    'customizable'?: boolean | null;
    'inventoryInboundStatus'?: PublicProductInventoryInboundStatus | null;
    'inventoryReceivedStatus'?: PublicProductReceivedStatus | null;
    'signatureStandard'?: SignatureStandard | null;
    'framedProductId'?: string | null;
}


export interface UserProfileStatsDto {
    'numBidsPlaced': number;
    'numProductsBidOn': number;
}
export interface ValidationFailure {
    'errorCode'?: string | null;
    'errorMessage'?: string | null;
    'propertyName'?: string | null;
}

/**
 * AdminBeneficiaryApi - axios parameter creator
 */
export const AdminBeneficiaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns beneficiary details by id
         * @param {string} beneficiaryId the id (guid) of the beneficiary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesBeneficiaryIdGet: async (beneficiaryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'beneficiaryId' is not null or undefined
            assertParamExists('adminBeneficiariesBeneficiaryIdGet', 'beneficiaryId', beneficiaryId)
            const localVarPath = `/admin/beneficiaries/{beneficiaryId}`
                .replace('{beneficiaryId}', encodeURIComponent(String(beneficiaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a beneficiary
         * @param {string} beneficiaryId The beneficiary ID
         * @param {UpdateBeneficiaryRequestDto} updateBeneficiaryRequestDto A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesBeneficiaryIdPut: async (beneficiaryId: string, updateBeneficiaryRequestDto: UpdateBeneficiaryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'beneficiaryId' is not null or undefined
            assertParamExists('adminBeneficiariesBeneficiaryIdPut', 'beneficiaryId', beneficiaryId)
            // verify required parameter 'updateBeneficiaryRequestDto' is not null or undefined
            assertParamExists('adminBeneficiariesBeneficiaryIdPut', 'updateBeneficiaryRequestDto', updateBeneficiaryRequestDto)
            const localVarPath = `/admin/beneficiaries/{beneficiaryId}`
                .replace('{beneficiaryId}', encodeURIComponent(String(beneficiaryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBeneficiaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [admin] Paginated list endpoint for showing and filtering of all beneficiaries
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {string} [sortColumn] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesGet: async (searchTerm?: string, offset?: number, pageSize?: number, sortColumn?: string, sortDirection?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/beneficiaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a beneficiary
         * @param {CreateBeneficiaryRequestDto} createBeneficiaryRequestDto A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesPost: async (createBeneficiaryRequestDto: CreateBeneficiaryRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBeneficiaryRequestDto' is not null or undefined
            assertParamExists('adminBeneficiariesPost', 'createBeneficiaryRequestDto', createBeneficiaryRequestDto)
            const localVarPath = `/admin/beneficiaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBeneficiaryRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBeneficiaryApi - functional programming interface
 */
export const AdminBeneficiaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBeneficiaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns beneficiary details by id
         * @param {string} beneficiaryId the id (guid) of the beneficiary
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBeneficiariesBeneficiaryIdGet(beneficiaryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBeneficiaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBeneficiariesBeneficiaryIdGet(beneficiaryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBeneficiaryApi.adminBeneficiariesBeneficiaryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a beneficiary
         * @param {string} beneficiaryId The beneficiary ID
         * @param {UpdateBeneficiaryRequestDto} updateBeneficiaryRequestDto A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBeneficiariesBeneficiaryIdPut(beneficiaryId: string, updateBeneficiaryRequestDto: UpdateBeneficiaryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBeneficiaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBeneficiariesBeneficiaryIdPut(beneficiaryId, updateBeneficiaryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBeneficiaryApi.adminBeneficiariesBeneficiaryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [admin] Paginated list endpoint for showing and filtering of all beneficiaries
         * @param {string} [searchTerm] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {string} [sortColumn] 
         * @param {string} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBeneficiariesGet(searchTerm?: string, offset?: number, pageSize?: number, sortColumn?: string, sortDirection?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminBeneficiaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBeneficiariesGet(searchTerm, offset, pageSize, sortColumn, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBeneficiaryApi.adminBeneficiariesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a beneficiary
         * @param {CreateBeneficiaryRequestDto} createBeneficiaryRequestDto A Cancellation token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBeneficiariesPost(createBeneficiaryRequestDto: CreateBeneficiaryRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBeneficiaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBeneficiariesPost(createBeneficiaryRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBeneficiaryApi.adminBeneficiariesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBeneficiaryApi - factory interface
 */
export const AdminBeneficiaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBeneficiaryApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns beneficiary details by id
         * @param {AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesBeneficiaryIdGet(requestParameters: AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBeneficiaryDto> {
            return localVarFp.adminBeneficiariesBeneficiaryIdGet(requestParameters.beneficiaryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a beneficiary
         * @param {AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesBeneficiaryIdPut(requestParameters: AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBeneficiaryDto> {
            return localVarFp.adminBeneficiariesBeneficiaryIdPut(requestParameters.beneficiaryId, requestParameters.updateBeneficiaryRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [admin] Paginated list endpoint for showing and filtering of all beneficiaries
         * @param {AdminBeneficiaryApiAdminBeneficiariesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesGet(requestParameters: AdminBeneficiaryApiAdminBeneficiariesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminBeneficiaryDto> {
            return localVarFp.adminBeneficiariesGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a beneficiary
         * @param {AdminBeneficiaryApiAdminBeneficiariesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBeneficiariesPost(requestParameters: AdminBeneficiaryApiAdminBeneficiariesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBeneficiaryDto> {
            return localVarFp.adminBeneficiariesPost(requestParameters.createBeneficiaryRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminBeneficiariesBeneficiaryIdGet operation in AdminBeneficiaryApi.
 */
export interface AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdGetRequest {
    /**
     * the id (guid) of the beneficiary
     */
    readonly beneficiaryId: string
}

/**
 * Request parameters for adminBeneficiariesBeneficiaryIdPut operation in AdminBeneficiaryApi.
 */
export interface AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdPutRequest {
    /**
     * The beneficiary ID
     */
    readonly beneficiaryId: string

    /**
     * A Cancellation token.
     */
    readonly updateBeneficiaryRequestDto: UpdateBeneficiaryRequestDto
}

/**
 * Request parameters for adminBeneficiariesGet operation in AdminBeneficiaryApi.
 */
export interface AdminBeneficiaryApiAdminBeneficiariesGetRequest {
    /**
     * 
     */
    readonly searchTerm?: string

    /**
     * 
     */
    readonly offset?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly sortColumn?: string

    /**
     * 
     */
    readonly sortDirection?: string
}

/**
 * Request parameters for adminBeneficiariesPost operation in AdminBeneficiaryApi.
 */
export interface AdminBeneficiaryApiAdminBeneficiariesPostRequest {
    /**
     * A Cancellation token.
     */
    readonly createBeneficiaryRequestDto: CreateBeneficiaryRequestDto
}

/**
 * AdminBeneficiaryApi - object-oriented interface
 */
export class AdminBeneficiaryApi extends BaseAPI {
    /**
     * 
     * @summary Returns beneficiary details by id
     * @param {AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBeneficiariesBeneficiaryIdGet(requestParameters: AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminBeneficiaryApiFp(this.configuration).adminBeneficiariesBeneficiaryIdGet(requestParameters.beneficiaryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a beneficiary
     * @param {AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBeneficiariesBeneficiaryIdPut(requestParameters: AdminBeneficiaryApiAdminBeneficiariesBeneficiaryIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminBeneficiaryApiFp(this.configuration).adminBeneficiariesBeneficiaryIdPut(requestParameters.beneficiaryId, requestParameters.updateBeneficiaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [admin] Paginated list endpoint for showing and filtering of all beneficiaries
     * @param {AdminBeneficiaryApiAdminBeneficiariesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBeneficiariesGet(requestParameters: AdminBeneficiaryApiAdminBeneficiariesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminBeneficiaryApiFp(this.configuration).adminBeneficiariesGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, requestParameters.sortColumn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a beneficiary
     * @param {AdminBeneficiaryApiAdminBeneficiariesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBeneficiariesPost(requestParameters: AdminBeneficiaryApiAdminBeneficiariesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminBeneficiaryApiFp(this.configuration).adminBeneficiariesPost(requestParameters.createBeneficiaryRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminBidsApi - axios parameter creator
 */
export const AdminBidsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Soft Delete the Bid
         * @param {string} bidId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsBidIdDelete: async (bidId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bidId' is not null or undefined
            assertParamExists('adminBidsBidIdDelete', 'bidId', bidId)
            const localVarPath = `/admin/bids/{bidId}`
                .replace('{bidId}', encodeURIComponent(String(bidId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Set a bid to suspicious or trusted
         * @param {string} bidId 
         * @param {boolean} isTrusted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsBidIdIsTrustedIsTrustedPatch: async (bidId: string, isTrusted: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bidId' is not null or undefined
            assertParamExists('adminBidsBidIdIsTrustedIsTrustedPatch', 'bidId', bidId)
            // verify required parameter 'isTrusted' is not null or undefined
            assertParamExists('adminBidsBidIdIsTrustedIsTrustedPatch', 'isTrusted', isTrusted)
            const localVarPath = `/admin/bids/{bidId}/is-trusted/{isTrusted}`
                .replace('{bidId}', encodeURIComponent(String(bidId)))
                .replace('{isTrusted}', encodeURIComponent(String(isTrusted)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] List and search all bids
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {string} [xPlatformKey] 
         * @param {string} [searchTerm] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsGet: async (offSet?: number, pageSize?: number, xPlatformKey?: string, searchTerm?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/bids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminBidsApi - functional programming interface
 */
export const AdminBidsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminBidsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Soft Delete the Bid
         * @param {string} bidId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBidsBidIdDelete(bidId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBidDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBidsBidIdDelete(bidId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBidsApi.adminBidsBidIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Set a bid to suspicious or trusted
         * @param {string} bidId 
         * @param {boolean} isTrusted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBidsBidIdIsTrustedIsTrustedPatch(bidId: string, isTrusted: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminBidDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBidsBidIdIsTrustedIsTrustedPatch(bidId, isTrusted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBidsApi.adminBidsBidIdIsTrustedIsTrustedPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] List and search all bids
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {string} [xPlatformKey] 
         * @param {string} [searchTerm] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBidsGet(offSet?: number, pageSize?: number, xPlatformKey?: string, searchTerm?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfEnrichedBidEntity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBidsGet(offSet, pageSize, xPlatformKey, searchTerm, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminBidsApi.adminBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminBidsApi - factory interface
 */
export const AdminBidsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminBidsApiFp(configuration)
    return {
        /**
         * 
         * @summary Soft Delete the Bid
         * @param {AdminBidsApiAdminBidsBidIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsBidIdDelete(requestParameters: AdminBidsApiAdminBidsBidIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBidDto> {
            return localVarFp.adminBidsBidIdDelete(requestParameters.bidId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Set a bid to suspicious or trusted
         * @param {AdminBidsApiAdminBidsBidIdIsTrustedIsTrustedPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsBidIdIsTrustedIsTrustedPatch(requestParameters: AdminBidsApiAdminBidsBidIdIsTrustedIsTrustedPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminBidDto> {
            return localVarFp.adminBidsBidIdIsTrustedIsTrustedPatch(requestParameters.bidId, requestParameters.isTrusted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] List and search all bids
         * @param {AdminBidsApiAdminBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBidsGet(requestParameters: AdminBidsApiAdminBidsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfEnrichedBidEntity> {
            return localVarFp.adminBidsGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminBidsBidIdDelete operation in AdminBidsApi.
 */
export interface AdminBidsApiAdminBidsBidIdDeleteRequest {
    /**
     * 
     */
    readonly bidId: string
}

/**
 * Request parameters for adminBidsBidIdIsTrustedIsTrustedPatch operation in AdminBidsApi.
 */
export interface AdminBidsApiAdminBidsBidIdIsTrustedIsTrustedPatchRequest {
    /**
     * 
     */
    readonly bidId: string

    /**
     * 
     */
    readonly isTrusted: boolean
}

/**
 * Request parameters for adminBidsGet operation in AdminBidsApi.
 */
export interface AdminBidsApiAdminBidsGetRequest {
    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number

    readonly xPlatformKey?: string

    /**
     * 
     */
    readonly searchTerm?: string

    readonly userId?: string
}

/**
 * AdminBidsApi - object-oriented interface
 */
export class AdminBidsApi extends BaseAPI {
    /**
     * 
     * @summary Soft Delete the Bid
     * @param {AdminBidsApiAdminBidsBidIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBidsBidIdDelete(requestParameters: AdminBidsApiAdminBidsBidIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminBidsApiFp(this.configuration).adminBidsBidIdDelete(requestParameters.bidId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Set a bid to suspicious or trusted
     * @param {AdminBidsApiAdminBidsBidIdIsTrustedIsTrustedPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBidsBidIdIsTrustedIsTrustedPatch(requestParameters: AdminBidsApiAdminBidsBidIdIsTrustedIsTrustedPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminBidsApiFp(this.configuration).adminBidsBidIdIsTrustedIsTrustedPatch(requestParameters.bidId, requestParameters.isTrusted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] List and search all bids
     * @param {AdminBidsApiAdminBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminBidsGet(requestParameters: AdminBidsApiAdminBidsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminBidsApiFp(this.configuration).adminBidsGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCategoriesApi - axios parameter creator
 */
export const AdminCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a category.
         * @param {string} categoryId 
         * @param {string} [newCategoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdDelete: async (categoryId: string, newCategoryId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdDelete', 'categoryId', categoryId)
            const localVarPath = `/admin/categories/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (newCategoryId !== undefined) {
                localVarQueryParameter['newCategoryId'] = newCategoryId;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an event from a category.
         * @param {string} categoryId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdEventsEventIdDelete: async (categoryId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdEventsEventIdDelete', 'categoryId', categoryId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdEventsEventIdDelete', 'eventId', eventId)
            const localVarPath = `/admin/categories/{categoryId}/events/{eventId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add an event to a category.
         * @param {string} categoryId 
         * @param {AddEventsToCategoryRequest} addEventsToCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdEventsPost: async (categoryId: string, addEventsToCategoryRequest: AddEventsToCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdEventsPost', 'categoryId', categoryId)
            // verify required parameter 'addEventsToCategoryRequest' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdEventsPost', 'addEventsToCategoryRequest', addEventsToCategoryRequest)
            const localVarPath = `/admin/categories/{categoryId}/events`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEventsToCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdGet: async (categoryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdGet', 'categoryId', categoryId)
            const localVarPath = `/admin/categories/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a category
         * @param {string} categoryId 
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdPut: async (categoryId: string, updateCategoryRequest: UpdateCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdPut', 'categoryId', categoryId)
            // verify required parameter 'updateCategoryRequest' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdPut', 'updateCategoryRequest', updateCategoryRequest)
            const localVarPath = `/admin/categories/{categoryId}`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all categories
         * @param {string} [searchTerm] 
         * @param {PublicCategoryType} [type] 
         * @param {string} [categoryIds] 
         * @param {string} [slugs] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesGet: async (searchTerm?: string, type?: PublicCategoryType, categoryIds?: string, slugs?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['categoryIds'] = categoryIds;
            }

            if (slugs !== undefined) {
                localVarQueryParameter['slugs'] = slugs;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a category
         * @param {CreateCategoryRequest} createCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesPost: async (createCategoryRequest: CreateCategoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCategoryRequest' is not null or undefined
            assertParamExists('adminCategoriesPost', 'createCategoryRequest', createCategoryRequest)
            const localVarPath = `/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCategoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCategoriesApi - functional programming interface
 */
export const AdminCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a category.
         * @param {string} categoryId 
         * @param {string} [newCategoryId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdDelete(categoryId: string, newCategoryId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdDelete(categoryId, newCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesCategoryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an event from a category.
         * @param {string} categoryId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdEventsEventIdDelete(categoryId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdEventsEventIdDelete(categoryId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesCategoryIdEventsEventIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add an event to a category.
         * @param {string} categoryId 
         * @param {AddEventsToCategoryRequest} addEventsToCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdEventsPost(categoryId: string, addEventsToCategoryRequest: AddEventsToCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdEventsPost(categoryId, addEventsToCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesCategoryIdEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a category
         * @param {string} categoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdGet(categoryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCategoryReadModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdGet(categoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesCategoryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a category
         * @param {string} categoryId 
         * @param {UpdateCategoryRequest} updateCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdPut(categoryId: string, updateCategoryRequest: UpdateCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdPut(categoryId, updateCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesCategoryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all categories
         * @param {string} [searchTerm] 
         * @param {PublicCategoryType} [type] 
         * @param {string} [categoryIds] 
         * @param {string} [slugs] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesGet(searchTerm?: string, type?: PublicCategoryType, categoryIds?: string, slugs?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesGet(searchTerm, type, categoryIds, slugs, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a category
         * @param {CreateCategoryRequest} createCategoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesPost(createCategoryRequest: CreateCategoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCategoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesPost(createCategoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoriesApi.adminCategoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCategoriesApi - factory interface
 */
export const AdminCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a category.
         * @param {AdminCategoriesApiAdminCategoriesCategoryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdDelete(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCategoriesCategoryIdDelete(requestParameters.categoryId, requestParameters.newCategoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an event from a category.
         * @param {AdminCategoriesApiAdminCategoriesCategoryIdEventsEventIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdEventsEventIdDelete(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdEventsEventIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCategoryResponse> {
            return localVarFp.adminCategoriesCategoryIdEventsEventIdDelete(requestParameters.categoryId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add an event to a category.
         * @param {AdminCategoriesApiAdminCategoriesCategoryIdEventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdEventsPost(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdEventsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCategoryResponse> {
            return localVarFp.adminCategoriesCategoryIdEventsPost(requestParameters.categoryId, requestParameters.addEventsToCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a category
         * @param {AdminCategoriesApiAdminCategoriesCategoryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdGet(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCategoryReadModel> {
            return localVarFp.adminCategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a category
         * @param {AdminCategoriesApiAdminCategoriesCategoryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdPut(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCategoryResponse> {
            return localVarFp.adminCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.updateCategoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all categories
         * @param {AdminCategoriesApiAdminCategoriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesGet(requestParameters: AdminCategoriesApiAdminCategoriesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminCategoryResponse> {
            return localVarFp.adminCategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.slugs, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a category
         * @param {AdminCategoriesApiAdminCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesPost(requestParameters: AdminCategoriesApiAdminCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCategoryResponse> {
            return localVarFp.adminCategoriesPost(requestParameters.createCategoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCategoriesCategoryIdDelete operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesCategoryIdDeleteRequest {
    readonly categoryId: string

    readonly newCategoryId?: string
}

/**
 * Request parameters for adminCategoriesCategoryIdEventsEventIdDelete operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesCategoryIdEventsEventIdDeleteRequest {
    readonly categoryId: string

    readonly eventId: string
}

/**
 * Request parameters for adminCategoriesCategoryIdEventsPost operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesCategoryIdEventsPostRequest {
    readonly categoryId: string

    readonly addEventsToCategoryRequest: AddEventsToCategoryRequest
}

/**
 * Request parameters for adminCategoriesCategoryIdGet operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesCategoryIdGetRequest {
    /**
     * 
     */
    readonly categoryId: string
}

/**
 * Request parameters for adminCategoriesCategoryIdPut operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesCategoryIdPutRequest {
    readonly categoryId: string

    readonly updateCategoryRequest: UpdateCategoryRequest
}

/**
 * Request parameters for adminCategoriesGet operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesGetRequest {
    readonly searchTerm?: string

    readonly type?: PublicCategoryType

    readonly categoryIds?: string

    readonly slugs?: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminCategoriesPost operation in AdminCategoriesApi.
 */
export interface AdminCategoriesApiAdminCategoriesPostRequest {
    readonly createCategoryRequest: CreateCategoryRequest
}

/**
 * AdminCategoriesApi - object-oriented interface
 */
export class AdminCategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Delete a category.
     * @param {AdminCategoriesApiAdminCategoriesCategoryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdDelete(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesCategoryIdDelete(requestParameters.categoryId, requestParameters.newCategoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an event from a category.
     * @param {AdminCategoriesApiAdminCategoriesCategoryIdEventsEventIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdEventsEventIdDelete(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdEventsEventIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesCategoryIdEventsEventIdDelete(requestParameters.categoryId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add an event to a category.
     * @param {AdminCategoriesApiAdminCategoriesCategoryIdEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdEventsPost(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdEventsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesCategoryIdEventsPost(requestParameters.categoryId, requestParameters.addEventsToCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a category
     * @param {AdminCategoriesApiAdminCategoriesCategoryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdGet(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesCategoryIdGet(requestParameters.categoryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a category
     * @param {AdminCategoriesApiAdminCategoriesCategoryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdPut(requestParameters: AdminCategoriesApiAdminCategoriesCategoryIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesCategoryIdPut(requestParameters.categoryId, requestParameters.updateCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all categories
     * @param {AdminCategoriesApiAdminCategoriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesGet(requestParameters: AdminCategoriesApiAdminCategoriesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesGet(requestParameters.searchTerm, requestParameters.type, requestParameters.categoryIds, requestParameters.slugs, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a category
     * @param {AdminCategoriesApiAdminCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesPost(requestParameters: AdminCategoriesApiAdminCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminCategoriesApiFp(this.configuration).adminCategoriesPost(requestParameters.createCategoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventAuthenticityReportApi - axios parameter creator
 */
export const AdminEventAuthenticityReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdAuthenticityReportsPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdAuthenticityReportsPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/authenticity-reports`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdAuthenticityReportsSyncPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdAuthenticityReportsSyncPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/authenticity-reports/sync`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventAuthenticityReportApi - functional programming interface
 */
export const AdminEventAuthenticityReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventAuthenticityReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdAuthenticityReportsPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdAuthenticityReportsPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventAuthenticityReportApi.adminEventsEventIdAuthenticityReportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdAuthenticityReportsSyncPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdAuthenticityReportsSyncPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventAuthenticityReportApi.adminEventsEventIdAuthenticityReportsSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventAuthenticityReportApi - factory interface
 */
export const AdminEventAuthenticityReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventAuthenticityReportApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdAuthenticityReportsPost(requestParameters: AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdAuthenticityReportsPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdAuthenticityReportsSyncPost(requestParameters: AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdAuthenticityReportsSyncPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdAuthenticityReportsPost operation in AdminEventAuthenticityReportApi.
 */
export interface AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsPostRequest {
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdAuthenticityReportsSyncPost operation in AdminEventAuthenticityReportApi.
 */
export interface AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsSyncPostRequest {
    readonly eventId: string
}

/**
 * AdminEventAuthenticityReportApi - object-oriented interface
 */
export class AdminEventAuthenticityReportApi extends BaseAPI {
    /**
     * 
     * @param {AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdAuthenticityReportsPost(requestParameters: AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventAuthenticityReportApiFp(this.configuration).adminEventsEventIdAuthenticityReportsPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdAuthenticityReportsSyncPost(requestParameters: AdminEventAuthenticityReportApiAdminEventsEventIdAuthenticityReportsSyncPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventAuthenticityReportApiFp(this.configuration).adminEventsEventIdAuthenticityReportsSyncPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventFinanceSettingsApi - axios parameter creator
 */
export const AdminEventFinanceSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdFinanceSettingsAdditionalPut: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdFinanceSettingsAdditionalPut', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/finance-settings/additional`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventFinanceSettingsApi - functional programming interface
 */
export const AdminEventFinanceSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventFinanceSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdFinanceSettingsAdditionalPut(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdFinanceSettingsAdditionalPut(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventFinanceSettingsApi.adminEventsEventIdFinanceSettingsAdditionalPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventFinanceSettingsApi - factory interface
 */
export const AdminEventFinanceSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventFinanceSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {AdminEventFinanceSettingsApiAdminEventsEventIdFinanceSettingsAdditionalPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdFinanceSettingsAdditionalPut(requestParameters: AdminEventFinanceSettingsApiAdminEventsEventIdFinanceSettingsAdditionalPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdFinanceSettingsAdditionalPut(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdFinanceSettingsAdditionalPut operation in AdminEventFinanceSettingsApi.
 */
export interface AdminEventFinanceSettingsApiAdminEventsEventIdFinanceSettingsAdditionalPutRequest {
    /**
     * The id of the event that should be marked as additional
     */
    readonly eventId: string
}

/**
 * AdminEventFinanceSettingsApi - object-oriented interface
 */
export class AdminEventFinanceSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Toggle whether an event is additional
     * @param {AdminEventFinanceSettingsApiAdminEventsEventIdFinanceSettingsAdditionalPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdFinanceSettingsAdditionalPut(requestParameters: AdminEventFinanceSettingsApiAdminEventsEventIdFinanceSettingsAdditionalPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventFinanceSettingsApiFp(this.configuration).adminEventsEventIdFinanceSettingsAdditionalPut(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventInboundProductsApi - axios parameter creator
 */
export const AdminEventInboundProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Admin] Get inbound reports for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsGet', 'eventId', eventId)
            const localVarPath = `/events/{eventId}/inbound-reports`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new inbound report
         * @param {string} eventId 
         * @param {CreateInboundReportRequest} createInboundReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsPost: async (eventId: string, createInboundReportRequest: CreateInboundReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsPost', 'eventId', eventId)
            // verify required parameter 'createInboundReportRequest' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsPost', 'createInboundReportRequest', createInboundReportRequest)
            const localVarPath = `/events/{eventId}/inbound-reports`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInboundReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get inbound products for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsProductsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsProductsGet', 'eventId', eventId)
            const localVarPath = `/events/{eventId}/inbound-reports/products`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Get a specific inbound report for an event
         * @param {string} eventId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsReportIdGet: async (eventId: string, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsReportIdGet', 'eventId', eventId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('eventsEventIdInboundReportsReportIdGet', 'reportId', reportId)
            const localVarPath = `/events/{eventId}/inbound-reports/{reportId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)))
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventInboundProductsApi - functional programming interface
 */
export const AdminEventInboundProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventInboundProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get inbound reports for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventIdInboundReportsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfInboundReportsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventIdInboundReportsGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventInboundProductsApi.eventsEventIdInboundReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new inbound report
         * @param {string} eventId 
         * @param {CreateInboundReportRequest} createInboundReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventIdInboundReportsPost(eventId: string, createInboundReportRequest: CreateInboundReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventIdInboundReportsPost(eventId, createInboundReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventInboundProductsApi.eventsEventIdInboundReportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get inbound products for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventIdInboundReportsProductsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventIdInboundReportsProductsGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventInboundProductsApi.eventsEventIdInboundReportsProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Get a specific inbound report for an event
         * @param {string} eventId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventIdInboundReportsReportIdGet(eventId: string, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InboundReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventIdInboundReportsReportIdGet(eventId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventInboundProductsApi.eventsEventIdInboundReportsReportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventInboundProductsApi - factory interface
 */
export const AdminEventInboundProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventInboundProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Admin] Get inbound reports for an event
         * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfInboundReportsResponse> {
            return localVarFp.eventsEventIdInboundReportsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new inbound report
         * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsPost(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<InboundReportResponse> {
            return localVarFp.eventsEventIdInboundReportsPost(requestParameters.eventId, requestParameters.createInboundReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get inbound products for an event
         * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsProductsGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InboundProductsResponse> {
            return localVarFp.eventsEventIdInboundReportsProductsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Get a specific inbound report for an event
         * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsReportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdInboundReportsReportIdGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<InboundReportResponse> {
            return localVarFp.eventsEventIdInboundReportsReportIdGet(requestParameters.eventId, requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for eventsEventIdInboundReportsGet operation in AdminEventInboundProductsApi.
 */
export interface AdminEventInboundProductsApiEventsEventIdInboundReportsGetRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for eventsEventIdInboundReportsPost operation in AdminEventInboundProductsApi.
 */
export interface AdminEventInboundProductsApiEventsEventIdInboundReportsPostRequest {
    /**
     * 
     */
    readonly eventId: string

    /**
     * 
     */
    readonly createInboundReportRequest: CreateInboundReportRequest
}

/**
 * Request parameters for eventsEventIdInboundReportsProductsGet operation in AdminEventInboundProductsApi.
 */
export interface AdminEventInboundProductsApiEventsEventIdInboundReportsProductsGetRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for eventsEventIdInboundReportsReportIdGet operation in AdminEventInboundProductsApi.
 */
export interface AdminEventInboundProductsApiEventsEventIdInboundReportsReportIdGetRequest {
    /**
     * 
     */
    readonly eventId: string

    /**
     * 
     */
    readonly reportId: string
}

/**
 * AdminEventInboundProductsApi - object-oriented interface
 */
export class AdminEventInboundProductsApi extends BaseAPI {
    /**
     * 
     * @summary [Admin] Get inbound reports for an event
     * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventIdInboundReportsGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventInboundProductsApiFp(this.configuration).eventsEventIdInboundReportsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new inbound report
     * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventIdInboundReportsPost(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventInboundProductsApiFp(this.configuration).eventsEventIdInboundReportsPost(requestParameters.eventId, requestParameters.createInboundReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get inbound products for an event
     * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventIdInboundReportsProductsGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsProductsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventInboundProductsApiFp(this.configuration).eventsEventIdInboundReportsProductsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Get a specific inbound report for an event
     * @param {AdminEventInboundProductsApiEventsEventIdInboundReportsReportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventIdInboundReportsReportIdGet(requestParameters: AdminEventInboundProductsApiEventsEventIdInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventInboundProductsApiFp(this.configuration).eventsEventIdInboundReportsReportIdGet(requestParameters.eventId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventMarketingSettingsApi - axios parameter creator
 */
export const AdminEventMarketingSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set the design angle of an event
         * @param {string} eventId 
         * @param {UpdateDesignAngleRequest} updateDesignAngleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdMarketingSettingsDesignAnglePut: async (eventId: string, updateDesignAngleRequest: UpdateDesignAngleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdMarketingSettingsDesignAnglePut', 'eventId', eventId)
            // verify required parameter 'updateDesignAngleRequest' is not null or undefined
            assertParamExists('adminEventsEventIdMarketingSettingsDesignAnglePut', 'updateDesignAngleRequest', updateDesignAngleRequest)
            const localVarPath = `/admin/events/{eventId}/marketing-settings/design-angle`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDesignAngleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {string} eventId 
         * @param {UpdateMarketingAngleRequest} updateMarketingAngleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdMarketingSettingsMarketingAnglePut: async (eventId: string, updateMarketingAngleRequest: UpdateMarketingAngleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdMarketingSettingsMarketingAnglePut', 'eventId', eventId)
            // verify required parameter 'updateMarketingAngleRequest' is not null or undefined
            assertParamExists('adminEventsEventIdMarketingSettingsMarketingAnglePut', 'updateMarketingAngleRequest', updateMarketingAngleRequest)
            const localVarPath = `/admin/events/{eventId}/marketing-settings/marketing-angle`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMarketingAngleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventMarketingSettingsApi - functional programming interface
 */
export const AdminEventMarketingSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventMarketingSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set the design angle of an event
         * @param {string} eventId 
         * @param {UpdateDesignAngleRequest} updateDesignAngleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdMarketingSettingsDesignAnglePut(eventId: string, updateDesignAngleRequest: UpdateDesignAngleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdMarketingSettingsDesignAnglePut(eventId, updateDesignAngleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventMarketingSettingsApi.adminEventsEventIdMarketingSettingsDesignAnglePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {string} eventId 
         * @param {UpdateMarketingAngleRequest} updateMarketingAngleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdMarketingSettingsMarketingAnglePut(eventId: string, updateMarketingAngleRequest: UpdateMarketingAngleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdMarketingSettingsMarketingAnglePut(eventId, updateMarketingAngleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventMarketingSettingsApi.adminEventsEventIdMarketingSettingsMarketingAnglePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventMarketingSettingsApi - factory interface
 */
export const AdminEventMarketingSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventMarketingSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Set the design angle of an event
         * @param {AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsDesignAnglePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdMarketingSettingsDesignAnglePut(requestParameters: AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsDesignAnglePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdMarketingSettingsDesignAnglePut(requestParameters.eventId, requestParameters.updateDesignAngleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsMarketingAnglePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdMarketingSettingsMarketingAnglePut(requestParameters: AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsMarketingAnglePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdMarketingSettingsMarketingAnglePut(requestParameters.eventId, requestParameters.updateMarketingAngleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdMarketingSettingsDesignAnglePut operation in AdminEventMarketingSettingsApi.
 */
export interface AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsDesignAnglePutRequest {
    readonly eventId: string

    readonly updateDesignAngleRequest: UpdateDesignAngleRequest
}

/**
 * Request parameters for adminEventsEventIdMarketingSettingsMarketingAnglePut operation in AdminEventMarketingSettingsApi.
 */
export interface AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsMarketingAnglePutRequest {
    readonly eventId: string

    readonly updateMarketingAngleRequest: UpdateMarketingAngleRequest
}

/**
 * AdminEventMarketingSettingsApi - object-oriented interface
 */
export class AdminEventMarketingSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Set the design angle of an event
     * @param {AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsDesignAnglePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdMarketingSettingsDesignAnglePut(requestParameters: AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsDesignAnglePutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventMarketingSettingsApiFp(this.configuration).adminEventsEventIdMarketingSettingsDesignAnglePut(requestParameters.eventId, requestParameters.updateDesignAngleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the marketing angle of an event
     * @param {AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsMarketingAnglePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdMarketingSettingsMarketingAnglePut(requestParameters: AdminEventMarketingSettingsApiAdminEventsEventIdMarketingSettingsMarketingAnglePutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventMarketingSettingsApiFp(this.configuration).adminEventsEventIdMarketingSettingsMarketingAnglePut(requestParameters.eventId, requestParameters.updateMarketingAngleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventPartnerSandboxApi - axios parameter creator
 */
export const AdminEventPartnerSandboxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Staging] List the partner sandbox partners and their fixtures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partner-sandbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Staging] Stop keeping a partner and its fixtures in the partner sandbox
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxPartnersPartnerIdDelete: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnerSandboxPartnersPartnerIdDelete', 'partnerId', partnerId)
            const localVarPath = `/admin/partner-sandbox/partners/{partnerId}`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Staging] Mark a partner as partner sandbox partner
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxPartnersPartnerIdPut: async (partnerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnerSandboxPartnersPartnerIdPut', 'partnerId', partnerId)
            const localVarPath = `/admin/partner-sandbox/partners/{partnerId}`
                .replace('{partnerId}', encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventPartnerSandboxApi - functional programming interface
 */
export const AdminEventPartnerSandboxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventPartnerSandboxApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Staging] List the partner sandbox partners and their fixtures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerSandboxGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerSandboxOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerSandboxGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPartnerSandboxApi.adminPartnerSandboxGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Staging] Stop keeping a partner and its fixtures in the partner sandbox
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerSandboxPartnersPartnerIdDelete(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerSandboxPartnersPartnerIdDelete(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPartnerSandboxApi.adminPartnerSandboxPartnersPartnerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Staging] Mark a partner as partner sandbox partner
         * @param {string} partnerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPartnerSandboxPartnersPartnerIdPut(partnerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerSandboxPartnerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPartnerSandboxPartnersPartnerIdPut(partnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPartnerSandboxApi.adminPartnerSandboxPartnersPartnerIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventPartnerSandboxApi - factory interface
 */
export const AdminEventPartnerSandboxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventPartnerSandboxApiFp(configuration)
    return {
        /**
         * 
         * @summary [Staging] List the partner sandbox partners and their fixtures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxGet(options?: RawAxiosRequestConfig): AxiosPromise<PartnerSandboxOverviewResponse> {
            return localVarFp.adminPartnerSandboxGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Staging] Stop keeping a partner and its fixtures in the partner sandbox
         * @param {AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxPartnersPartnerIdDelete(requestParameters: AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminPartnerSandboxPartnersPartnerIdDelete(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Staging] Mark a partner as partner sandbox partner
         * @param {AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnerSandboxPartnersPartnerIdPut(requestParameters: AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerSandboxPartnerResponse> {
            return localVarFp.adminPartnerSandboxPartnersPartnerIdPut(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPartnerSandboxPartnersPartnerIdDelete operation in AdminEventPartnerSandboxApi.
 */
export interface AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdDeleteRequest {
    readonly partnerId: string
}

/**
 * Request parameters for adminPartnerSandboxPartnersPartnerIdPut operation in AdminEventPartnerSandboxApi.
 */
export interface AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdPutRequest {
    readonly partnerId: string
}

/**
 * AdminEventPartnerSandboxApi - object-oriented interface
 */
export class AdminEventPartnerSandboxApi extends BaseAPI {
    /**
     * 
     * @summary [Staging] List the partner sandbox partners and their fixtures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnerSandboxGet(options?: RawAxiosRequestConfig) {
        return AdminEventPartnerSandboxApiFp(this.configuration).adminPartnerSandboxGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Staging] Stop keeping a partner and its fixtures in the partner sandbox
     * @param {AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnerSandboxPartnersPartnerIdDelete(requestParameters: AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPartnerSandboxApiFp(this.configuration).adminPartnerSandboxPartnersPartnerIdDelete(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Staging] Mark a partner as partner sandbox partner
     * @param {AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminPartnerSandboxPartnersPartnerIdPut(requestParameters: AdminEventPartnerSandboxApiAdminPartnerSandboxPartnersPartnerIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPartnerSandboxApiFp(this.configuration).adminPartnerSandboxPartnersPartnerIdPut(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventPickupApi - axios parameter creator
 */
export const AdminEventPickupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {Array<string>} [shippingOfficeIds] 
         * @param {Array<EventStatus>} [eventStatuses] 
         * @param {Array<EventPickupStatus>} [eventPickupStatuses] 
         * @param {Date} [estimatedDeliveryDate] 
         * @param {SortEventPickupOn} [sortEventPickupOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventPickupsGet: async (searchTerm?: string, shippingOfficeIds?: Array<string>, eventStatuses?: Array<EventStatus>, eventPickupStatuses?: Array<EventPickupStatus>, estimatedDeliveryDate?: Date, sortEventPickupOn?: SortEventPickupOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/event-pickups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (shippingOfficeIds) {
                localVarQueryParameter['ShippingOfficeIds'] = shippingOfficeIds;
            }

            if (eventStatuses) {
                localVarQueryParameter['EventStatuses'] = eventStatuses;
            }

            if (eventPickupStatuses) {
                localVarQueryParameter['EventPickupStatuses'] = eventPickupStatuses;
            }

            if (estimatedDeliveryDate !== undefined) {
                localVarQueryParameter['EstimatedDeliveryDate'] = (estimatedDeliveryDate as any instanceof Date) ?
                    (estimatedDeliveryDate as any).toISOString() :
                    estimatedDeliveryDate;
            }

            if (sortEventPickupOn !== undefined) {
                localVarQueryParameter['SortEventPickupOn'] = sortEventPickupOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsGet: async (eventId: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/pickups`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdCancelPost: async (pickupId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickupId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdCancelPost', 'pickupId', pickupId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdCancelPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/pickups/{pickupId}/cancel`
                .replace('{pickupId}', encodeURIComponent(String(pickupId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdGet: async (pickupId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickupId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdGet', 'pickupId', pickupId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/pickups/{pickupId}`
                .replace('{pickupId}', encodeURIComponent(String(pickupId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {Date} [pickupStartTime] 
         * @param {Date} [pickupEndTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdReschedulePost: async (pickupId: string, eventId: string, pickupStartTime?: Date, pickupEndTime?: Date, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pickupId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdReschedulePost', 'pickupId', pickupId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPickupIdReschedulePost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/pickups/{pickupId}/reschedule`
                .replace('{pickupId}', encodeURIComponent(String(pickupId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pickupStartTime !== undefined) {
                localVarQueryParameter['pickupStartTime'] = (pickupStartTime as any instanceof Date) ?
                    (pickupStartTime as any).toISOString() :
                    pickupStartTime;
            }

            if (pickupEndTime !== undefined) {
                localVarQueryParameter['pickupEndTime'] = (pickupEndTime as any instanceof Date) ?
                    (pickupEndTime as any).toISOString() :
                    pickupEndTime;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {CreateEventPickupRequest} createEventPickupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPost: async (eventId: string, createEventPickupRequest: CreateEventPickupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPost', 'eventId', eventId)
            // verify required parameter 'createEventPickupRequest' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPost', 'createEventPickupRequest', createEventPickupRequest)
            const localVarPath = `/admin/events/{eventId}/pickups`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventPickupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPrefillDataGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPickupsPrefillDataGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/pickups/prefill-data`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventPickupApi - functional programming interface
 */
export const AdminEventPickupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventPickupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {Array<string>} [shippingOfficeIds] 
         * @param {Array<EventStatus>} [eventStatuses] 
         * @param {Array<EventPickupStatus>} [eventPickupStatuses] 
         * @param {Date} [estimatedDeliveryDate] 
         * @param {SortEventPickupOn} [sortEventPickupOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventPickupsGet(searchTerm?: string, shippingOfficeIds?: Array<string>, eventStatuses?: Array<EventStatus>, eventPickupStatuses?: Array<EventPickupStatus>, estimatedDeliveryDate?: Date, sortEventPickupOn?: SortEventPickupOn, sortDirection?: SortDirection, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminEventPickupsListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventPickupsGet(searchTerm, shippingOfficeIds, eventStatuses, eventPickupStatuses, estimatedDeliveryDate, sortEventPickupOn, sortDirection, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventPickupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsGet(eventId: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminEventPickupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsGet(eventId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsPickupIdCancelPost(pickupId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsPickupIdCancelPost(pickupId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsPickupIdCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsPickupIdGet(pickupId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEventPickupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsPickupIdGet(pickupId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsPickupIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pickupId 
         * @param {string} eventId 
         * @param {Date} [pickupStartTime] 
         * @param {Date} [pickupEndTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsPickupIdReschedulePost(pickupId: string, eventId: string, pickupStartTime?: Date, pickupEndTime?: Date, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsPickupIdReschedulePost(pickupId, eventId, pickupStartTime, pickupEndTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsPickupIdReschedulePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {CreateEventPickupRequest} createEventPickupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsPost(eventId: string, createEventPickupRequest: CreateEventPickupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsPost(eventId, createEventPickupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPickupsPrefillDataGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventPickupPrefillDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPickupsPrefillDataGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPickupApi.adminEventsEventIdPickupsPrefillDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventPickupApi - factory interface
 */
export const AdminEventPickupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventPickupApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminEventPickupApiAdminEventPickupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventPickupsGet(requestParameters: AdminEventPickupApiAdminEventPickupsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminEventPickupsListResponse> {
            return localVarFp.adminEventPickupsGet(requestParameters.searchTerm, requestParameters.shippingOfficeIds, requestParameters.eventStatuses, requestParameters.eventPickupStatuses, requestParameters.estimatedDeliveryDate, requestParameters.sortEventPickupOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminEventPickupResponse> {
            return localVarFp.adminEventsEventIdPickupsGet(requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdCancelPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdCancelPost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdCancelPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdPickupsPickupIdCancelPost(requestParameters.pickupId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEventPickupResponse> {
            return localVarFp.adminEventsEventIdPickupsPickupIdGet(requestParameters.pickupId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdReschedulePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPickupIdReschedulePost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdReschedulePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdPickupsPickupIdReschedulePost(requestParameters.pickupId, requestParameters.eventId, requestParameters.pickupStartTime, requestParameters.pickupEndTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdPickupsPost(requestParameters.eventId, requestParameters.createEventPickupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventPickupApiAdminEventsEventIdPickupsPrefillDataGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPickupsPrefillDataGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPrefillDataGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventPickupPrefillDataResponse> {
            return localVarFp.adminEventsEventIdPickupsPrefillDataGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventPickupsGet operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventPickupsGetRequest {
    readonly searchTerm?: string

    readonly shippingOfficeIds?: Array<string>

    readonly eventStatuses?: Array<EventStatus>

    readonly eventPickupStatuses?: Array<EventPickupStatus>

    readonly estimatedDeliveryDate?: Date

    readonly sortEventPickupOn?: SortEventPickupOn

    readonly sortDirection?: SortDirection

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminEventsEventIdPickupsGet operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsGetRequest {
    readonly eventId: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminEventsEventIdPickupsPickupIdCancelPost operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsPickupIdCancelPostRequest {
    readonly pickupId: string

    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdPickupsPickupIdGet operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsPickupIdGetRequest {
    readonly pickupId: string

    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdPickupsPickupIdReschedulePost operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsPickupIdReschedulePostRequest {
    readonly pickupId: string

    readonly eventId: string

    readonly pickupStartTime?: Date

    readonly pickupEndTime?: Date
}

/**
 * Request parameters for adminEventsEventIdPickupsPost operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsPostRequest {
    readonly eventId: string

    readonly createEventPickupRequest: CreateEventPickupRequest
}

/**
 * Request parameters for adminEventsEventIdPickupsPrefillDataGet operation in AdminEventPickupApi.
 */
export interface AdminEventPickupApiAdminEventsEventIdPickupsPrefillDataGetRequest {
    readonly eventId: string
}

/**
 * AdminEventPickupApi - object-oriented interface
 */
export class AdminEventPickupApi extends BaseAPI {
    /**
     * 
     * @param {AdminEventPickupApiAdminEventPickupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventPickupsGet(requestParameters: AdminEventPickupApiAdminEventPickupsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventPickupsGet(requestParameters.searchTerm, requestParameters.shippingOfficeIds, requestParameters.eventStatuses, requestParameters.eventPickupStatuses, requestParameters.estimatedDeliveryDate, requestParameters.sortEventPickupOn, requestParameters.sortDirection, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsGet(requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdCancelPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsPickupIdCancelPost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdCancelPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsPickupIdCancelPost(requestParameters.pickupId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsPickupIdGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsPickupIdGet(requestParameters.pickupId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsPickupIdReschedulePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsPickupIdReschedulePost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPickupIdReschedulePostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsPickupIdReschedulePost(requestParameters.pickupId, requestParameters.eventId, requestParameters.pickupStartTime, requestParameters.pickupEndTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsPost(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsPost(requestParameters.eventId, requestParameters.createEventPickupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventPickupApiAdminEventsEventIdPickupsPrefillDataGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPickupsPrefillDataGet(requestParameters: AdminEventPickupApiAdminEventsEventIdPickupsPrefillDataGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPickupApiFp(this.configuration).adminEventsEventIdPickupsPrefillDataGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventProductSettingsApi - axios parameter creator
 */
export const AdminEventProductSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {UpdateEventProductSettingsRequest} updateEventProductSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductSettingsPut: async (eventId: string, updateEventProductSettingsRequest: UpdateEventProductSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdProductSettingsPut', 'eventId', eventId)
            // verify required parameter 'updateEventProductSettingsRequest' is not null or undefined
            assertParamExists('adminEventsEventIdProductSettingsPut', 'updateEventProductSettingsRequest', updateEventProductSettingsRequest)
            const localVarPath = `/admin/events/{eventId}/product-settings`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventProductSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventProductSettingsApi - functional programming interface
 */
export const AdminEventProductSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventProductSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {UpdateEventProductSettingsRequest} updateEventProductSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdProductSettingsPut(eventId: string, updateEventProductSettingsRequest: UpdateEventProductSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdProductSettingsPut(eventId, updateEventProductSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventProductSettingsApi.adminEventsEventIdProductSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventProductSettingsApi - factory interface
 */
export const AdminEventProductSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventProductSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Set the marketing angle of an event
         * @param {AdminEventProductSettingsApiAdminEventsEventIdProductSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductSettingsPut(requestParameters: AdminEventProductSettingsApiAdminEventsEventIdProductSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdProductSettingsPut(requestParameters.eventId, requestParameters.updateEventProductSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdProductSettingsPut operation in AdminEventProductSettingsApi.
 */
export interface AdminEventProductSettingsApiAdminEventsEventIdProductSettingsPutRequest {
    /**
     * The id of the event that should be marked as additional
     */
    readonly eventId: string

    /**
     * 
     */
    readonly updateEventProductSettingsRequest: UpdateEventProductSettingsRequest
}

/**
 * AdminEventProductSettingsApi - object-oriented interface
 */
export class AdminEventProductSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Set the marketing angle of an event
     * @param {AdminEventProductSettingsApiAdminEventsEventIdProductSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdProductSettingsPut(requestParameters: AdminEventProductSettingsApiAdminEventsEventIdProductSettingsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventProductSettingsApiFp(this.configuration).adminEventsEventIdProductSettingsPut(requestParameters.eventId, requestParameters.updateEventProductSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventPublicationsApi - axios parameter creator
 */
export const AdminEventPublicationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateEventPublicationsRequest} updateEventPublicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPublicationsPut: async (eventId: string, xPlatformKey: string, updateEventPublicationsRequest: UpdateEventPublicationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPublicationsPut', 'eventId', eventId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminEventsEventIdPublicationsPut', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'updateEventPublicationsRequest' is not null or undefined
            assertParamExists('adminEventsEventIdPublicationsPut', 'updateEventPublicationsRequest', updateEventPublicationsRequest)
            const localVarPath = `/admin/events/{eventId}/publications`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventPublicationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventPublicationsApi - functional programming interface
 */
export const AdminEventPublicationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventPublicationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {string} eventId The id of the event that should be marked as additional
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateEventPublicationsRequest} updateEventPublicationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPublicationsPut(eventId: string, xPlatformKey: string, updateEventPublicationsRequest: UpdateEventPublicationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPublicationsPut(eventId, xPlatformKey, updateEventPublicationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventPublicationsApi.adminEventsEventIdPublicationsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventPublicationsApi - factory interface
 */
export const AdminEventPublicationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventPublicationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Toggle whether an event is additional
         * @param {AdminEventPublicationsApiAdminEventsEventIdPublicationsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPublicationsPut(requestParameters: AdminEventPublicationsApiAdminEventsEventIdPublicationsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdPublicationsPut(requestParameters.eventId, requestParameters.xPlatformKey, requestParameters.updateEventPublicationsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdPublicationsPut operation in AdminEventPublicationsApi.
 */
export interface AdminEventPublicationsApiAdminEventsEventIdPublicationsPutRequest {
    /**
     * The id of the event that should be marked as additional
     */
    readonly eventId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * 
     */
    readonly updateEventPublicationsRequest: UpdateEventPublicationsRequest
}

/**
 * AdminEventPublicationsApi - object-oriented interface
 */
export class AdminEventPublicationsApi extends BaseAPI {
    /**
     * 
     * @summary Toggle whether an event is additional
     * @param {AdminEventPublicationsApiAdminEventsEventIdPublicationsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPublicationsPut(requestParameters: AdminEventPublicationsApiAdminEventsEventIdPublicationsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventPublicationsApiFp(this.configuration).adminEventsEventIdPublicationsPut(requestParameters.eventId, requestParameters.xPlatformKey, requestParameters.updateEventPublicationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventScheduleContractsApi - axios parameter creator
 */
export const AdminEventScheduleContractsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an event schedule contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsContractIdDelete: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminEventScheduleContractsContractIdDelete', 'contractId', contractId)
            const localVarPath = `/admin/event-schedule-contracts/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all event schedule contracts for a finance contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsFinanceContractContractIdGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminEventScheduleContractsFinanceContractContractIdGet', 'contractId', contractId)
            const localVarPath = `/admin/event-schedule-contracts/finance-contract/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an event schedule contracts by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsIdGet: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminEventScheduleContractsIdGet', 'id', id)
            const localVarPath = `/admin/event-schedule-contracts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an event schedule contract
         * @param {string} id 
         * @param {UpdateEventScheduleContractRequest} updateEventScheduleContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsIdPut: async (id: string, updateEventScheduleContractRequest: UpdateEventScheduleContractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminEventScheduleContractsIdPut', 'id', id)
            // verify required parameter 'updateEventScheduleContractRequest' is not null or undefined
            assertParamExists('adminEventScheduleContractsIdPut', 'updateEventScheduleContractRequest', updateEventScheduleContractRequest)
            const localVarPath = `/admin/event-schedule-contracts/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventScheduleContractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an event schedule contract
         * @param {CreateEventScheduleContractRequest} createEventScheduleContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsPost: async (createEventScheduleContractRequest: CreateEventScheduleContractRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEventScheduleContractRequest' is not null or undefined
            assertParamExists('adminEventScheduleContractsPost', 'createEventScheduleContractRequest', createEventScheduleContractRequest)
            const localVarPath = `/admin/event-schedule-contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventScheduleContractRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventScheduleContractsApi - functional programming interface
 */
export const AdminEventScheduleContractsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventScheduleContractsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an event schedule contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventScheduleContractsContractIdDelete(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventScheduleContractsContractIdDelete(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventScheduleContractsApi.adminEventScheduleContractsContractIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all event schedule contracts for a finance contract
         * @param {string} contractId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventScheduleContractsFinanceContractContractIdGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventScheduleContractResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventScheduleContractsFinanceContractContractIdGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventScheduleContractsApi.adminEventScheduleContractsFinanceContractContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get an event schedule contracts by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventScheduleContractsIdGet(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventScheduleContractResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventScheduleContractsIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventScheduleContractsApi.adminEventScheduleContractsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an event schedule contract
         * @param {string} id 
         * @param {UpdateEventScheduleContractRequest} updateEventScheduleContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventScheduleContractsIdPut(id: string, updateEventScheduleContractRequest: UpdateEventScheduleContractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventScheduleContractsIdPut(id, updateEventScheduleContractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventScheduleContractsApi.adminEventScheduleContractsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an event schedule contract
         * @param {CreateEventScheduleContractRequest} createEventScheduleContractRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventScheduleContractsPost(createEventScheduleContractRequest: CreateEventScheduleContractRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventScheduleContractsPost(createEventScheduleContractRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventScheduleContractsApi.adminEventScheduleContractsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventScheduleContractsApi - factory interface
 */
export const AdminEventScheduleContractsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventScheduleContractsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an event schedule contract
         * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsContractIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsContractIdDelete(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsContractIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventScheduleContractsContractIdDelete(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all event schedule contracts for a finance contract
         * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsFinanceContractContractIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsFinanceContractContractIdGet(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsFinanceContractContractIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventScheduleContractResponse>> {
            return localVarFp.adminEventScheduleContractsFinanceContractContractIdGet(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an event schedule contracts by id
         * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsIdGet(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventScheduleContractResponse> {
            return localVarFp.adminEventScheduleContractsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an event schedule contract
         * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsIdPut(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventScheduleContractsIdPut(requestParameters.id, requestParameters.updateEventScheduleContractRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an event schedule contract
         * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventScheduleContractsPost(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventScheduleContractsPost(requestParameters.createEventScheduleContractRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventScheduleContractsContractIdDelete operation in AdminEventScheduleContractsApi.
 */
export interface AdminEventScheduleContractsApiAdminEventScheduleContractsContractIdDeleteRequest {
    readonly contractId: string
}

/**
 * Request parameters for adminEventScheduleContractsFinanceContractContractIdGet operation in AdminEventScheduleContractsApi.
 */
export interface AdminEventScheduleContractsApiAdminEventScheduleContractsFinanceContractContractIdGetRequest {
    readonly contractId: string
}

/**
 * Request parameters for adminEventScheduleContractsIdGet operation in AdminEventScheduleContractsApi.
 */
export interface AdminEventScheduleContractsApiAdminEventScheduleContractsIdGetRequest {
    readonly id: string
}

/**
 * Request parameters for adminEventScheduleContractsIdPut operation in AdminEventScheduleContractsApi.
 */
export interface AdminEventScheduleContractsApiAdminEventScheduleContractsIdPutRequest {
    readonly id: string

    readonly updateEventScheduleContractRequest: UpdateEventScheduleContractRequest
}

/**
 * Request parameters for adminEventScheduleContractsPost operation in AdminEventScheduleContractsApi.
 */
export interface AdminEventScheduleContractsApiAdminEventScheduleContractsPostRequest {
    readonly createEventScheduleContractRequest: CreateEventScheduleContractRequest
}

/**
 * AdminEventScheduleContractsApi - object-oriented interface
 */
export class AdminEventScheduleContractsApi extends BaseAPI {
    /**
     * 
     * @summary Delete an event schedule contract
     * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsContractIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventScheduleContractsContractIdDelete(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsContractIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminEventScheduleContractsApiFp(this.configuration).adminEventScheduleContractsContractIdDelete(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all event schedule contracts for a finance contract
     * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsFinanceContractContractIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventScheduleContractsFinanceContractContractIdGet(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsFinanceContractContractIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventScheduleContractsApiFp(this.configuration).adminEventScheduleContractsFinanceContractContractIdGet(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an event schedule contracts by id
     * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventScheduleContractsIdGet(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventScheduleContractsApiFp(this.configuration).adminEventScheduleContractsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an event schedule contract
     * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventScheduleContractsIdPut(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventScheduleContractsApiFp(this.configuration).adminEventScheduleContractsIdPut(requestParameters.id, requestParameters.updateEventScheduleContractRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an event schedule contract
     * @param {AdminEventScheduleContractsApiAdminEventScheduleContractsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventScheduleContractsPost(requestParameters: AdminEventScheduleContractsApiAdminEventScheduleContractsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventScheduleContractsApiFp(this.configuration).adminEventScheduleContractsPost(requestParameters.createEventScheduleContractRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventYieldPredictionApi - axios parameter creator
 */
export const AdminEventYieldPredictionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calls the ML model to predict event yield based on the two teams
         * @param {string} [featuredTeamId] Guid of the featured team
         * @param {string} [participatingTeamId] Guid of the participating team
         * @param {string} [featuredTeamExternalId] SportMonks Id for the featured team
         * @param {string} [participatingTeamExternalId] SportMonks Id for the participating team
         * @param {number} [numberOfProducts] The amount of products in the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventYieldPredictionGet: async (featuredTeamId?: string, participatingTeamId?: string, featuredTeamExternalId?: string, participatingTeamExternalId?: string, numberOfProducts?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/event-yield-prediction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (featuredTeamId !== undefined) {
                localVarQueryParameter['featuredTeamId'] = featuredTeamId;
            }

            if (participatingTeamId !== undefined) {
                localVarQueryParameter['participatingTeamId'] = participatingTeamId;
            }

            if (featuredTeamExternalId !== undefined) {
                localVarQueryParameter['featuredTeamExternalId'] = featuredTeamExternalId;
            }

            if (participatingTeamExternalId !== undefined) {
                localVarQueryParameter['participatingTeamExternalId'] = participatingTeamExternalId;
            }

            if (numberOfProducts !== undefined) {
                localVarQueryParameter['numberOfProducts'] = numberOfProducts;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the predicted yield for an event
         * @param {UpdateEventPredictedYieldRequest} updateEventPredictedYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventYieldPredictionPut: async (updateEventPredictedYieldRequest: UpdateEventPredictedYieldRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateEventPredictedYieldRequest' is not null or undefined
            assertParamExists('adminEventYieldPredictionPut', 'updateEventPredictedYieldRequest', updateEventPredictedYieldRequest)
            const localVarPath = `/admin/event-yield-prediction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventPredictedYieldRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventYieldPredictionApi - functional programming interface
 */
export const AdminEventYieldPredictionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventYieldPredictionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calls the ML model to predict event yield based on the two teams
         * @param {string} [featuredTeamId] Guid of the featured team
         * @param {string} [participatingTeamId] Guid of the participating team
         * @param {string} [featuredTeamExternalId] SportMonks Id for the featured team
         * @param {string} [participatingTeamExternalId] SportMonks Id for the participating team
         * @param {number} [numberOfProducts] The amount of products in the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventYieldPredictionGet(featuredTeamId?: string, participatingTeamId?: string, featuredTeamExternalId?: string, participatingTeamExternalId?: string, numberOfProducts?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventYieldPredictionGet(featuredTeamId, participatingTeamId, featuredTeamExternalId, participatingTeamExternalId, numberOfProducts, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventYieldPredictionApi.adminEventYieldPredictionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the predicted yield for an event
         * @param {UpdateEventPredictedYieldRequest} updateEventPredictedYieldRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventYieldPredictionPut(updateEventPredictedYieldRequest: UpdateEventPredictedYieldRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventYieldPredictionPut(updateEventPredictedYieldRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventYieldPredictionApi.adminEventYieldPredictionPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventYieldPredictionApi - factory interface
 */
export const AdminEventYieldPredictionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventYieldPredictionApiFp(configuration)
    return {
        /**
         * 
         * @summary Calls the ML model to predict event yield based on the two teams
         * @param {AdminEventYieldPredictionApiAdminEventYieldPredictionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventYieldPredictionGet(requestParameters: AdminEventYieldPredictionApiAdminEventYieldPredictionGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.adminEventYieldPredictionGet(requestParameters.featuredTeamId, requestParameters.participatingTeamId, requestParameters.featuredTeamExternalId, requestParameters.participatingTeamExternalId, requestParameters.numberOfProducts, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the predicted yield for an event
         * @param {AdminEventYieldPredictionApiAdminEventYieldPredictionPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventYieldPredictionPut(requestParameters: AdminEventYieldPredictionApiAdminEventYieldPredictionPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventYieldPredictionPut(requestParameters.updateEventPredictedYieldRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventYieldPredictionGet operation in AdminEventYieldPredictionApi.
 */
export interface AdminEventYieldPredictionApiAdminEventYieldPredictionGetRequest {
    /**
     * Guid of the featured team
     */
    readonly featuredTeamId?: string

    /**
     * Guid of the participating team
     */
    readonly participatingTeamId?: string

    /**
     * SportMonks Id for the featured team
     */
    readonly featuredTeamExternalId?: string

    /**
     * SportMonks Id for the participating team
     */
    readonly participatingTeamExternalId?: string

    /**
     * The amount of products in the event
     */
    readonly numberOfProducts?: number
}

/**
 * Request parameters for adminEventYieldPredictionPut operation in AdminEventYieldPredictionApi.
 */
export interface AdminEventYieldPredictionApiAdminEventYieldPredictionPutRequest {
    /**
     * 
     */
    readonly updateEventPredictedYieldRequest: UpdateEventPredictedYieldRequest
}

/**
 * AdminEventYieldPredictionApi - object-oriented interface
 */
export class AdminEventYieldPredictionApi extends BaseAPI {
    /**
     * 
     * @summary Calls the ML model to predict event yield based on the two teams
     * @param {AdminEventYieldPredictionApiAdminEventYieldPredictionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventYieldPredictionGet(requestParameters: AdminEventYieldPredictionApiAdminEventYieldPredictionGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventYieldPredictionApiFp(this.configuration).adminEventYieldPredictionGet(requestParameters.featuredTeamId, requestParameters.participatingTeamId, requestParameters.featuredTeamExternalId, requestParameters.participatingTeamExternalId, requestParameters.numberOfProducts, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the predicted yield for an event
     * @param {AdminEventYieldPredictionApiAdminEventYieldPredictionPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventYieldPredictionPut(requestParameters: AdminEventYieldPredictionApiAdminEventYieldPredictionPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventYieldPredictionApiFp(this.configuration).adminEventYieldPredictionPut(requestParameters.updateEventPredictedYieldRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventsApi - axios parameter creator
 */
export const AdminEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all events in a time period, used for the month view in the admin portal
         * @param {Date} [startsAfter] 
         * @param {Date} [startsBefore] 
         * @param {Date} [endsAfter] 
         * @param {Date} [endsBefore] 
         * @param {Array<EventStatus>} [statuses] 
         * @param {boolean} [hasHighlightedMarketingAngle] 
         * @param {boolean} [hasMarketingAngle] 
         * @param {string} [categoryId] 
         * @param {string} [searchTerm] 
         * @param {string} [managerUserId] 
         * @param {PartnerRegion} [partnerRegion] 
         * @param {number | null} [teamTier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsCalendarGet: async (startsAfter?: Date, startsBefore?: Date, endsAfter?: Date, endsBefore?: Date, statuses?: Array<EventStatus>, hasHighlightedMarketingAngle?: boolean, hasMarketingAngle?: boolean, categoryId?: string, searchTerm?: string, managerUserId?: string, partnerRegion?: PartnerRegion, teamTier?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/events/calendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startsAfter !== undefined) {
                localVarQueryParameter['startsAfter'] = (startsAfter as any instanceof Date) ?
                    (startsAfter as any).toISOString() :
                    startsAfter;
            }

            if (startsBefore !== undefined) {
                localVarQueryParameter['startsBefore'] = (startsBefore as any instanceof Date) ?
                    (startsBefore as any).toISOString() :
                    startsBefore;
            }

            if (endsAfter !== undefined) {
                localVarQueryParameter['endsAfter'] = (endsAfter as any instanceof Date) ?
                    (endsAfter as any).toISOString() :
                    endsAfter;
            }

            if (endsBefore !== undefined) {
                localVarQueryParameter['endsBefore'] = (endsBefore as any instanceof Date) ?
                    (endsBefore as any).toISOString() :
                    endsBefore;
            }

            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (hasHighlightedMarketingAngle !== undefined) {
                localVarQueryParameter['hasHighlightedMarketingAngle'] = hasHighlightedMarketingAngle;
            }

            if (hasMarketingAngle !== undefined) {
                localVarQueryParameter['hasMarketingAngle'] = hasMarketingAngle;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (managerUserId !== undefined) {
                localVarQueryParameter['managerUserId'] = managerUserId;
            }

            if (partnerRegion !== undefined) {
                localVarQueryParameter['partnerRegion'] = partnerRegion;
            }

            if (teamTier !== undefined) {
                localVarQueryParameter['teamTier'] = teamTier;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the events with this contract
         * @param {string} contractId 
         * @param {string} [eventStatus] 
         * @param {Array<string>} [eventSettingsIds] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {SortEventOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsContractContractIdGet: async (contractId: string, eventStatus?: string, eventSettingsIds?: Array<string>, offSet?: number, pageSize?: number, sortOn?: SortEventOn, sortDirection?: SortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminEventsContractContractIdGet', 'contractId', contractId)
            const localVarPath = `/admin/events/contract/{contractId}`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventStatus !== undefined) {
                localVarQueryParameter['eventStatus'] = eventStatus;
            }

            if (eventSettingsIds) {
                localVarQueryParameter['eventSettingsIds'] = eventSettingsIds;
            }

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortOn !== undefined) {
                localVarQueryParameter['sortOn'] = sortOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] update the beneficiary on all collections of an event
         * @param {string} eventId 
         * @param {SetEventBeneficiaryRequest} setEventBeneficiaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdBeneficiaryPatch: async (eventId: string, setEventBeneficiaryRequest: SetEventBeneficiaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdBeneficiaryPatch', 'eventId', eventId)
            // verify required parameter 'setEventBeneficiaryRequest' is not null or undefined
            assertParamExists('adminEventsEventIdBeneficiaryPatch', 'setEventBeneficiaryRequest', setEventBeneficiaryRequest)
            const localVarPath = `/admin/events/{eventId}/beneficiary`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setEventBeneficiaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the contract of an event
         * @param {string} eventId 
         * @param {UpdateEventContractRequestDto} updateEventContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdContractsPatch: async (eventId: string, updateEventContractRequestDto: UpdateEventContractRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdContractsPatch', 'eventId', eventId)
            // verify required parameter 'updateEventContractRequestDto' is not null or undefined
            assertParamExists('adminEventsEventIdContractsPatch', 'updateEventContractRequestDto', updateEventContractRequestDto)
            const localVarPath = `/admin/events/{eventId}/contracts`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventContractRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a default product mockup image to an event
         * @param {string} eventId The id of the event
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdDefaultProductImagePost: async (eventId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdDefaultProductImagePost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/default-product-image`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (file !== undefined) { 
                localVarFormParams.set('File', file as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export all bids of an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExportBidsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdExportBidsGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/export-bids`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The Event will be exported to the platform provided
         * @param {string} eventId 
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExportToPlatformPlatformIdPost: async (eventId: string, platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdExportToPlatformPlatformIdPost', 'eventId', eventId)
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('adminEventsEventIdExportToPlatformPlatformIdPost', 'platformId', platformId)
            const localVarPath = `/admin/events/{eventId}/export-to-platform/{platformId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)))
                .replace('{platformId}', encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Extend the event with a reason
         * @param {string} eventId The id of the event
         * @param {ExtendEventRequest} extendEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExtendPatch: async (eventId: string, extendEventRequest: ExtendEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdExtendPatch', 'eventId', eventId)
            // verify required parameter 'extendEventRequest' is not null or undefined
            assertParamExists('adminEventsEventIdExtendPatch', 'extendEventRequest', extendEventRequest)
            const localVarPath = `/admin/events/{eventId}/extend`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get event
         * @param {string} eventId The id of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdGet: async (eventId: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdGet', 'eventId', eventId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminEventsEventIdGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide or show the partner on the event\'s product pages.
         * @param {string} eventId The event to update
         * @param {UpdateEventHidePartnerRequest} updateEventHidePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdHidePartnerPatch: async (eventId: string, updateEventHidePartnerRequest: UpdateEventHidePartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdHidePartnerPatch', 'eventId', eventId)
            // verify required parameter 'updateEventHidePartnerRequest' is not null or undefined
            assertParamExists('adminEventsEventIdHidePartnerPatch', 'updateEventHidePartnerRequest', updateEventHidePartnerRequest)
            const localVarPath = `/admin/events/{eventId}/hide-partner`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventHidePartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates both event and project in Odoo
         * @param {string} eventId The id of the event to sync
         * @param {boolean} [createEventInOdoo] 
         * @param {boolean} [createProjectInOdoo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooPost: async (eventId: string, createEventInOdoo?: boolean, createProjectInOdoo?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdOdooPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/odoo`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (createEventInOdoo !== undefined) {
                localVarQueryParameter['CreateEventInOdoo'] = createEventInOdoo;
            }

            if (createProjectInOdoo !== undefined) {
                localVarQueryParameter['CreateProjectInOdoo'] = createProjectInOdoo;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update both event and project in Odoo
         * @param {string} eventId The id of the event to sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooPut: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdOdooPut', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/odoo`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Odoo inbound project task for event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooTasksPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdOdooTasksPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/odoo/tasks`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get  paginated products under an event
         * @param {string} eventId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {SortProductListingOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [isSetup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPaginatedProductsGet: async (eventId: string, offset?: number, pageSize?: number, sortOn?: SortProductListingOn, sortDirection?: SortDirection, isSetup?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPaginatedProductsGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/paginated/products`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortOn !== undefined) {
                localVarQueryParameter['sortOn'] = sortOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (isSetup !== undefined) {
                localVarQueryParameter['isSetup'] = isSetup;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Event Finance Manager
         * @param {string} eventId The event to update
         * @param {UpdateEventPartnerManagerRequest} updateEventPartnerManagerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPartnerManagerPatch: async (eventId: string, updateEventPartnerManagerRequest: UpdateEventPartnerManagerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPartnerManagerPatch', 'eventId', eventId)
            // verify required parameter 'updateEventPartnerManagerRequest' is not null or undefined
            assertParamExists('adminEventsEventIdPartnerManagerPatch', 'updateEventPartnerManagerRequest', updateEventPartnerManagerRequest)
            const localVarPath = `/admin/events/{eventId}/partner-manager`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventPartnerManagerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update basic event properties
         * @param {string} eventId The id of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateEventRequestDto} updateEventRequestDto The request object with updated event information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPatch: async (eventId: string, xPlatformKey: string, updateEventRequestDto: UpdateEventRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPatch', 'eventId', eventId)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminEventsEventIdPatch', 'xPlatformKey', xPlatformKey)
            // verify required parameter 'updateEventRequestDto' is not null or undefined
            assertParamExists('adminEventsEventIdPatch', 'updateEventRequestDto', updateEventRequestDto)
            const localVarPath = `/admin/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsCreateFromLineupPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdProductsCreateFromLineupPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/products/create-from-lineup`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get products under an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdProductsGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/products`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update product media so that it matches the configured kit.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsMediaKitPatch: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdProductsMediaKitPatch', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/products/media/kit`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] create a product for an event
         * @param {string} eventId 
         * @param {CreateProductForEventRequest} createProductForEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsPost: async (eventId: string, createProductForEventRequest: CreateProductForEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdProductsPost', 'eventId', eventId)
            // verify required parameter 'createProductForEventRequest' is not null or undefined
            assertParamExists('adminEventsEventIdProductsPost', 'createProductForEventRequest', createProductForEventRequest)
            const localVarPath = `/admin/events/{eventId}/products`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductForEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * publishing an event means settings its event status to \'PUBLISHED\'. If an event has event status \'PUBLISHED\' it will be included in the \'/events\' endpoint response.
         * @summary Publish an event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPublishPatch: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdPublishPatch', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/publish`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Relist multiple products through their IDs in one event using a CSV
         * @param {string} eventId The id of the event
         * @param {File} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdRelistProductsPost: async (eventId: string, csvFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdRelistProductsPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/relist-products`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (csvFile !== undefined) { 
                localVarFormParams.append('csvFile', csvFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an event status
         * @param {string} eventId The id of the event
         * @param {UpdateEventStatusRequest} updateEventStatusRequest A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdStatusPut: async (eventId: string, updateEventStatusRequest: UpdateEventStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdStatusPut', 'eventId', eventId)
            // verify required parameter 'updateEventStatusRequest' is not null or undefined
            assertParamExists('adminEventsEventIdStatusPut', 'updateEventStatusRequest', updateEventStatusRequest)
            const localVarPath = `/admin/events/{eventId}/status`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] will toggle all the products mockup, and image medias active/inactive so all the mockup, image media\'s visibility property for this event will be flipped
         * @param {string} eventId the event to flip all of its media
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdToggleMediaPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdToggleMediaPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/toggle/media`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unpublishing an event means flipping its event status to \'UNPUBLISHED\' If an event has event status \'UNPUBLISHED\' it will be no longer be included in the \'/events\' endpoint response.
         * @summary Unpublish an event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdUnpublishPatch: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdUnpublishPatch', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/unpublish`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The events will be exported to the platform provided
         * @param {ExportEventsToNewPlatformsRequest} exportEventsToNewPlatformsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsExportToPlatformsPost: async (exportEventsToNewPlatformsRequest: ExportEventsToNewPlatformsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportEventsToNewPlatformsRequest' is not null or undefined
            assertParamExists('adminEventsExportToPlatformsPost', 'exportEventsToNewPlatformsRequest', exportEventsToNewPlatformsRequest)
            const localVarPath = `/admin/events/export-to-platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportEventsToNewPlatformsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Flexible list events
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<string>} [statuses] Status filter to be applied
         * @param {string} [searchTerm] The search term for searching
         * @param {Date} [startbefore] The datetime for events to start before
         * @param {Date} [startafter] The datetime for events to start after
         * @param {Date} [endbefore] The datetime for events to end before
         * @param {Date} [endafter] The datetime for events to end after
         * @param {string} [sortColumn] The column to sort by. Can be startDate or endDate
         * @param {string} [sortDirection] Sort property. Can be \&#39;asc\&#39; for ascending and \&#39;desc\&#39; for descending
         * @param {string} [categoryId] The category id you want to retrieve events of
         * @param {string} [categoryIds] The category ids you want to retrieve intersection events of
         * @param {boolean} [hasHighlightedMarketingAngle] 
         * @param {boolean} [hasMarketingAngle] 
         * @param {string} [managerUserId] 
         * @param {PartnerRegion} [partnerRegion] 
         * @param {number | null} [teamTier] 
         * @param {string} [contractId] 
         * @param {string} [partnerId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsGet: async (xPlatformKey: string, statuses?: Array<string>, searchTerm?: string, startbefore?: Date, startafter?: Date, endbefore?: Date, endafter?: Date, sortColumn?: string, sortDirection?: string, categoryId?: string, categoryIds?: string, hasHighlightedMarketingAngle?: boolean, hasMarketingAngle?: boolean, managerUserId?: string, partnerRegion?: PartnerRegion, teamTier?: number | null, contractId?: string, partnerId?: string, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminEventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statuses) {
                localVarQueryParameter['Statuses'] = statuses;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (startbefore !== undefined) {
                localVarQueryParameter['Startbefore'] = (startbefore as any instanceof Date) ?
                    (startbefore as any).toISOString() :
                    startbefore;
            }

            if (startafter !== undefined) {
                localVarQueryParameter['Startafter'] = (startafter as any instanceof Date) ?
                    (startafter as any).toISOString() :
                    startafter;
            }

            if (endbefore !== undefined) {
                localVarQueryParameter['Endbefore'] = (endbefore as any instanceof Date) ?
                    (endbefore as any).toISOString() :
                    endbefore;
            }

            if (endafter !== undefined) {
                localVarQueryParameter['Endafter'] = (endafter as any instanceof Date) ?
                    (endafter as any).toISOString() :
                    endafter;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['SortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['CategoryIds'] = categoryIds;
            }

            if (hasHighlightedMarketingAngle !== undefined) {
                localVarQueryParameter['HasHighlightedMarketingAngle'] = hasHighlightedMarketingAngle;
            }

            if (hasMarketingAngle !== undefined) {
                localVarQueryParameter['HasMarketingAngle'] = hasMarketingAngle;
            }

            if (managerUserId !== undefined) {
                localVarQueryParameter['ManagerUserId'] = managerUserId;
            }

            if (partnerRegion !== undefined) {
                localVarQueryParameter['PartnerRegion'] = partnerRegion;
            }

            if (teamTier !== undefined) {
                localVarQueryParameter['TeamTier'] = teamTier;
            }

            if (contractId !== undefined) {
                localVarQueryParameter['ContractId'] = contractId;
            }

            if (partnerId !== undefined) {
                localVarQueryParameter['PartnerId'] = partnerId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get multiple events by Id
         * @param {string} [eventIds] The ids of the events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsMultipleGet: async (eventIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/events/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventIds !== undefined) {
                localVarQueryParameter['eventIds'] = eventIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CreateEventRequest>} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsMultiplePost: async (createEventRequest: Array<CreateEventRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEventRequest' is not null or undefined
            assertParamExists('adminEventsMultiplePost', 'createEventRequest', createEventRequest)
            const localVarPath = `/admin/events/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update events
         * @param {BulkUpdateEventsRequest} bulkUpdateEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsPatch: async (bulkUpdateEventsRequest: BulkUpdateEventsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateEventsRequest' is not null or undefined
            assertParamExists('adminEventsPatch', 'bulkUpdateEventsRequest', bulkUpdateEventsRequest)
            const localVarPath = `/admin/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateEventsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary New unified endpoint for creating an event. This endpoint will replace the old 2 endpoints for creating events
         * @param {CreateEventRequest} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsPost: async (createEventRequest: CreateEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEventRequest' is not null or undefined
            assertParamExists('adminEventsPost', 'createEventRequest', createEventRequest)
            const localVarPath = `/admin/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search events for a given term.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {string} [searchTerm] Search query to be applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsSearchGet: async (xPlatformKey: string, offSet?: number, pageSize?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminEventsSearchGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventsApi - functional programming interface
 */
export const AdminEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all events in a time period, used for the month view in the admin portal
         * @param {Date} [startsAfter] 
         * @param {Date} [startsBefore] 
         * @param {Date} [endsAfter] 
         * @param {Date} [endsBefore] 
         * @param {Array<EventStatus>} [statuses] 
         * @param {boolean} [hasHighlightedMarketingAngle] 
         * @param {boolean} [hasMarketingAngle] 
         * @param {string} [categoryId] 
         * @param {string} [searchTerm] 
         * @param {string} [managerUserId] 
         * @param {PartnerRegion} [partnerRegion] 
         * @param {number | null} [teamTier] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsCalendarGet(startsAfter?: Date, startsBefore?: Date, endsAfter?: Date, endsBefore?: Date, statuses?: Array<EventStatus>, hasHighlightedMarketingAngle?: boolean, hasMarketingAngle?: boolean, categoryId?: string, searchTerm?: string, managerUserId?: string, partnerRegion?: PartnerRegion, teamTier?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsCalendarGet(startsAfter, startsBefore, endsAfter, endsBefore, statuses, hasHighlightedMarketingAngle, hasMarketingAngle, categoryId, searchTerm, managerUserId, partnerRegion, teamTier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsCalendarGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the events with this contract
         * @param {string} contractId 
         * @param {string} [eventStatus] 
         * @param {Array<string>} [eventSettingsIds] 
         * @param {number} [offSet] 
         * @param {number} [pageSize] 
         * @param {SortEventOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsContractContractIdGet(contractId: string, eventStatus?: string, eventSettingsIds?: Array<string>, offSet?: number, pageSize?: number, sortOn?: SortEventOn, sortDirection?: SortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsContractContractIdGet(contractId, eventStatus, eventSettingsIds, offSet, pageSize, sortOn, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsContractContractIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] update the beneficiary on all collections of an event
         * @param {string} eventId 
         * @param {SetEventBeneficiaryRequest} setEventBeneficiaryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdBeneficiaryPatch(eventId: string, setEventBeneficiaryRequest: SetEventBeneficiaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdBeneficiaryPatch(eventId, setEventBeneficiaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdBeneficiaryPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the contract of an event
         * @param {string} eventId 
         * @param {UpdateEventContractRequestDto} updateEventContractRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdContractsPatch(eventId: string, updateEventContractRequestDto: UpdateEventContractRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdContractsPatch(eventId, updateEventContractRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdContractsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add a default product mockup image to an event
         * @param {string} eventId The id of the event
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdDefaultProductImagePost(eventId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdDefaultProductImagePost(eventId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdDefaultProductImagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export all bids of an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdExportBidsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdExportBidsGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdExportBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The Event will be exported to the platform provided
         * @param {string} eventId 
         * @param {string} platformId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdExportToPlatformPlatformIdPost(eventId: string, platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdExportToPlatformPlatformIdPost(eventId, platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdExportToPlatformPlatformIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Extend the event with a reason
         * @param {string} eventId The id of the event
         * @param {ExtendEventRequest} extendEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdExtendPatch(eventId: string, extendEventRequest: ExtendEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdExtendPatch(eventId, extendEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdExtendPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get event
         * @param {string} eventId The id of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdGet(eventId: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdGet(eventId, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide or show the partner on the event\'s product pages.
         * @param {string} eventId The event to update
         * @param {UpdateEventHidePartnerRequest} updateEventHidePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdHidePartnerPatch(eventId: string, updateEventHidePartnerRequest: UpdateEventHidePartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdHidePartnerPatch(eventId, updateEventHidePartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdHidePartnerPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates both event and project in Odoo
         * @param {string} eventId The id of the event to sync
         * @param {boolean} [createEventInOdoo] 
         * @param {boolean} [createProjectInOdoo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdOdooPost(eventId: string, createEventInOdoo?: boolean, createProjectInOdoo?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdOdooPost(eventId, createEventInOdoo, createProjectInOdoo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdOdooPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update both event and project in Odoo
         * @param {string} eventId The id of the event to sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdOdooPut(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdOdooPut(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdOdooPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Odoo inbound project task for event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdOdooTasksPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdOdooTasksPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdOdooTasksPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get  paginated products under an event
         * @param {string} eventId 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {SortProductListingOn} [sortOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {boolean} [isSetup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPaginatedProductsGet(eventId: string, offset?: number, pageSize?: number, sortOn?: SortProductListingOn, sortDirection?: SortDirection, isSetup?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPaginatedProductsGet(eventId, offset, pageSize, sortOn, sortDirection, isSetup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdPaginatedProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Event Finance Manager
         * @param {string} eventId The event to update
         * @param {UpdateEventPartnerManagerRequest} updateEventPartnerManagerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPartnerManagerPatch(eventId: string, updateEventPartnerManagerRequest: UpdateEventPartnerManagerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPartnerManagerPatch(eventId, updateEventPartnerManagerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdPartnerManagerPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update basic event properties
         * @param {string} eventId The id of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {UpdateEventRequestDto} updateEventRequestDto The request object with updated event information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPatch(eventId: string, xPlatformKey: string, updateEventRequestDto: UpdateEventRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPatch(eventId, xPlatformKey, updateEventRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdProductsCreateFromLineupPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdProductsCreateFromLineupPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdProductsCreateFromLineupPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get products under an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdProductsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductSkuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdProductsGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update product media so that it matches the configured kit.
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdProductsMediaKitPatch(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdProductsMediaKitPatch(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdProductsMediaKitPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] create a product for an event
         * @param {string} eventId 
         * @param {CreateProductForEventRequest} createProductForEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdProductsPost(eventId: string, createProductForEventRequest: CreateProductForEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdProductsPost(eventId, createProductForEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * publishing an event means settings its event status to \'PUBLISHED\'. If an event has event status \'PUBLISHED\' it will be included in the \'/events\' endpoint response.
         * @summary Publish an event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdPublishPatch(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdPublishPatch(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdPublishPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Relist multiple products through their IDs in one event using a CSV
         * @param {string} eventId The id of the event
         * @param {File} [csvFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdRelistProductsPost(eventId: string, csvFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdRelistProductsPost(eventId, csvFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdRelistProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an event status
         * @param {string} eventId The id of the event
         * @param {UpdateEventStatusRequest} updateEventStatusRequest A cancellation token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdStatusPut(eventId: string, updateEventStatusRequest: UpdateEventStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdStatusPut(eventId, updateEventStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] will toggle all the products mockup, and image medias active/inactive so all the mockup, image media\'s visibility property for this event will be flipped
         * @param {string} eventId the event to flip all of its media
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdToggleMediaPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdToggleMediaPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdToggleMediaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unpublishing an event means flipping its event status to \'UNPUBLISHED\' If an event has event status \'UNPUBLISHED\' it will be no longer be included in the \'/events\' endpoint response.
         * @summary Unpublish an event
         * @param {string} eventId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdUnpublishPatch(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdUnpublishPatch(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsEventIdUnpublishPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The events will be exported to the platform provided
         * @param {ExportEventsToNewPlatformsRequest} exportEventsToNewPlatformsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsExportToPlatformsPost(exportEventsToNewPlatformsRequest: ExportEventsToNewPlatformsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsExportToPlatformsPost(exportEventsToNewPlatformsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsExportToPlatformsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Flexible list events
         * @param {string} xPlatformKey Select the platform.
         * @param {Array<string>} [statuses] Status filter to be applied
         * @param {string} [searchTerm] The search term for searching
         * @param {Date} [startbefore] The datetime for events to start before
         * @param {Date} [startafter] The datetime for events to start after
         * @param {Date} [endbefore] The datetime for events to end before
         * @param {Date} [endafter] The datetime for events to end after
         * @param {string} [sortColumn] The column to sort by. Can be startDate or endDate
         * @param {string} [sortDirection] Sort property. Can be \&#39;asc\&#39; for ascending and \&#39;desc\&#39; for descending
         * @param {string} [categoryId] The category id you want to retrieve events of
         * @param {string} [categoryIds] The category ids you want to retrieve intersection events of
         * @param {boolean} [hasHighlightedMarketingAngle] 
         * @param {boolean} [hasMarketingAngle] 
         * @param {string} [managerUserId] 
         * @param {PartnerRegion} [partnerRegion] 
         * @param {number | null} [teamTier] 
         * @param {string} [contractId] 
         * @param {string} [partnerId] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsGet(xPlatformKey: string, statuses?: Array<string>, searchTerm?: string, startbefore?: Date, startafter?: Date, endbefore?: Date, endafter?: Date, sortColumn?: string, sortDirection?: string, categoryId?: string, categoryIds?: string, hasHighlightedMarketingAngle?: boolean, hasMarketingAngle?: boolean, managerUserId?: string, partnerRegion?: PartnerRegion, teamTier?: number | null, contractId?: string, partnerId?: string, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsGet(xPlatformKey, statuses, searchTerm, startbefore, startafter, endbefore, endafter, sortColumn, sortDirection, categoryId, categoryIds, hasHighlightedMarketingAngle, hasMarketingAngle, managerUserId, partnerRegion, teamTier, contractId, partnerId, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get multiple events by Id
         * @param {string} [eventIds] The ids of the events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsMultipleGet(eventIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsMultipleGet(eventIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsMultipleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CreateEventRequest>} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsMultiplePost(createEventRequest: Array<CreateEventRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminEventResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsMultiplePost(createEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsMultiplePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk update events
         * @param {BulkUpdateEventsRequest} bulkUpdateEventsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsPatch(bulkUpdateEventsRequest: BulkUpdateEventsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductSkuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsPatch(bulkUpdateEventsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary New unified endpoint for creating an event. This endpoint will replace the old 2 endpoints for creating events
         * @param {CreateEventRequest} createEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsPost(createEventRequest: CreateEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEventResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsPost(createEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search events for a given term.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {string} [searchTerm] Search query to be applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsSearchGet(xPlatformKey: string, offSet?: number, pageSize?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsSearchGet(xPlatformKey, offSet, pageSize, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsApi.adminEventsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventsApi - factory interface
 */
export const AdminEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all events in a time period, used for the month view in the admin portal
         * @param {AdminEventsApiAdminEventsCalendarGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsCalendarGet(requestParameters: AdminEventsApiAdminEventsCalendarGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventResponse>> {
            return localVarFp.adminEventsCalendarGet(requestParameters.startsAfter, requestParameters.startsBefore, requestParameters.endsAfter, requestParameters.endsBefore, requestParameters.statuses, requestParameters.hasHighlightedMarketingAngle, requestParameters.hasMarketingAngle, requestParameters.categoryId, requestParameters.searchTerm, requestParameters.managerUserId, requestParameters.partnerRegion, requestParameters.teamTier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the events with this contract
         * @param {AdminEventsApiAdminEventsContractContractIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsContractContractIdGet(requestParameters: AdminEventsApiAdminEventsContractContractIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminEventResponse> {
            return localVarFp.adminEventsContractContractIdGet(requestParameters.contractId, requestParameters.eventStatus, requestParameters.eventSettingsIds, requestParameters.offSet, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] update the beneficiary on all collections of an event
         * @param {AdminEventsApiAdminEventsEventIdBeneficiaryPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdBeneficiaryPatch(requestParameters: AdminEventsApiAdminEventsEventIdBeneficiaryPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdBeneficiaryPatch(requestParameters.eventId, requestParameters.setEventBeneficiaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the contract of an event
         * @param {AdminEventsApiAdminEventsEventIdContractsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdContractsPatch(requestParameters: AdminEventsApiAdminEventsEventIdContractsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdContractsPatch(requestParameters.eventId, requestParameters.updateEventContractRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a default product mockup image to an event
         * @param {AdminEventsApiAdminEventsEventIdDefaultProductImagePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdDefaultProductImagePost(requestParameters: AdminEventsApiAdminEventsEventIdDefaultProductImagePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdDefaultProductImagePost(requestParameters.eventId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export all bids of an event
         * @param {AdminEventsApiAdminEventsEventIdExportBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExportBidsGet(requestParameters: AdminEventsApiAdminEventsEventIdExportBidsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileResult> {
            return localVarFp.adminEventsEventIdExportBidsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The Event will be exported to the platform provided
         * @param {AdminEventsApiAdminEventsEventIdExportToPlatformPlatformIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExportToPlatformPlatformIdPost(requestParameters: AdminEventsApiAdminEventsEventIdExportToPlatformPlatformIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdExportToPlatformPlatformIdPost(requestParameters.eventId, requestParameters.platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Extend the event with a reason
         * @param {AdminEventsApiAdminEventsEventIdExtendPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdExtendPatch(requestParameters: AdminEventsApiAdminEventsEventIdExtendPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdExtendPatch(requestParameters.eventId, requestParameters.extendEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get event
         * @param {AdminEventsApiAdminEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdGet(requestParameters: AdminEventsApiAdminEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEventResponse> {
            return localVarFp.adminEventsEventIdGet(requestParameters.eventId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide or show the partner on the event\'s product pages.
         * @param {AdminEventsApiAdminEventsEventIdHidePartnerPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdHidePartnerPatch(requestParameters: AdminEventsApiAdminEventsEventIdHidePartnerPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdHidePartnerPatch(requestParameters.eventId, requestParameters.updateEventHidePartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates both event and project in Odoo
         * @param {AdminEventsApiAdminEventsEventIdOdooPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooPost(requestParameters: AdminEventsApiAdminEventsEventIdOdooPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdOdooPost(requestParameters.eventId, requestParameters.createEventInOdoo, requestParameters.createProjectInOdoo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update both event and project in Odoo
         * @param {AdminEventsApiAdminEventsEventIdOdooPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooPut(requestParameters: AdminEventsApiAdminEventsEventIdOdooPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdOdooPut(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Odoo inbound project task for event
         * @param {AdminEventsApiAdminEventsEventIdOdooTasksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdOdooTasksPost(requestParameters: AdminEventsApiAdminEventsEventIdOdooTasksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdOdooTasksPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get  paginated products under an event
         * @param {AdminEventsApiAdminEventsEventIdPaginatedProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPaginatedProductsGet(requestParameters: AdminEventsApiAdminEventsEventIdPaginatedProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminProductSkuDto> {
            return localVarFp.adminEventsEventIdPaginatedProductsGet(requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, requestParameters.isSetup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Event Finance Manager
         * @param {AdminEventsApiAdminEventsEventIdPartnerManagerPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPartnerManagerPatch(requestParameters: AdminEventsApiAdminEventsEventIdPartnerManagerPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdPartnerManagerPatch(requestParameters.eventId, requestParameters.updateEventPartnerManagerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update basic event properties
         * @param {AdminEventsApiAdminEventsEventIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPatch(requestParameters: AdminEventsApiAdminEventsEventIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEventResponse> {
            return localVarFp.adminEventsEventIdPatch(requestParameters.eventId, requestParameters.xPlatformKey, requestParameters.updateEventRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventsApiAdminEventsEventIdProductsCreateFromLineupPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsCreateFromLineupPost(requestParameters: AdminEventsApiAdminEventsEventIdProductsCreateFromLineupPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdProductsCreateFromLineupPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get products under an event
         * @param {AdminEventsApiAdminEventsEventIdProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsGet(requestParameters: AdminEventsApiAdminEventsEventIdProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSkuDto>> {
            return localVarFp.adminEventsEventIdProductsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update product media so that it matches the configured kit.
         * @param {AdminEventsApiAdminEventsEventIdProductsMediaKitPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsMediaKitPatch(requestParameters: AdminEventsApiAdminEventsEventIdProductsMediaKitPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdProductsMediaKitPatch(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] create a product for an event
         * @param {AdminEventsApiAdminEventsEventIdProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdProductsPost(requestParameters: AdminEventsApiAdminEventsEventIdProductsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductSkuDto> {
            return localVarFp.adminEventsEventIdProductsPost(requestParameters.eventId, requestParameters.createProductForEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * publishing an event means settings its event status to \'PUBLISHED\'. If an event has event status \'PUBLISHED\' it will be included in the \'/events\' endpoint response.
         * @summary Publish an event
         * @param {AdminEventsApiAdminEventsEventIdPublishPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdPublishPatch(requestParameters: AdminEventsApiAdminEventsEventIdPublishPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventDto> {
            return localVarFp.adminEventsEventIdPublishPatch(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Relist multiple products through their IDs in one event using a CSV
         * @param {AdminEventsApiAdminEventsEventIdRelistProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdRelistProductsPost(requestParameters: AdminEventsApiAdminEventsEventIdRelistProductsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdRelistProductsPost(requestParameters.eventId, requestParameters.csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an event status
         * @param {AdminEventsApiAdminEventsEventIdStatusPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdStatusPut(requestParameters: AdminEventsApiAdminEventsEventIdStatusPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdStatusPut(requestParameters.eventId, requestParameters.updateEventStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] will toggle all the products mockup, and image medias active/inactive so all the mockup, image media\'s visibility property for this event will be flipped
         * @param {AdminEventsApiAdminEventsEventIdToggleMediaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdToggleMediaPost(requestParameters: AdminEventsApiAdminEventsEventIdToggleMediaPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdToggleMediaPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unpublishing an event means flipping its event status to \'UNPUBLISHED\' If an event has event status \'UNPUBLISHED\' it will be no longer be included in the \'/events\' endpoint response.
         * @summary Unpublish an event
         * @param {AdminEventsApiAdminEventsEventIdUnpublishPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdUnpublishPatch(requestParameters: AdminEventsApiAdminEventsEventIdUnpublishPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventDto> {
            return localVarFp.adminEventsEventIdUnpublishPatch(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The events will be exported to the platform provided
         * @param {AdminEventsApiAdminEventsExportToPlatformsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsExportToPlatformsPost(requestParameters: AdminEventsApiAdminEventsExportToPlatformsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsExportToPlatformsPost(requestParameters.exportEventsToNewPlatformsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Flexible list events
         * @param {AdminEventsApiAdminEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsGet(requestParameters: AdminEventsApiAdminEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminEventResponse> {
            return localVarFp.adminEventsGet(requestParameters.xPlatformKey, requestParameters.statuses, requestParameters.searchTerm, requestParameters.startbefore, requestParameters.startafter, requestParameters.endbefore, requestParameters.endafter, requestParameters.sortColumn, requestParameters.sortDirection, requestParameters.categoryId, requestParameters.categoryIds, requestParameters.hasHighlightedMarketingAngle, requestParameters.hasMarketingAngle, requestParameters.managerUserId, requestParameters.partnerRegion, requestParameters.teamTier, requestParameters.contractId, requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get multiple events by Id
         * @param {AdminEventsApiAdminEventsMultipleGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsMultipleGet(requestParameters: AdminEventsApiAdminEventsMultipleGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventDto>> {
            return localVarFp.adminEventsMultipleGet(requestParameters.eventIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventsApiAdminEventsMultiplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsMultiplePost(requestParameters: AdminEventsApiAdminEventsMultiplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminEventResponse>> {
            return localVarFp.adminEventsMultiplePost(requestParameters.createEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update events
         * @param {AdminEventsApiAdminEventsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsPatch(requestParameters: AdminEventsApiAdminEventsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSkuDto>> {
            return localVarFp.adminEventsPatch(requestParameters.bulkUpdateEventsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary New unified endpoint for creating an event. This endpoint will replace the old 2 endpoints for creating events
         * @param {AdminEventsApiAdminEventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsPost(requestParameters: AdminEventsApiAdminEventsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEventResponse> {
            return localVarFp.adminEventsPost(requestParameters.createEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search events for a given term.
         * @param {AdminEventsApiAdminEventsSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsSearchGet(requestParameters: AdminEventsApiAdminEventsSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfEventDto> {
            return localVarFp.adminEventsSearchGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsCalendarGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsCalendarGetRequest {
    readonly startsAfter?: Date

    readonly startsBefore?: Date

    readonly endsAfter?: Date

    readonly endsBefore?: Date

    readonly statuses?: Array<EventStatus>

    readonly hasHighlightedMarketingAngle?: boolean

    readonly hasMarketingAngle?: boolean

    readonly categoryId?: string

    readonly searchTerm?: string

    readonly managerUserId?: string

    readonly partnerRegion?: PartnerRegion

    readonly teamTier?: number | null
}

/**
 * Request parameters for adminEventsContractContractIdGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsContractContractIdGetRequest {
    /**
     * 
     */
    readonly contractId: string

    /**
     * 
     */
    readonly eventStatus?: string

    readonly eventSettingsIds?: Array<string>

    /**
     * 
     */
    readonly offSet?: number

    /**
     * 
     */
    readonly pageSize?: number

    /**
     * 
     */
    readonly sortOn?: SortEventOn

    /**
     * 
     */
    readonly sortDirection?: SortDirection
}

/**
 * Request parameters for adminEventsEventIdBeneficiaryPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdBeneficiaryPatchRequest {
    /**
     * 
     */
    readonly eventId: string

    /**
     * 
     */
    readonly setEventBeneficiaryRequest: SetEventBeneficiaryRequest
}

/**
 * Request parameters for adminEventsEventIdContractsPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdContractsPatchRequest {
    readonly eventId: string

    readonly updateEventContractRequestDto: UpdateEventContractRequestDto
}

/**
 * Request parameters for adminEventsEventIdDefaultProductImagePost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdDefaultProductImagePostRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    readonly file?: File
}

/**
 * Request parameters for adminEventsEventIdExportBidsGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdExportBidsGetRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdExportToPlatformPlatformIdPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdExportToPlatformPlatformIdPostRequest {
    /**
     * 
     */
    readonly eventId: string

    /**
     * 
     */
    readonly platformId: string
}

/**
 * Request parameters for adminEventsEventIdExtendPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdExtendPatchRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    /**
     * 
     */
    readonly extendEventRequest: ExtendEventRequest
}

/**
 * Request parameters for adminEventsEventIdGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdGetRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for adminEventsEventIdHidePartnerPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdHidePartnerPatchRequest {
    /**
     * The event to update
     */
    readonly eventId: string

    /**
     * 
     */
    readonly updateEventHidePartnerRequest: UpdateEventHidePartnerRequest
}

/**
 * Request parameters for adminEventsEventIdOdooPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdOdooPostRequest {
    /**
     * The id of the event to sync
     */
    readonly eventId: string

    readonly createEventInOdoo?: boolean

    readonly createProjectInOdoo?: boolean
}

/**
 * Request parameters for adminEventsEventIdOdooPut operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdOdooPutRequest {
    /**
     * The id of the event to sync
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdOdooTasksPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdOdooTasksPostRequest {
    /**
     * The id of the event
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdPaginatedProductsGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdPaginatedProductsGetRequest {
    /**
     * 
     */
    readonly eventId: string

    readonly offset?: number

    readonly pageSize?: number

    readonly sortOn?: SortProductListingOn

    readonly sortDirection?: SortDirection

    readonly isSetup?: boolean
}

/**
 * Request parameters for adminEventsEventIdPartnerManagerPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdPartnerManagerPatchRequest {
    /**
     * The event to update
     */
    readonly eventId: string

    /**
     * 
     */
    readonly updateEventPartnerManagerRequest: UpdateEventPartnerManagerRequest
}

/**
 * Request parameters for adminEventsEventIdPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdPatchRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * The request object with updated event information
     */
    readonly updateEventRequestDto: UpdateEventRequestDto
}

/**
 * Request parameters for adminEventsEventIdProductsCreateFromLineupPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdProductsCreateFromLineupPostRequest {
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdProductsGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdProductsGetRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdProductsMediaKitPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdProductsMediaKitPatchRequest {
    /**
     * 
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdProductsPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdProductsPostRequest {
    /**
     * 
     */
    readonly eventId: string

    /**
     * 
     */
    readonly createProductForEventRequest: CreateProductForEventRequest
}

/**
 * Request parameters for adminEventsEventIdPublishPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdPublishPatchRequest {
    /**
     * The id of the event
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdRelistProductsPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdRelistProductsPostRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    readonly csvFile?: File
}

/**
 * Request parameters for adminEventsEventIdStatusPut operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdStatusPutRequest {
    /**
     * The id of the event
     */
    readonly eventId: string

    /**
     * A cancellation token
     */
    readonly updateEventStatusRequest: UpdateEventStatusRequest
}

/**
 * Request parameters for adminEventsEventIdToggleMediaPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdToggleMediaPostRequest {
    /**
     * the event to flip all of its media
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdUnpublishPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsEventIdUnpublishPatchRequest {
    /**
     * The id of the event
     */
    readonly eventId: string
}

/**
 * Request parameters for adminEventsExportToPlatformsPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsExportToPlatformsPostRequest {
    /**
     * 
     */
    readonly exportEventsToNewPlatformsRequest: ExportEventsToNewPlatformsRequest
}

/**
 * Request parameters for adminEventsGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * Status filter to be applied
     */
    readonly statuses?: Array<string>

    /**
     * The search term for searching
     */
    readonly searchTerm?: string

    /**
     * The datetime for events to start before
     */
    readonly startbefore?: Date

    /**
     * The datetime for events to start after
     */
    readonly startafter?: Date

    /**
     * The datetime for events to end before
     */
    readonly endbefore?: Date

    /**
     * The datetime for events to end after
     */
    readonly endafter?: Date

    /**
     * The column to sort by. Can be startDate or endDate
     */
    readonly sortColumn?: string

    /**
     * Sort property. Can be \&#39;asc\&#39; for ascending and \&#39;desc\&#39; for descending
     */
    readonly sortDirection?: string

    /**
     * The category id you want to retrieve events of
     */
    readonly categoryId?: string

    /**
     * The category ids you want to retrieve intersection events of
     */
    readonly categoryIds?: string

    readonly hasHighlightedMarketingAngle?: boolean

    readonly hasMarketingAngle?: boolean

    readonly managerUserId?: string

    readonly partnerRegion?: PartnerRegion

    readonly teamTier?: number | null

    readonly contractId?: string

    readonly partnerId?: string

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminEventsMultipleGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsMultipleGetRequest {
    /**
     * The ids of the events
     */
    readonly eventIds?: string
}

/**
 * Request parameters for adminEventsMultiplePost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsMultiplePostRequest {
    readonly createEventRequest: Array<CreateEventRequest>
}

/**
 * Request parameters for adminEventsPatch operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsPatchRequest {
    /**
     * 
     */
    readonly bulkUpdateEventsRequest: BulkUpdateEventsRequest
}

/**
 * Request parameters for adminEventsPost operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsPostRequest {
    readonly createEventRequest: CreateEventRequest
}

/**
 * Request parameters for adminEventsSearchGet operation in AdminEventsApi.
 */
export interface AdminEventsApiAdminEventsSearchGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * The amount of items to skip
     */
    readonly offSet?: number

    /**
     * The maximum size of any individual subset
     */
    readonly pageSize?: number

    /**
     * Search query to be applied
     */
    readonly searchTerm?: string
}

/**
 * AdminEventsApi - object-oriented interface
 */
export class AdminEventsApi extends BaseAPI {
    /**
     * 
     * @summary List all events in a time period, used for the month view in the admin portal
     * @param {AdminEventsApiAdminEventsCalendarGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsCalendarGet(requestParameters: AdminEventsApiAdminEventsCalendarGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsCalendarGet(requestParameters.startsAfter, requestParameters.startsBefore, requestParameters.endsAfter, requestParameters.endsBefore, requestParameters.statuses, requestParameters.hasHighlightedMarketingAngle, requestParameters.hasMarketingAngle, requestParameters.categoryId, requestParameters.searchTerm, requestParameters.managerUserId, requestParameters.partnerRegion, requestParameters.teamTier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the events with this contract
     * @param {AdminEventsApiAdminEventsContractContractIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsContractContractIdGet(requestParameters: AdminEventsApiAdminEventsContractContractIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsContractContractIdGet(requestParameters.contractId, requestParameters.eventStatus, requestParameters.eventSettingsIds, requestParameters.offSet, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] update the beneficiary on all collections of an event
     * @param {AdminEventsApiAdminEventsEventIdBeneficiaryPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdBeneficiaryPatch(requestParameters: AdminEventsApiAdminEventsEventIdBeneficiaryPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdBeneficiaryPatch(requestParameters.eventId, requestParameters.setEventBeneficiaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the contract of an event
     * @param {AdminEventsApiAdminEventsEventIdContractsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdContractsPatch(requestParameters: AdminEventsApiAdminEventsEventIdContractsPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdContractsPatch(requestParameters.eventId, requestParameters.updateEventContractRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a default product mockup image to an event
     * @param {AdminEventsApiAdminEventsEventIdDefaultProductImagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdDefaultProductImagePost(requestParameters: AdminEventsApiAdminEventsEventIdDefaultProductImagePostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdDefaultProductImagePost(requestParameters.eventId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export all bids of an event
     * @param {AdminEventsApiAdminEventsEventIdExportBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdExportBidsGet(requestParameters: AdminEventsApiAdminEventsEventIdExportBidsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdExportBidsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The Event will be exported to the platform provided
     * @param {AdminEventsApiAdminEventsEventIdExportToPlatformPlatformIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdExportToPlatformPlatformIdPost(requestParameters: AdminEventsApiAdminEventsEventIdExportToPlatformPlatformIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdExportToPlatformPlatformIdPost(requestParameters.eventId, requestParameters.platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Extend the event with a reason
     * @param {AdminEventsApiAdminEventsEventIdExtendPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdExtendPatch(requestParameters: AdminEventsApiAdminEventsEventIdExtendPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdExtendPatch(requestParameters.eventId, requestParameters.extendEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get event
     * @param {AdminEventsApiAdminEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdGet(requestParameters: AdminEventsApiAdminEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdGet(requestParameters.eventId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide or show the partner on the event\'s product pages.
     * @param {AdminEventsApiAdminEventsEventIdHidePartnerPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdHidePartnerPatch(requestParameters: AdminEventsApiAdminEventsEventIdHidePartnerPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdHidePartnerPatch(requestParameters.eventId, requestParameters.updateEventHidePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates both event and project in Odoo
     * @param {AdminEventsApiAdminEventsEventIdOdooPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdOdooPost(requestParameters: AdminEventsApiAdminEventsEventIdOdooPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdOdooPost(requestParameters.eventId, requestParameters.createEventInOdoo, requestParameters.createProjectInOdoo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update both event and project in Odoo
     * @param {AdminEventsApiAdminEventsEventIdOdooPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdOdooPut(requestParameters: AdminEventsApiAdminEventsEventIdOdooPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdOdooPut(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Odoo inbound project task for event
     * @param {AdminEventsApiAdminEventsEventIdOdooTasksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdOdooTasksPost(requestParameters: AdminEventsApiAdminEventsEventIdOdooTasksPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdOdooTasksPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get  paginated products under an event
     * @param {AdminEventsApiAdminEventsEventIdPaginatedProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPaginatedProductsGet(requestParameters: AdminEventsApiAdminEventsEventIdPaginatedProductsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdPaginatedProductsGet(requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.sortOn, requestParameters.sortDirection, requestParameters.isSetup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Event Finance Manager
     * @param {AdminEventsApiAdminEventsEventIdPartnerManagerPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPartnerManagerPatch(requestParameters: AdminEventsApiAdminEventsEventIdPartnerManagerPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdPartnerManagerPatch(requestParameters.eventId, requestParameters.updateEventPartnerManagerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update basic event properties
     * @param {AdminEventsApiAdminEventsEventIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPatch(requestParameters: AdminEventsApiAdminEventsEventIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdPatch(requestParameters.eventId, requestParameters.xPlatformKey, requestParameters.updateEventRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventsApiAdminEventsEventIdProductsCreateFromLineupPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdProductsCreateFromLineupPost(requestParameters: AdminEventsApiAdminEventsEventIdProductsCreateFromLineupPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdProductsCreateFromLineupPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get products under an event
     * @param {AdminEventsApiAdminEventsEventIdProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdProductsGet(requestParameters: AdminEventsApiAdminEventsEventIdProductsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdProductsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update product media so that it matches the configured kit.
     * @param {AdminEventsApiAdminEventsEventIdProductsMediaKitPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdProductsMediaKitPatch(requestParameters: AdminEventsApiAdminEventsEventIdProductsMediaKitPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdProductsMediaKitPatch(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] create a product for an event
     * @param {AdminEventsApiAdminEventsEventIdProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdProductsPost(requestParameters: AdminEventsApiAdminEventsEventIdProductsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdProductsPost(requestParameters.eventId, requestParameters.createProductForEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * publishing an event means settings its event status to \'PUBLISHED\'. If an event has event status \'PUBLISHED\' it will be included in the \'/events\' endpoint response.
     * @summary Publish an event
     * @param {AdminEventsApiAdminEventsEventIdPublishPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdPublishPatch(requestParameters: AdminEventsApiAdminEventsEventIdPublishPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdPublishPatch(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Relist multiple products through their IDs in one event using a CSV
     * @param {AdminEventsApiAdminEventsEventIdRelistProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdRelistProductsPost(requestParameters: AdminEventsApiAdminEventsEventIdRelistProductsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdRelistProductsPost(requestParameters.eventId, requestParameters.csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an event status
     * @param {AdminEventsApiAdminEventsEventIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdStatusPut(requestParameters: AdminEventsApiAdminEventsEventIdStatusPutRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdStatusPut(requestParameters.eventId, requestParameters.updateEventStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] will toggle all the products mockup, and image medias active/inactive so all the mockup, image media\'s visibility property for this event will be flipped
     * @param {AdminEventsApiAdminEventsEventIdToggleMediaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdToggleMediaPost(requestParameters: AdminEventsApiAdminEventsEventIdToggleMediaPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdToggleMediaPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unpublishing an event means flipping its event status to \'UNPUBLISHED\' If an event has event status \'UNPUBLISHED\' it will be no longer be included in the \'/events\' endpoint response.
     * @summary Unpublish an event
     * @param {AdminEventsApiAdminEventsEventIdUnpublishPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdUnpublishPatch(requestParameters: AdminEventsApiAdminEventsEventIdUnpublishPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsEventIdUnpublishPatch(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The events will be exported to the platform provided
     * @param {AdminEventsApiAdminEventsExportToPlatformsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsExportToPlatformsPost(requestParameters: AdminEventsApiAdminEventsExportToPlatformsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsExportToPlatformsPost(requestParameters.exportEventsToNewPlatformsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Flexible list events
     * @param {AdminEventsApiAdminEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsGet(requestParameters: AdminEventsApiAdminEventsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsGet(requestParameters.xPlatformKey, requestParameters.statuses, requestParameters.searchTerm, requestParameters.startbefore, requestParameters.startafter, requestParameters.endbefore, requestParameters.endafter, requestParameters.sortColumn, requestParameters.sortDirection, requestParameters.categoryId, requestParameters.categoryIds, requestParameters.hasHighlightedMarketingAngle, requestParameters.hasMarketingAngle, requestParameters.managerUserId, requestParameters.partnerRegion, requestParameters.teamTier, requestParameters.contractId, requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get multiple events by Id
     * @param {AdminEventsApiAdminEventsMultipleGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsMultipleGet(requestParameters: AdminEventsApiAdminEventsMultipleGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsMultipleGet(requestParameters.eventIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventsApiAdminEventsMultiplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsMultiplePost(requestParameters: AdminEventsApiAdminEventsMultiplePostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsMultiplePost(requestParameters.createEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update events
     * @param {AdminEventsApiAdminEventsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsPatch(requestParameters: AdminEventsApiAdminEventsPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsPatch(requestParameters.bulkUpdateEventsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary New unified endpoint for creating an event. This endpoint will replace the old 2 endpoints for creating events
     * @param {AdminEventsApiAdminEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsPost(requestParameters: AdminEventsApiAdminEventsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsPost(requestParameters.createEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search events for a given term.
     * @param {AdminEventsApiAdminEventsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsSearchGet(requestParameters: AdminEventsApiAdminEventsSearchGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsApiFp(this.configuration).adminEventsSearchGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEventsInboundReportApi - axios parameter creator
 */
export const AdminEventsInboundReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all inbound reports for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsGet: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/inbound-reports`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a kitman inbound report for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsKitmanPost: async (eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsKitmanPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/kitman`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates latest version of an inbound report for an event
         * @param {string} eventId 
         * @param {InboundReportType} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsLatestPost: async (eventId: string, reportType?: InboundReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsLatestPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/latest`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reportType !== undefined) {
                localVarQueryParameter['reportType'] = reportType;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update and Submit an admin photo report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitPhotoReportRequest} updateAndSubmitPhotoReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsPhotoPost: async (eventId: string, updateAndSubmitPhotoReportRequest: UpdateAndSubmitPhotoReportRequest, u?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsPhotoPost', 'eventId', eventId)
            // verify required parameter 'updateAndSubmitPhotoReportRequest' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsPhotoPost', 'updateAndSubmitPhotoReportRequest', updateAndSubmitPhotoReportRequest)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/photo`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (u !== undefined) {
                localVarQueryParameter['_'] = u;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAndSubmitPhotoReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsReportIdGet: async (reportId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsReportIdGet', 'reportId', reportId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsReportIdGet', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/{reportId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync received shirts from an inbound report to Odoo as stock lots
         * @param {string} reportId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsReportIdSyncPost: async (reportId: string, eventId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsReportIdSyncPost', 'reportId', reportId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsReportIdSyncPost', 'eventId', eventId)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/{reportId}/sync`
                .replace('{reportId}', encodeURIComponent(String(reportId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a storage inbound report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitStorageInboundReportRequest} updateAndSubmitStorageInboundReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsStoragePost: async (eventId: string, updateAndSubmitStorageInboundReportRequest: UpdateAndSubmitStorageInboundReportRequest, u?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsStoragePost', 'eventId', eventId)
            // verify required parameter 'updateAndSubmitStorageInboundReportRequest' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsStoragePost', 'updateAndSubmitStorageInboundReportRequest', updateAndSubmitStorageInboundReportRequest)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/storage`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (u !== undefined) {
                localVarQueryParameter['_'] = u;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAndSubmitStorageInboundReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update and Submit an admin inbound report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitAdminInboundReportRequest} updateAndSubmitAdminInboundReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsSubmitPost: async (eventId: string, updateAndSubmitAdminInboundReportRequest: UpdateAndSubmitAdminInboundReportRequest, u?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsSubmitPost', 'eventId', eventId)
            // verify required parameter 'updateAndSubmitAdminInboundReportRequest' is not null or undefined
            assertParamExists('adminEventsEventIdInboundReportsSubmitPost', 'updateAndSubmitAdminInboundReportRequest', updateAndSubmitAdminInboundReportRequest)
            const localVarPath = `/admin/events/{eventId}/inbound-reports/submit`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (u !== undefined) {
                localVarQueryParameter['_'] = u;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAndSubmitAdminInboundReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEventsInboundReportApi - functional programming interface
 */
export const AdminEventsInboundReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEventsInboundReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all inbound reports for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsGet(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminInboundReportItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsGet(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a kitman inbound report for an event
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsKitmanPost(eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsKitmanPost(eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsKitmanPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates latest version of an inbound report for an event
         * @param {string} eventId 
         * @param {InboundReportType} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsLatestPost(eventId: string, reportType?: InboundReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestEventReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsLatestPost(eventId, reportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsLatestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update and Submit an admin photo report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitPhotoReportRequest} updateAndSubmitPhotoReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsPhotoPost(eventId: string, updateAndSubmitPhotoReportRequest: UpdateAndSubmitPhotoReportRequest, u?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsPhotoPost(eventId, updateAndSubmitPhotoReportRequest, u, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsPhotoPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsReportIdGet(reportId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestEventReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsReportIdGet(reportId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsReportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync received shirts from an inbound report to Odoo as stock lots
         * @param {string} reportId 
         * @param {string} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsReportIdSyncPost(reportId: string, eventId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsReportIdSyncPost(reportId, eventId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsReportIdSyncPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a storage inbound report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitStorageInboundReportRequest} updateAndSubmitStorageInboundReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsStoragePost(eventId: string, updateAndSubmitStorageInboundReportRequest: UpdateAndSubmitStorageInboundReportRequest, u?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsStoragePost(eventId, updateAndSubmitStorageInboundReportRequest, u, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsStoragePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update and Submit an admin inbound report for an event
         * @param {string} eventId 
         * @param {UpdateAndSubmitAdminInboundReportRequest} updateAndSubmitAdminInboundReportRequest 
         * @param {string} [u] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminEventsEventIdInboundReportsSubmitPost(eventId: string, updateAndSubmitAdminInboundReportRequest: UpdateAndSubmitAdminInboundReportRequest, u?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminEventsEventIdInboundReportsSubmitPost(eventId, updateAndSubmitAdminInboundReportRequest, u, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEventsInboundReportApi.adminEventsEventIdInboundReportsSubmitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEventsInboundReportApi - factory interface
 */
export const AdminEventsInboundReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEventsInboundReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all inbound reports for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsGet(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminInboundReportItemResponse> {
            return localVarFp.adminEventsEventIdInboundReportsGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a kitman inbound report for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsKitmanPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsKitmanPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsKitmanPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdInboundReportsKitmanPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates latest version of an inbound report for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsLatestPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsLatestPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsLatestPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LatestEventReportResponse> {
            return localVarFp.adminEventsEventIdInboundReportsLatestPost(requestParameters.eventId, requestParameters.reportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update and Submit an admin photo report for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsPhotoPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsPhotoPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsPhotoPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdInboundReportsPhotoPost(requestParameters.eventId, requestParameters.updateAndSubmitPhotoReportRequest, requestParameters.u, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsReportIdGet(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LatestEventReportResponse> {
            return localVarFp.adminEventsEventIdInboundReportsReportIdGet(requestParameters.reportId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync received shirts from an inbound report to Odoo as stock lots
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdSyncPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsReportIdSyncPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdSyncPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminEventsEventIdInboundReportsReportIdSyncPost(requestParameters.reportId, requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a storage inbound report for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsStoragePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsStoragePost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsStoragePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdInboundReportsStoragePost(requestParameters.eventId, requestParameters.updateAndSubmitStorageInboundReportRequest, requestParameters.u, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update and Submit an admin inbound report for an event
         * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsSubmitPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEventsEventIdInboundReportsSubmitPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsSubmitPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminEventsEventIdInboundReportsSubmitPost(requestParameters.eventId, requestParameters.updateAndSubmitAdminInboundReportRequest, requestParameters.u, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminEventsEventIdInboundReportsGet operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsGetRequest {
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsKitmanPost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsKitmanPostRequest {
    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsLatestPost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsLatestPostRequest {
    readonly eventId: string

    readonly reportType?: InboundReportType
}

/**
 * Request parameters for adminEventsEventIdInboundReportsPhotoPost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsPhotoPostRequest {
    readonly eventId: string

    readonly updateAndSubmitPhotoReportRequest: UpdateAndSubmitPhotoReportRequest

    readonly u?: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsReportIdGet operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdGetRequest {
    readonly reportId: string

    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsReportIdSyncPost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdSyncPostRequest {
    readonly reportId: string

    readonly eventId: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsStoragePost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsStoragePostRequest {
    readonly eventId: string

    readonly updateAndSubmitStorageInboundReportRequest: UpdateAndSubmitStorageInboundReportRequest

    readonly u?: string
}

/**
 * Request parameters for adminEventsEventIdInboundReportsSubmitPost operation in AdminEventsInboundReportApi.
 */
export interface AdminEventsInboundReportApiAdminEventsEventIdInboundReportsSubmitPostRequest {
    readonly eventId: string

    readonly updateAndSubmitAdminInboundReportRequest: UpdateAndSubmitAdminInboundReportRequest

    readonly u?: string
}

/**
 * AdminEventsInboundReportApi - object-oriented interface
 */
export class AdminEventsInboundReportApi extends BaseAPI {
    /**
     * 
     * @summary Get all inbound reports for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsGet(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a kitman inbound report for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsKitmanPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsKitmanPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsKitmanPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsKitmanPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates latest version of an inbound report for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsLatestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsLatestPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsLatestPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsLatestPost(requestParameters.eventId, requestParameters.reportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update and Submit an admin photo report for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsPhotoPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsPhotoPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsPhotoPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsPhotoPost(requestParameters.eventId, requestParameters.updateAndSubmitPhotoReportRequest, requestParameters.u, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsReportIdGet(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsReportIdGet(requestParameters.reportId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync received shirts from an inbound report to Odoo as stock lots
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdSyncPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsReportIdSyncPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsReportIdSyncPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsReportIdSyncPost(requestParameters.reportId, requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a storage inbound report for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsStoragePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsStoragePost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsStoragePostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsStoragePost(requestParameters.eventId, requestParameters.updateAndSubmitStorageInboundReportRequest, requestParameters.u, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update and Submit an admin inbound report for an event
     * @param {AdminEventsInboundReportApiAdminEventsEventIdInboundReportsSubmitPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminEventsEventIdInboundReportsSubmitPost(requestParameters: AdminEventsInboundReportApiAdminEventsEventIdInboundReportsSubmitPostRequest, options?: RawAxiosRequestConfig) {
        return AdminEventsInboundReportApiFp(this.configuration).adminEventsEventIdInboundReportsSubmitPost(requestParameters.eventId, requestParameters.updateAndSubmitAdminInboundReportRequest, requestParameters.u, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminKitMockupsApi - axios parameter creator
 */
export const AdminKitMockupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsDownloadGet: async (kitId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsDownloadGet', 'kitId', kitId)
            const localVarPath = `/admin/kit/{kitId}/mockups/download`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdDelete: async (kitMockupId: string, kitId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitMockupId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdDelete', 'kitMockupId', kitMockupId)
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdDelete', 'kitId', kitId)
            const localVarPath = `/admin/kit/{kitId}/mockups/{kitMockupId}`
                .replace('{kitMockupId}', encodeURIComponent(String(kitMockupId)))
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdFrameAssetsGet: async (kitMockupId: string, kitId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitMockupId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdFrameAssetsGet', 'kitMockupId', kitMockupId)
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdFrameAssetsGet', 'kitId', kitId)
            const localVarPath = `/admin/kit/{kitId}/mockups/{kitMockupId}/frame-assets`
                .replace('{kitMockupId}', encodeURIComponent(String(kitMockupId)))
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {UpdateKitMockupFrameAssetRequest} updateKitMockupFrameAssetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdFrameAssetsPut: async (kitMockupId: string, kitId: string, updateKitMockupFrameAssetRequest: UpdateKitMockupFrameAssetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitMockupId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdFrameAssetsPut', 'kitMockupId', kitMockupId)
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdFrameAssetsPut', 'kitId', kitId)
            // verify required parameter 'updateKitMockupFrameAssetRequest' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdFrameAssetsPut', 'updateKitMockupFrameAssetRequest', updateKitMockupFrameAssetRequest)
            const localVarPath = `/admin/kit/{kitId}/mockups/{kitMockupId}/frame-assets`
                .replace('{kitMockupId}', encodeURIComponent(String(kitMockupId)))
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKitMockupFrameAssetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {UpdateKitMockupRequest} updateKitMockupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdPut: async (kitMockupId: string, kitId: string, updateKitMockupRequest: UpdateKitMockupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitMockupId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdPut', 'kitMockupId', kitMockupId)
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdPut', 'kitId', kitId)
            // verify required parameter 'updateKitMockupRequest' is not null or undefined
            assertParamExists('adminKitKitIdMockupsKitMockupIdPut', 'updateKitMockupRequest', updateKitMockupRequest)
            const localVarPath = `/admin/kit/{kitId}/mockups/{kitMockupId}`
                .replace('{kitMockupId}', encodeURIComponent(String(kitMockupId)))
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKitMockupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {CreateKitMockupRequest} createKitMockupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsPost: async (kitId: string, createKitMockupRequest: CreateKitMockupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitKitIdMockupsPost', 'kitId', kitId)
            // verify required parameter 'createKitMockupRequest' is not null or undefined
            assertParamExists('adminKitKitIdMockupsPost', 'createKitMockupRequest', createKitMockupRequest)
            const localVarPath = `/admin/kit/{kitId}/mockups`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKitMockupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminKitMockupsApi - functional programming interface
 */
export const AdminKitMockupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminKitMockupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsDownloadGet(kitId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsDownloadGet(kitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsKitMockupIdDelete(kitMockupId: string, kitId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsKitMockupIdDelete(kitMockupId, kitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsKitMockupIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsKitMockupIdFrameAssetsGet(kitMockupId: string, kitId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitMockupFrameAssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsKitMockupIdFrameAssetsGet(kitMockupId, kitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsKitMockupIdFrameAssetsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {UpdateKitMockupFrameAssetRequest} updateKitMockupFrameAssetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsKitMockupIdFrameAssetsPut(kitMockupId: string, kitId: string, updateKitMockupFrameAssetRequest: UpdateKitMockupFrameAssetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsKitMockupIdFrameAssetsPut(kitMockupId, kitId, updateKitMockupFrameAssetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsKitMockupIdFrameAssetsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitMockupId 
         * @param {string} kitId 
         * @param {UpdateKitMockupRequest} updateKitMockupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsKitMockupIdPut(kitMockupId: string, kitId: string, updateKitMockupRequest: UpdateKitMockupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsKitMockupIdPut(kitMockupId, kitId, updateKitMockupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsKitMockupIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {CreateKitMockupRequest} createKitMockupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitKitIdMockupsPost(kitId: string, createKitMockupRequest: CreateKitMockupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitKitIdMockupsPost(kitId, createKitMockupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitMockupsApi.adminKitKitIdMockupsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminKitMockupsApi - factory interface
 */
export const AdminKitMockupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminKitMockupsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsDownloadGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsDownloadGet(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsDownloadGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FileResult> {
            return localVarFp.adminKitKitIdMockupsDownloadGet(requestParameters.kitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdDelete(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitKitIdMockupsKitMockupIdDelete(requestParameters.kitMockupId, requestParameters.kitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdFrameAssetsGet(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<KitMockupFrameAssetResponse> {
            return localVarFp.adminKitKitIdMockupsKitMockupIdFrameAssetsGet(requestParameters.kitMockupId, requestParameters.kitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdFrameAssetsPut(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitKitIdMockupsKitMockupIdFrameAssetsPut(requestParameters.kitMockupId, requestParameters.kitId, requestParameters.updateKitMockupFrameAssetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsKitMockupIdPut(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitKitIdMockupsKitMockupIdPut(requestParameters.kitMockupId, requestParameters.kitId, requestParameters.updateKitMockupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitMockupsApiAdminKitKitIdMockupsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitKitIdMockupsPost(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminKitKitIdMockupsPost(requestParameters.kitId, requestParameters.createKitMockupRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminKitKitIdMockupsDownloadGet operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsDownloadGetRequest {
    readonly kitId: string
}

/**
 * Request parameters for adminKitKitIdMockupsKitMockupIdDelete operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdDeleteRequest {
    readonly kitMockupId: string

    readonly kitId: string
}

/**
 * Request parameters for adminKitKitIdMockupsKitMockupIdFrameAssetsGet operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsGetRequest {
    readonly kitMockupId: string

    readonly kitId: string
}

/**
 * Request parameters for adminKitKitIdMockupsKitMockupIdFrameAssetsPut operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsPutRequest {
    readonly kitMockupId: string

    readonly kitId: string

    readonly updateKitMockupFrameAssetRequest: UpdateKitMockupFrameAssetRequest
}

/**
 * Request parameters for adminKitKitIdMockupsKitMockupIdPut operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdPutRequest {
    readonly kitMockupId: string

    readonly kitId: string

    readonly updateKitMockupRequest: UpdateKitMockupRequest
}

/**
 * Request parameters for adminKitKitIdMockupsPost operation in AdminKitMockupsApi.
 */
export interface AdminKitMockupsApiAdminKitKitIdMockupsPostRequest {
    readonly kitId: string

    readonly createKitMockupRequest: CreateKitMockupRequest
}

/**
 * AdminKitMockupsApi - object-oriented interface
 */
export class AdminKitMockupsApi extends BaseAPI {
    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsDownloadGet(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsDownloadGetRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsDownloadGet(requestParameters.kitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsKitMockupIdDelete(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsKitMockupIdDelete(requestParameters.kitMockupId, requestParameters.kitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsKitMockupIdFrameAssetsGet(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsKitMockupIdFrameAssetsGet(requestParameters.kitMockupId, requestParameters.kitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsKitMockupIdFrameAssetsPut(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdFrameAssetsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsKitMockupIdFrameAssetsPut(requestParameters.kitMockupId, requestParameters.kitId, requestParameters.updateKitMockupFrameAssetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsKitMockupIdPut(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsKitMockupIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsKitMockupIdPut(requestParameters.kitMockupId, requestParameters.kitId, requestParameters.updateKitMockupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitMockupsApiAdminKitKitIdMockupsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitKitIdMockupsPost(requestParameters: AdminKitMockupsApiAdminKitKitIdMockupsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminKitMockupsApiFp(this.configuration).adminKitKitIdMockupsPost(requestParameters.kitId, requestParameters.createKitMockupRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminKitsApi - axios parameter creator
 */
export const AdminKitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {KitPlayerPosition} [playerPosition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsEventsEventIdGet: async (eventId: string, playerPosition?: KitPlayerPosition, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminKitsEventsEventIdGet', 'eventId', eventId)
            const localVarPath = `/admin/kits/events/{eventId}`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (playerPosition !== undefined) {
                localVarQueryParameter['playerPosition'] = playerPosition;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [teamId] 
         * @param {string} [seasonId] 
         * @param {string} [leagueId] 
         * @param {string} [rosterId] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsGet: async (teamId?: string, seasonId?: string, leagueId?: string, rosterId?: string, isArchived?: boolean, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }

            if (seasonId !== undefined) {
                localVarQueryParameter['seasonId'] = seasonId;
            }

            if (leagueId !== undefined) {
                localVarQueryParameter['leagueId'] = leagueId;
            }

            if (rosterId !== undefined) {
                localVarQueryParameter['rosterId'] = rosterId;
            }

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdArchivePatch: async (kitId: string, isArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdArchivePatch', 'kitId', kitId)
            const localVarPath = `/admin/kits/{kitId}/archive`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitAssetFilesRequest} updateKitAssetFilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdAssetsPut: async (kitId: string, updateKitAssetFilesRequest: UpdateKitAssetFilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdAssetsPut', 'kitId', kitId)
            // verify required parameter 'updateKitAssetFilesRequest' is not null or undefined
            assertParamExists('adminKitsKitIdAssetsPut', 'updateKitAssetFilesRequest', updateKitAssetFilesRequest)
            const localVarPath = `/admin/kits/{kitId}/assets`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKitAssetFilesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {BulkUploadKitMockupImagesRequest} bulkUploadKitMockupImagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdBulkUploadMockupsImagesPut: async (kitId: string, bulkUploadKitMockupImagesRequest: BulkUploadKitMockupImagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdBulkUploadMockupsImagesPut', 'kitId', kitId)
            // verify required parameter 'bulkUploadKitMockupImagesRequest' is not null or undefined
            assertParamExists('adminKitsKitIdBulkUploadMockupsImagesPut', 'bulkUploadKitMockupImagesRequest', bulkUploadKitMockupImagesRequest)
            const localVarPath = `/admin/kits/{kitId}/bulk-upload/mockups-images`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUploadKitMockupImagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {boolean} [isMockupArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdGet: async (kitId: string, isMockupArchived?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdGet', 'kitId', kitId)
            const localVarPath = `/admin/kits/{kitId}`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isMockupArchived !== undefined) {
                localVarQueryParameter['isMockupArchived'] = isMockupArchived;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitMockupsImagesRequest} updateKitMockupsImagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdMockupsImagesPut: async (kitId: string, updateKitMockupsImagesRequest: UpdateKitMockupsImagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdMockupsImagesPut', 'kitId', kitId)
            // verify required parameter 'updateKitMockupsImagesRequest' is not null or undefined
            assertParamExists('adminKitsKitIdMockupsImagesPut', 'updateKitMockupsImagesRequest', updateKitMockupsImagesRequest)
            const localVarPath = `/admin/kits/{kitId}/mockups-images`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKitMockupsImagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitDetailsRequest} updateKitDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdPut: async (kitId: string, updateKitDetailsRequest: UpdateKitDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kitId' is not null or undefined
            assertParamExists('adminKitsKitIdPut', 'kitId', kitId)
            // verify required parameter 'updateKitDetailsRequest' is not null or undefined
            assertParamExists('adminKitsKitIdPut', 'updateKitDetailsRequest', updateKitDetailsRequest)
            const localVarPath = `/admin/kits/{kitId}`
                .replace('{kitId}', encodeURIComponent(String(kitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateKitDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateKitRequest} createKitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsPost: async (createKitRequest: CreateKitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createKitRequest' is not null or undefined
            assertParamExists('adminKitsPost', 'createKitRequest', createKitRequest)
            const localVarPath = `/admin/kits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createKitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminKitsApi - functional programming interface
 */
export const AdminKitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminKitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eventId 
         * @param {KitPlayerPosition} [playerPosition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsEventsEventIdGet(eventId: string, playerPosition?: KitPlayerPosition, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsEventsEventIdGet(eventId, playerPosition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsEventsEventIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [teamId] 
         * @param {string} [seasonId] 
         * @param {string} [leagueId] 
         * @param {string} [rosterId] 
         * @param {boolean} [isArchived] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsGet(teamId?: string, seasonId?: string, leagueId?: string, rosterId?: string, isArchived?: boolean, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfKitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsGet(teamId, seasonId, leagueId, rosterId, isArchived, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {boolean} [isArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdArchivePatch(kitId: string, isArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdArchivePatch(kitId, isArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdArchivePatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitAssetFilesRequest} updateKitAssetFilesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdAssetsPut(kitId: string, updateKitAssetFilesRequest: UpdateKitAssetFilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdAssetsPut(kitId, updateKitAssetFilesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdAssetsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {BulkUploadKitMockupImagesRequest} bulkUploadKitMockupImagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdBulkUploadMockupsImagesPut(kitId: string, bulkUploadKitMockupImagesRequest: BulkUploadKitMockupImagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdBulkUploadMockupsImagesPut(kitId, bulkUploadKitMockupImagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdBulkUploadMockupsImagesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {boolean} [isMockupArchived] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdGet(kitId: string, isMockupArchived?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdGet(kitId, isMockupArchived, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitMockupsImagesRequest} updateKitMockupsImagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdMockupsImagesPut(kitId: string, updateKitMockupsImagesRequest: UpdateKitMockupsImagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdMockupsImagesPut(kitId, updateKitMockupsImagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdMockupsImagesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kitId 
         * @param {UpdateKitDetailsRequest} updateKitDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsKitIdPut(kitId: string, updateKitDetailsRequest: UpdateKitDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsKitIdPut(kitId, updateKitDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsKitIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateKitRequest} createKitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminKitsPost(createKitRequest: CreateKitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminKitsPost(createKitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminKitsApi.adminKitsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminKitsApi - factory interface
 */
export const AdminKitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminKitsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminKitsApiAdminKitsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsEventsEventIdGet(requestParameters: AdminKitsApiAdminKitsEventsEventIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<KitResponse>> {
            return localVarFp.adminKitsEventsEventIdGet(requestParameters.eventId, requestParameters.playerPosition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsGet(requestParameters: AdminKitsApiAdminKitsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfKitResponse> {
            return localVarFp.adminKitsGet(requestParameters.teamId, requestParameters.seasonId, requestParameters.leagueId, requestParameters.rosterId, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdArchivePatch(requestParameters: AdminKitsApiAdminKitsKitIdArchivePatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitsKitIdArchivePatch(requestParameters.kitId, requestParameters.isArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdAssetsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdAssetsPut(requestParameters: AdminKitsApiAdminKitsKitIdAssetsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitsKitIdAssetsPut(requestParameters.kitId, requestParameters.updateKitAssetFilesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdBulkUploadMockupsImagesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdBulkUploadMockupsImagesPut(requestParameters: AdminKitsApiAdminKitsKitIdBulkUploadMockupsImagesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitsKitIdBulkUploadMockupsImagesPut(requestParameters.kitId, requestParameters.bulkUploadKitMockupImagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdGet(requestParameters: AdminKitsApiAdminKitsKitIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<KitResponse> {
            return localVarFp.adminKitsKitIdGet(requestParameters.kitId, requestParameters.isMockupArchived, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdMockupsImagesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdMockupsImagesPut(requestParameters: AdminKitsApiAdminKitsKitIdMockupsImagesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitsKitIdMockupsImagesPut(requestParameters.kitId, requestParameters.updateKitMockupsImagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsKitIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsKitIdPut(requestParameters: AdminKitsApiAdminKitsKitIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminKitsKitIdPut(requestParameters.kitId, requestParameters.updateKitDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminKitsApiAdminKitsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminKitsPost(requestParameters: AdminKitsApiAdminKitsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminKitsPost(requestParameters.createKitRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminKitsEventsEventIdGet operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsEventsEventIdGetRequest {
    readonly eventId: string

    readonly playerPosition?: KitPlayerPosition
}

/**
 * Request parameters for adminKitsGet operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsGetRequest {
    readonly teamId?: string

    readonly seasonId?: string

    readonly leagueId?: string

    readonly rosterId?: string

    readonly isArchived?: boolean

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminKitsKitIdArchivePatch operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdArchivePatchRequest {
    readonly kitId: string

    readonly isArchived?: boolean
}

/**
 * Request parameters for adminKitsKitIdAssetsPut operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdAssetsPutRequest {
    readonly kitId: string

    readonly updateKitAssetFilesRequest: UpdateKitAssetFilesRequest
}

/**
 * Request parameters for adminKitsKitIdBulkUploadMockupsImagesPut operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdBulkUploadMockupsImagesPutRequest {
    readonly kitId: string

    readonly bulkUploadKitMockupImagesRequest: BulkUploadKitMockupImagesRequest
}

/**
 * Request parameters for adminKitsKitIdGet operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdGetRequest {
    readonly kitId: string

    readonly isMockupArchived?: boolean
}

/**
 * Request parameters for adminKitsKitIdMockupsImagesPut operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdMockupsImagesPutRequest {
    readonly kitId: string

    readonly updateKitMockupsImagesRequest: UpdateKitMockupsImagesRequest
}

/**
 * Request parameters for adminKitsKitIdPut operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsKitIdPutRequest {
    readonly kitId: string

    readonly updateKitDetailsRequest: UpdateKitDetailsRequest
}

/**
 * Request parameters for adminKitsPost operation in AdminKitsApi.
 */
export interface AdminKitsApiAdminKitsPostRequest {
    readonly createKitRequest: CreateKitRequest
}

/**
 * AdminKitsApi - object-oriented interface
 */
export class AdminKitsApi extends BaseAPI {
    /**
     * 
     * @param {AdminKitsApiAdminKitsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsEventsEventIdGet(requestParameters: AdminKitsApiAdminKitsEventsEventIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsEventsEventIdGet(requestParameters.eventId, requestParameters.playerPosition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsGet(requestParameters: AdminKitsApiAdminKitsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsGet(requestParameters.teamId, requestParameters.seasonId, requestParameters.leagueId, requestParameters.rosterId, requestParameters.isArchived, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdArchivePatch(requestParameters: AdminKitsApiAdminKitsKitIdArchivePatchRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdArchivePatch(requestParameters.kitId, requestParameters.isArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdAssetsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdAssetsPut(requestParameters: AdminKitsApiAdminKitsKitIdAssetsPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdAssetsPut(requestParameters.kitId, requestParameters.updateKitAssetFilesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdBulkUploadMockupsImagesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdBulkUploadMockupsImagesPut(requestParameters: AdminKitsApiAdminKitsKitIdBulkUploadMockupsImagesPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdBulkUploadMockupsImagesPut(requestParameters.kitId, requestParameters.bulkUploadKitMockupImagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdGet(requestParameters: AdminKitsApiAdminKitsKitIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdGet(requestParameters.kitId, requestParameters.isMockupArchived, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdMockupsImagesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdMockupsImagesPut(requestParameters: AdminKitsApiAdminKitsKitIdMockupsImagesPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdMockupsImagesPut(requestParameters.kitId, requestParameters.updateKitMockupsImagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsKitIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsKitIdPut(requestParameters: AdminKitsApiAdminKitsKitIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsKitIdPut(requestParameters.kitId, requestParameters.updateKitDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminKitsApiAdminKitsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminKitsPost(requestParameters: AdminKitsApiAdminKitsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminKitsApiFp(this.configuration).adminKitsPost(requestParameters.createKitRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLabelsApi - axios parameter creator
 */
export const AdminLabelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary (Admin) fetches a label by its id
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsLabelIdGet: async (labelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('adminLabelsLabelIdGet', 'labelId', labelId)
            const localVarPath = `/admin/labels/{labelId}`
                .replace('{labelId}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a label
         * @param {string} labelId 
         * @param {UpdateLabelRequestDto} updateLabelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsLabelIdPatch: async (labelId: string, updateLabelRequestDto: UpdateLabelRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('adminLabelsLabelIdPatch', 'labelId', labelId)
            // verify required parameter 'updateLabelRequestDto' is not null or undefined
            assertParamExists('adminLabelsLabelIdPatch', 'updateLabelRequestDto', updateLabelRequestDto)
            const localVarPath = `/admin/labels/{labelId}`
                .replace('{labelId}', encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLabelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a label
         * @param {CreateLabelRequestDto} createLabelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsPost: async (createLabelRequestDto: CreateLabelRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLabelRequestDto' is not null or undefined
            assertParamExists('adminLabelsPost', 'createLabelRequestDto', createLabelRequestDto)
            const localVarPath = `/admin/labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLabelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLabelsApi - functional programming interface
 */
export const AdminLabelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLabelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary (Admin) fetches a label by its id
         * @param {string} labelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLabelsLabelIdGet(labelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLabelsLabelIdGet(labelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLabelsApi.adminLabelsLabelIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a label
         * @param {string} labelId 
         * @param {UpdateLabelRequestDto} updateLabelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLabelsLabelIdPatch(labelId: string, updateLabelRequestDto: UpdateLabelRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LabelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLabelsLabelIdPatch(labelId, updateLabelRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLabelsApi.adminLabelsLabelIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a label
         * @param {CreateLabelRequestDto} createLabelRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLabelsPost(createLabelRequestDto: CreateLabelRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LabelDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLabelsPost(createLabelRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLabelsApi.adminLabelsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLabelsApi - factory interface
 */
export const AdminLabelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLabelsApiFp(configuration)
    return {
        /**
         * 
         * @summary (Admin) fetches a label by its id
         * @param {AdminLabelsApiAdminLabelsLabelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsLabelIdGet(requestParameters: AdminLabelsApiAdminLabelsLabelIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelDto> {
            return localVarFp.adminLabelsLabelIdGet(requestParameters.labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a label
         * @param {AdminLabelsApiAdminLabelsLabelIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsLabelIdPatch(requestParameters: AdminLabelsApiAdminLabelsLabelIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<LabelDto>> {
            return localVarFp.adminLabelsLabelIdPatch(requestParameters.labelId, requestParameters.updateLabelRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a label
         * @param {AdminLabelsApiAdminLabelsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLabelsPost(requestParameters: AdminLabelsApiAdminLabelsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LabelDto> {
            return localVarFp.adminLabelsPost(requestParameters.createLabelRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminLabelsLabelIdGet operation in AdminLabelsApi.
 */
export interface AdminLabelsApiAdminLabelsLabelIdGetRequest {
    readonly labelId: string
}

/**
 * Request parameters for adminLabelsLabelIdPatch operation in AdminLabelsApi.
 */
export interface AdminLabelsApiAdminLabelsLabelIdPatchRequest {
    /**
     * 
     */
    readonly labelId: string

    /**
     * 
     */
    readonly updateLabelRequestDto: UpdateLabelRequestDto
}

/**
 * Request parameters for adminLabelsPost operation in AdminLabelsApi.
 */
export interface AdminLabelsApiAdminLabelsPostRequest {
    /**
     * 
     */
    readonly createLabelRequestDto: CreateLabelRequestDto
}

/**
 * AdminLabelsApi - object-oriented interface
 */
export class AdminLabelsApi extends BaseAPI {
    /**
     * 
     * @summary (Admin) fetches a label by its id
     * @param {AdminLabelsApiAdminLabelsLabelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLabelsLabelIdGet(requestParameters: AdminLabelsApiAdminLabelsLabelIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminLabelsApiFp(this.configuration).adminLabelsLabelIdGet(requestParameters.labelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a label
     * @param {AdminLabelsApiAdminLabelsLabelIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLabelsLabelIdPatch(requestParameters: AdminLabelsApiAdminLabelsLabelIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminLabelsApiFp(this.configuration).adminLabelsLabelIdPatch(requestParameters.labelId, requestParameters.updateLabelRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a label
     * @param {AdminLabelsApiAdminLabelsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminLabelsPost(requestParameters: AdminLabelsApiAdminLabelsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminLabelsApiFp(this.configuration).adminLabelsPost(requestParameters.createLabelRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminMenuHierarchiesApi - axios parameter creator
 */
export const AdminMenuHierarchiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesGet: async (xPlatformKey: string, menuHierarchyIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminMenuHierarchiesGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/menu-hierarchies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (menuHierarchyIds !== undefined) {
                localVarQueryParameter['menuHierarchyIds'] = menuHierarchyIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a menu hierarchy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesIdDelete: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminMenuHierarchiesIdDelete', 'id', id)
            const localVarPath = `/admin/menu-hierarchies/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a menu hierarchy
         * @param {string} id 
         * @param {UpdateMenuHierarchyRequest} updateMenuHierarchyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesIdPut: async (id: string, updateMenuHierarchyRequest: UpdateMenuHierarchyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminMenuHierarchiesIdPut', 'id', id)
            // verify required parameter 'updateMenuHierarchyRequest' is not null or undefined
            assertParamExists('adminMenuHierarchiesIdPut', 'updateMenuHierarchyRequest', updateMenuHierarchyRequest)
            const localVarPath = `/admin/menu-hierarchies/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMenuHierarchyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a menu hierarchy
         * @param {CreateMenuHierarchyRequest} createMenuHierarchyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesPost: async (createMenuHierarchyRequest: CreateMenuHierarchyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMenuHierarchyRequest' is not null or undefined
            assertParamExists('adminMenuHierarchiesPost', 'createMenuHierarchyRequest', createMenuHierarchyRequest)
            const localVarPath = `/admin/menu-hierarchies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMenuHierarchyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMenuHierarchiesApi - functional programming interface
 */
export const AdminMenuHierarchiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMenuHierarchiesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [menuHierarchyIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMenuHierarchiesGet(xPlatformKey: string, menuHierarchyIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminMenuHierarchyTreeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMenuHierarchiesGet(xPlatformKey, menuHierarchyIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMenuHierarchiesApi.adminMenuHierarchiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a menu hierarchy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMenuHierarchiesIdDelete(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMenuHierarchiesIdDelete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMenuHierarchiesApi.adminMenuHierarchiesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a menu hierarchy
         * @param {string} id 
         * @param {UpdateMenuHierarchyRequest} updateMenuHierarchyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMenuHierarchiesIdPut(id: string, updateMenuHierarchyRequest: UpdateMenuHierarchyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMenuHierarchyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMenuHierarchiesIdPut(id, updateMenuHierarchyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMenuHierarchiesApi.adminMenuHierarchiesIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a menu hierarchy
         * @param {CreateMenuHierarchyRequest} createMenuHierarchyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMenuHierarchiesPost(createMenuHierarchyRequest: CreateMenuHierarchyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMenuHierarchyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMenuHierarchiesPost(createMenuHierarchyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminMenuHierarchiesApi.adminMenuHierarchiesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminMenuHierarchiesApi - factory interface
 */
export const AdminMenuHierarchiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMenuHierarchiesApiFp(configuration)
    return {
        /**
         * 
         * @summary List all menu hierarchy trees
         * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesGet(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminMenuHierarchyTreeResponse>> {
            return localVarFp.adminMenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a menu hierarchy
         * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesIdDelete(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminMenuHierarchiesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a menu hierarchy
         * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesIdPut(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMenuHierarchyResponse> {
            return localVarFp.adminMenuHierarchiesIdPut(requestParameters.id, requestParameters.updateMenuHierarchyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a menu hierarchy
         * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMenuHierarchiesPost(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminMenuHierarchyResponse> {
            return localVarFp.adminMenuHierarchiesPost(requestParameters.createMenuHierarchyRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminMenuHierarchiesGet operation in AdminMenuHierarchiesApi.
 */
export interface AdminMenuHierarchiesApiAdminMenuHierarchiesGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly menuHierarchyIds?: string
}

/**
 * Request parameters for adminMenuHierarchiesIdDelete operation in AdminMenuHierarchiesApi.
 */
export interface AdminMenuHierarchiesApiAdminMenuHierarchiesIdDeleteRequest {
    readonly id: string
}

/**
 * Request parameters for adminMenuHierarchiesIdPut operation in AdminMenuHierarchiesApi.
 */
export interface AdminMenuHierarchiesApiAdminMenuHierarchiesIdPutRequest {
    readonly id: string

    readonly updateMenuHierarchyRequest: UpdateMenuHierarchyRequest
}

/**
 * Request parameters for adminMenuHierarchiesPost operation in AdminMenuHierarchiesApi.
 */
export interface AdminMenuHierarchiesApiAdminMenuHierarchiesPostRequest {
    readonly createMenuHierarchyRequest: CreateMenuHierarchyRequest
}

/**
 * AdminMenuHierarchiesApi - object-oriented interface
 */
export class AdminMenuHierarchiesApi extends BaseAPI {
    /**
     * 
     * @summary List all menu hierarchy trees
     * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminMenuHierarchiesGet(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesGetRequest, options?: RawAxiosRequestConfig) {
        return AdminMenuHierarchiesApiFp(this.configuration).adminMenuHierarchiesGet(requestParameters.xPlatformKey, requestParameters.menuHierarchyIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a menu hierarchy
     * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminMenuHierarchiesIdDelete(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return AdminMenuHierarchiesApiFp(this.configuration).adminMenuHierarchiesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a menu hierarchy
     * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminMenuHierarchiesIdPut(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesIdPutRequest, options?: RawAxiosRequestConfig) {
        return AdminMenuHierarchiesApiFp(this.configuration).adminMenuHierarchiesIdPut(requestParameters.id, requestParameters.updateMenuHierarchyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a menu hierarchy
     * @param {AdminMenuHierarchiesApiAdminMenuHierarchiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminMenuHierarchiesPost(requestParameters: AdminMenuHierarchiesApiAdminMenuHierarchiesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminMenuHierarchiesApiFp(this.configuration).adminMenuHierarchiesPost(requestParameters.createMenuHierarchyRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductCategoriesApi - axios parameter creator
 */
export const AdminProductCategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update Product Categories
         * @param {UpdateProductCategoriesRequest} updateProductCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductCategoriesPost: async (updateProductCategoriesRequest: UpdateProductCategoriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProductCategoriesRequest' is not null or undefined
            assertParamExists('adminProductCategoriesPost', 'updateProductCategoriesRequest', updateProductCategoriesRequest)
            const localVarPath = `/admin/product/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductCategoriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductCategoriesApi - functional programming interface
 */
export const AdminProductCategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductCategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update Product Categories
         * @param {UpdateProductCategoriesRequest} updateProductCategoriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductCategoriesPost(updateProductCategoriesRequest: UpdateProductCategoriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductCategoriesPost(updateProductCategoriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductCategoriesApi.adminProductCategoriesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductCategoriesApi - factory interface
 */
export const AdminProductCategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductCategoriesApiFp(configuration)
    return {
        /**
         * 
         * @summary Update Product Categories
         * @param {AdminProductCategoriesApiAdminProductCategoriesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductCategoriesPost(requestParameters: AdminProductCategoriesApiAdminProductCategoriesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductSkuDto> {
            return localVarFp.adminProductCategoriesPost(requestParameters.updateProductCategoriesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminProductCategoriesPost operation in AdminProductCategoriesApi.
 */
export interface AdminProductCategoriesApiAdminProductCategoriesPostRequest {
    readonly updateProductCategoriesRequest: UpdateProductCategoriesRequest
}

/**
 * AdminProductCategoriesApi - object-oriented interface
 */
export class AdminProductCategoriesApi extends BaseAPI {
    /**
     * 
     * @summary Update Product Categories
     * @param {AdminProductCategoriesApiAdminProductCategoriesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductCategoriesPost(requestParameters: AdminProductCategoriesApiAdminProductCategoriesPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductCategoriesApiFp(this.configuration).adminProductCategoriesPost(requestParameters.updateProductCategoriesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductsApi - axios parameter creator
 */
export const AdminProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get product listings by athlete id
         * @param {string} athleteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsAthletesAthleteIdGet: async (athleteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'athleteId' is not null or undefined
            assertParamExists('adminProductsAthletesAthleteIdGet', 'athleteId', athleteId)
            const localVarPath = `/admin/products/athletes/{athleteId}`
                .replace('{athleteId}', encodeURIComponent(String(athleteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a replacement downgrade product for an existing product
         * @param {CreateDowngradeProductRequest} createDowngradeProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsDowngradePost: async (createDowngradeProductRequest: CreateDowngradeProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDowngradeProductRequest' is not null or undefined
            assertParamExists('adminProductsDowngradePost', 'createDowngradeProductRequest', createDowngradeProductRequest)
            const localVarPath = `/admin/products/downgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDowngradeProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get multiple events by product ids
         * @param {string} [skuIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsEventsGet: async (skuIds?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skuIds !== undefined) {
                localVarQueryParameter['skuIds'] = skuIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieves a paginated list of product listings with the ability to search and filter by various criteria. This endpoint is accessible only to admins and allows for listing visibility, event filtering, and sorting.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {string} [productId] 
         * @param {Array<string>} [eventIds] 
         * @param {Array<string>} [categoryIds] 
         * @param {Array<EventStatus>} [eventStatuses] 
         * @param {string} [platformId] 
         * @param {SkuVisibility} [visibility] 
         * @param {string} [endDate] 
         * @param {SortProductListingOn} [sortProductListingOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [salesMethodFilter] 
         * @param {boolean} [hasBids] 
         * @param {number | null} [priceRangeLower] 
         * @param {number | null} [priceRangeUpper] 
         * @param {Array<string>} [shippingOfficeIds] 
         * @param {Array<string>} [productTypeIds] 
         * @param {Array<PublicInventoryLocationType>} [storageLocationTypes] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsGet: async (xPlatformKey: string, searchTerm?: string, productId?: string, eventIds?: Array<string>, categoryIds?: Array<string>, eventStatuses?: Array<EventStatus>, platformId?: string, visibility?: SkuVisibility, endDate?: string, sortProductListingOn?: SortProductListingOn, sortDirection?: SortDirection, salesMethodFilter?: string, hasBids?: boolean, priceRangeLower?: number | null, priceRangeUpper?: number | null, shippingOfficeIds?: Array<string>, productTypeIds?: Array<string>, storageLocationTypes?: Array<PublicInventoryLocationType>, offset?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminProductsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (productId !== undefined) {
                localVarQueryParameter['ProductId'] = productId;
            }

            if (eventIds) {
                localVarQueryParameter['EventIds'] = eventIds;
            }

            if (categoryIds) {
                localVarQueryParameter['CategoryIds'] = categoryIds;
            }

            if (eventStatuses) {
                localVarQueryParameter['EventStatuses'] = eventStatuses;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['PlatformId'] = platformId;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['Visibility'] = visibility;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['EndDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (sortProductListingOn !== undefined) {
                localVarQueryParameter['SortProductListingOn'] = sortProductListingOn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (salesMethodFilter !== undefined) {
                localVarQueryParameter['SalesMethodFilter'] = salesMethodFilter;
            }

            if (hasBids !== undefined) {
                localVarQueryParameter['HasBids'] = hasBids;
            }

            if (priceRangeLower !== undefined) {
                localVarQueryParameter['PriceRange.Lower'] = priceRangeLower;
            }

            if (priceRangeUpper !== undefined) {
                localVarQueryParameter['PriceRange.Upper'] = priceRangeUpper;
            }

            if (shippingOfficeIds) {
                localVarQueryParameter['ShippingOfficeIds'] = shippingOfficeIds;
            }

            if (productTypeIds) {
                localVarQueryParameter['ProductTypeIds'] = productTypeIds;
            }

            if (storageLocationTypes) {
                localVarQueryParameter['StorageLocationTypes'] = storageLocationTypes;
            }

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk update products
         * @param {AdminUpdateMultipleProductListingsRequest} adminUpdateMultipleProductListingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsPatch: async (adminUpdateMultipleProductListingsRequest: AdminUpdateMultipleProductListingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUpdateMultipleProductListingsRequest' is not null or undefined
            assertParamExists('adminProductsPatch', 'adminUpdateMultipleProductListingsRequest', adminUpdateMultipleProductListingsRequest)
            const localVarPath = `/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateMultipleProductListingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a product with a listing
         * @param {CreateProductListingRequest} createProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsPost: async (createProductListingRequest: CreateProductListingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductListingRequest' is not null or undefined
            assertParamExists('adminProductsPost', 'createProductListingRequest', createProductListingRequest)
            const localVarPath = `/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductListingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new listing for a product on an event
         * @param {string} productId 
         * @param {CreateListingForProductRequest} createListingForProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductIdListingsPost: async (productId: string, createListingForProductRequest: CreateListingForProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminProductsProductIdListingsPost', 'productId', productId)
            // verify required parameter 'createListingForProductRequest' is not null or undefined
            assertParamExists('adminProductsProductIdListingsPost', 'createListingForProductRequest', createListingForProductRequest)
            const localVarPath = `/admin/products/{productId}/listings`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createListingForProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the setup progress of a product created via the setup flow
         * @param {string} productId The id of the product
         * @param {UpdateProductSetupProgressRequest} updateProductSetupProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductIdSetupProgressPatch: async (productId: string, updateProductSetupProgressRequest: UpdateProductSetupProgressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('adminProductsProductIdSetupProgressPatch', 'productId', productId)
            // verify required parameter 'updateProductSetupProgressRequest' is not null or undefined
            assertParamExists('adminProductsProductIdSetupProgressPatch', 'updateProductSetupProgressRequest', updateProductSetupProgressRequest)
            const localVarPath = `/admin/products/{productId}/setup-progress`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductSetupProgressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new product listing from an old product listing for a new event
         * @param {string} productListingId 
         * @param {string} eventId 
         * @param {number} [priceInEuroCents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductListingIdEventEventIdPost: async (productListingId: string, eventId: string, priceInEuroCents?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productListingId' is not null or undefined
            assertParamExists('adminProductsProductListingIdEventEventIdPost', 'productListingId', productListingId)
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminProductsProductListingIdEventEventIdPost', 'eventId', eventId)
            const localVarPath = `/admin/products/{productListingId}/event/{eventId}`
                .replace('{productListingId}', encodeURIComponent(String(productListingId)))
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (priceInEuroCents !== undefined) {
                localVarQueryParameter['priceInEuroCents'] = priceInEuroCents;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search products for a given term.
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {string} [searchTerm] Search query to be applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSearchGet: async (offSet?: number, pageSize?: number, searchTerm?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/products/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] get bids by sku id
         * @param {string} skuId The id the sku for which bids should be fetched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdBidsGet: async (skuId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdBidsGet', 'skuId', skuId)
            const localVarPath = `/admin/products/{skuId}/bids`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get admin product sku by id
         * @param {string} skuId the id (guid) of the product which details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdGet: async (skuId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdGet', 'skuId', skuId)
            const localVarPath = `/admin/products/{skuId}`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {string} skuId 
         * @param {UpdateProductSkuRequestDto} updateProductSkuRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPatch: async (skuId: string, updateProductSkuRequestDto: UpdateProductSkuRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdPatch', 'skuId', skuId)
            // verify required parameter 'updateProductSkuRequestDto' is not null or undefined
            assertParamExists('adminProductsSkuIdPatch', 'updateProductSkuRequestDto', updateProductSkuRequestDto)
            const localVarPath = `/admin/products/{skuId}`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductSkuRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a products prices dictionary manually
         * @param {string} skuId 
         * @param {UpdateProductPriceRequest} updateProductPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPricesPatch: async (skuId: string, updateProductPriceRequest: UpdateProductPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdPricesPatch', 'skuId', skuId)
            // verify required parameter 'updateProductPriceRequest' is not null or undefined
            assertParamExists('adminProductsSkuIdPricesPatch', 'updateProductPriceRequest', updateProductPriceRequest)
            const localVarPath = `/admin/products/{skuId}/prices`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] publish a product
         * @param {string} skuId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPublishPatch: async (skuId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdPublishPatch', 'skuId', skuId)
            const localVarPath = `/admin/products/{skuId}/publish`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] unpublish a product
         * @param {string} skuId 
         * @param {UnpublishProductRequest} unpublishProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdUnpublishPatch: async (skuId: string, unpublishProductRequest: UnpublishProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminProductsSkuIdUnpublishPatch', 'skuId', skuId)
            // verify required parameter 'unpublishProductRequest' is not null or undefined
            assertParamExists('adminProductsSkuIdUnpublishPatch', 'unpublishProductRequest', unpublishProductRequest)
            const localVarPath = `/admin/products/{skuId}/unpublish`
                .replace('{skuId}', encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unpublishProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a replacement upgrade product for an existing product
         * @param {CreateUpgradeProductRequest} createUpgradeProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsUpgradePost: async (createUpgradeProductRequest: CreateUpgradeProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUpgradeProductRequest' is not null or undefined
            assertParamExists('adminProductsUpgradePost', 'createUpgradeProductRequest', createUpgradeProductRequest)
            const localVarPath = `/admin/products/upgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUpgradeProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductsApi - functional programming interface
 */
export const AdminProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get product listings by athlete id
         * @param {string} athleteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsAthletesAthleteIdGet(athleteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductSkuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsAthletesAthleteIdGet(athleteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsAthletesAthleteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a replacement downgrade product for an existing product
         * @param {CreateDowngradeProductRequest} createDowngradeProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsDowngradePost(createDowngradeProductRequest: CreateDowngradeProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsDowngradePost(createDowngradeProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsDowngradePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get multiple events by product ids
         * @param {string} [skuIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsEventsGet(skuIds?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductEventDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsEventsGet(skuIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieves a paginated list of product listings with the ability to search and filter by various criteria. This endpoint is accessible only to admins and allows for listing visibility, event filtering, and sorting.
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [searchTerm] 
         * @param {string} [productId] 
         * @param {Array<string>} [eventIds] 
         * @param {Array<string>} [categoryIds] 
         * @param {Array<EventStatus>} [eventStatuses] 
         * @param {string} [platformId] 
         * @param {SkuVisibility} [visibility] 
         * @param {string} [endDate] 
         * @param {SortProductListingOn} [sortProductListingOn] 
         * @param {SortDirection} [sortDirection] 
         * @param {string} [salesMethodFilter] 
         * @param {boolean} [hasBids] 
         * @param {number | null} [priceRangeLower] 
         * @param {number | null} [priceRangeUpper] 
         * @param {Array<string>} [shippingOfficeIds] 
         * @param {Array<string>} [productTypeIds] 
         * @param {Array<PublicInventoryLocationType>} [storageLocationTypes] 
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsGet(xPlatformKey: string, searchTerm?: string, productId?: string, eventIds?: Array<string>, categoryIds?: Array<string>, eventStatuses?: Array<EventStatus>, platformId?: string, visibility?: SkuVisibility, endDate?: string, sortProductListingOn?: SortProductListingOn, sortDirection?: SortDirection, salesMethodFilter?: string, hasBids?: boolean, priceRangeLower?: number | null, priceRangeUpper?: number | null, shippingOfficeIds?: Array<string>, productTypeIds?: Array<string>, storageLocationTypes?: Array<PublicInventoryLocationType>, offset?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsGet(xPlatformKey, searchTerm, productId, eventIds, categoryIds, eventStatuses, platformId, visibility, endDate, sortProductListingOn, sortDirection, salesMethodFilter, hasBids, priceRangeLower, priceRangeUpper, shippingOfficeIds, productTypeIds, storageLocationTypes, offset, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk update products
         * @param {AdminUpdateMultipleProductListingsRequest} adminUpdateMultipleProductListingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsPatch(adminUpdateMultipleProductListingsRequest: AdminUpdateMultipleProductListingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductSkuDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsPatch(adminUpdateMultipleProductListingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a product with a listing
         * @param {CreateProductListingRequest} createProductListingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsPost(createProductListingRequest: CreateProductListingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsPost(createProductListingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new listing for a product on an event
         * @param {string} productId 
         * @param {CreateListingForProductRequest} createListingForProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsProductIdListingsPost(productId: string, createListingForProductRequest: CreateListingForProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsProductIdListingsPost(productId, createListingForProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsProductIdListingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the setup progress of a product created via the setup flow
         * @param {string} productId The id of the product
         * @param {UpdateProductSetupProgressRequest} updateProductSetupProgressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsProductIdSetupProgressPatch(productId: string, updateProductSetupProgressRequest: UpdateProductSetupProgressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsProductIdSetupProgressPatch(productId, updateProductSetupProgressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsProductIdSetupProgressPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new product listing from an old product listing for a new event
         * @param {string} productListingId 
         * @param {string} eventId 
         * @param {number} [priceInEuroCents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsProductListingIdEventEventIdPost(productListingId: string, eventId: string, priceInEuroCents?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsProductListingIdEventEventIdPost(productListingId, eventId, priceInEuroCents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsProductListingIdEventEventIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search products for a given term.
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {string} [searchTerm] Search query to be applied
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSearchGet(offSet?: number, pageSize?: number, searchTerm?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfAdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSearchGet(offSet, pageSize, searchTerm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] get bids by sku id
         * @param {string} skuId The id the sku for which bids should be fetched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdBidsGet(skuId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminBidDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdBidsGet(skuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdBidsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get admin product sku by id
         * @param {string} skuId the id (guid) of the product which details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdGet(skuId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdGet(skuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {string} skuId 
         * @param {UpdateProductSkuRequestDto} updateProductSkuRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdPatch(skuId: string, updateProductSkuRequestDto: UpdateProductSkuRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdPatch(skuId, updateProductSkuRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a products prices dictionary manually
         * @param {string} skuId 
         * @param {UpdateProductPriceRequest} updateProductPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdPricesPatch(skuId: string, updateProductPriceRequest: UpdateProductPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ValidationFailure>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdPricesPatch(skuId, updateProductPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdPricesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] publish a product
         * @param {string} skuId The id of the event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdPublishPatch(skuId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdPublishPatch(skuId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdPublishPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] unpublish a product
         * @param {string} skuId 
         * @param {UnpublishProductRequest} unpublishProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsSkuIdUnpublishPatch(skuId: string, unpublishProductRequest: UnpublishProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsSkuIdUnpublishPatch(skuId, unpublishProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsSkuIdUnpublishPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a replacement upgrade product for an existing product
         * @param {CreateUpgradeProductRequest} createUpgradeProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminProductsUpgradePost(createUpgradeProductRequest: CreateUpgradeProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminProductsUpgradePost(createUpgradeProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductsApi.adminProductsUpgradePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductsApi - factory interface
 */
export const AdminProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get product listings by athlete id
         * @param {AdminProductsApiAdminProductsAthletesAthleteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsAthletesAthleteIdGet(requestParameters: AdminProductsApiAdminProductsAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSkuDto>> {
            return localVarFp.adminProductsAthletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a replacement downgrade product for an existing product
         * @param {AdminProductsApiAdminProductsDowngradePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsDowngradePost(requestParameters: AdminProductsApiAdminProductsDowngradePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminProductsDowngradePost(requestParameters.createDowngradeProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get multiple events by product ids
         * @param {AdminProductsApiAdminProductsEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsEventsGet(requestParameters: AdminProductsApiAdminProductsEventsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductEventDto>> {
            return localVarFp.adminProductsEventsGet(requestParameters.skuIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieves a paginated list of product listings with the ability to search and filter by various criteria. This endpoint is accessible only to admins and allows for listing visibility, event filtering, and sorting.
         * @param {AdminProductsApiAdminProductsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsGet(requestParameters: AdminProductsApiAdminProductsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminProductSkuDto> {
            return localVarFp.adminProductsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.productId, requestParameters.eventIds, requestParameters.categoryIds, requestParameters.eventStatuses, requestParameters.platformId, requestParameters.visibility, requestParameters.endDate, requestParameters.sortProductListingOn, requestParameters.sortDirection, requestParameters.salesMethodFilter, requestParameters.hasBids, requestParameters.priceRangeLower, requestParameters.priceRangeUpper, requestParameters.shippingOfficeIds, requestParameters.productTypeIds, requestParameters.storageLocationTypes, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk update products
         * @param {AdminProductsApiAdminProductsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsPatch(requestParameters: AdminProductsApiAdminProductsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSkuDto>> {
            return localVarFp.adminProductsPatch(requestParameters.adminUpdateMultipleProductListingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a product with a listing
         * @param {AdminProductsApiAdminProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsPost(requestParameters: AdminProductsApiAdminProductsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminProductsPost(requestParameters.createProductListingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new listing for a product on an event
         * @param {AdminProductsApiAdminProductsProductIdListingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductIdListingsPost(requestParameters: AdminProductsApiAdminProductsProductIdListingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminProductsProductIdListingsPost(requestParameters.productId, requestParameters.createListingForProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the setup progress of a product created via the setup flow
         * @param {AdminProductsApiAdminProductsProductIdSetupProgressPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductIdSetupProgressPatch(requestParameters: AdminProductsApiAdminProductsProductIdSetupProgressPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminProductsProductIdSetupProgressPatch(requestParameters.productId, requestParameters.updateProductSetupProgressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new product listing from an old product listing for a new event
         * @param {AdminProductsApiAdminProductsProductListingIdEventEventIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsProductListingIdEventEventIdPost(requestParameters: AdminProductsApiAdminProductsProductListingIdEventEventIdPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminProductsProductListingIdEventEventIdPost(requestParameters.productListingId, requestParameters.eventId, requestParameters.priceInEuroCents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search products for a given term.
         * @param {AdminProductsApiAdminProductsSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSearchGet(requestParameters: AdminProductsApiAdminProductsSearchGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfAdminProductSkuDto> {
            return localVarFp.adminProductsSearchGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] get bids by sku id
         * @param {AdminProductsApiAdminProductsSkuIdBidsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdBidsGet(requestParameters: AdminProductsApiAdminProductsSkuIdBidsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminBidDto>> {
            return localVarFp.adminProductsSkuIdBidsGet(requestParameters.skuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get admin product sku by id
         * @param {AdminProductsApiAdminProductsSkuIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdGet(requestParameters: AdminProductsApiAdminProductsSkuIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductSkuDto> {
            return localVarFp.adminProductsSkuIdGet(requestParameters.skuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates some parts of the product
         * @param {AdminProductsApiAdminProductsSkuIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductSkuDto> {
            return localVarFp.adminProductsSkuIdPatch(requestParameters.skuId, requestParameters.updateProductSkuRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a products prices dictionary manually
         * @param {AdminProductsApiAdminProductsSkuIdPricesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPricesPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPricesPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ValidationFailure>> {
            return localVarFp.adminProductsSkuIdPricesPatch(requestParameters.skuId, requestParameters.updateProductPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] publish a product
         * @param {AdminProductsApiAdminProductsSkuIdPublishPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdPublishPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPublishPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSkuDto> {
            return localVarFp.adminProductsSkuIdPublishPatch(requestParameters.skuId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] unpublish a product
         * @param {AdminProductsApiAdminProductsSkuIdUnpublishPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsSkuIdUnpublishPatch(requestParameters: AdminProductsApiAdminProductsSkuIdUnpublishPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSkuDto> {
            return localVarFp.adminProductsSkuIdUnpublishPatch(requestParameters.skuId, requestParameters.unpublishProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a replacement upgrade product for an existing product
         * @param {AdminProductsApiAdminProductsUpgradePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsUpgradePost(requestParameters: AdminProductsApiAdminProductsUpgradePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminProductsUpgradePost(requestParameters.createUpgradeProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminProductsAthletesAthleteIdGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsAthletesAthleteIdGetRequest {
    /**
     * 
     */
    readonly athleteId: string
}

/**
 * Request parameters for adminProductsDowngradePost operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsDowngradePostRequest {
    readonly createDowngradeProductRequest: CreateDowngradeProductRequest
}

/**
 * Request parameters for adminProductsEventsGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsEventsGetRequest {
    /**
     * 
     */
    readonly skuIds?: string
}

/**
 * Request parameters for adminProductsGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly searchTerm?: string

    readonly productId?: string

    readonly eventIds?: Array<string>

    readonly categoryIds?: Array<string>

    readonly eventStatuses?: Array<EventStatus>

    readonly platformId?: string

    readonly visibility?: SkuVisibility

    readonly endDate?: string

    readonly sortProductListingOn?: SortProductListingOn

    readonly sortDirection?: SortDirection

    readonly salesMethodFilter?: string

    readonly hasBids?: boolean

    readonly priceRangeLower?: number | null

    readonly priceRangeUpper?: number | null

    readonly shippingOfficeIds?: Array<string>

    readonly productTypeIds?: Array<string>

    readonly storageLocationTypes?: Array<PublicInventoryLocationType>

    readonly offset?: number

    readonly pageSize?: number
}

/**
 * Request parameters for adminProductsPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsPatchRequest {
    /**
     * 
     */
    readonly adminUpdateMultipleProductListingsRequest: AdminUpdateMultipleProductListingsRequest
}

/**
 * Request parameters for adminProductsPost operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsPostRequest {
    readonly createProductListingRequest: CreateProductListingRequest
}

/**
 * Request parameters for adminProductsProductIdListingsPost operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsProductIdListingsPostRequest {
    readonly productId: string

    readonly createListingForProductRequest: CreateListingForProductRequest
}

/**
 * Request parameters for adminProductsProductIdSetupProgressPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsProductIdSetupProgressPatchRequest {
    /**
     * The id of the product
     */
    readonly productId: string

    /**
     * 
     */
    readonly updateProductSetupProgressRequest: UpdateProductSetupProgressRequest
}

/**
 * Request parameters for adminProductsProductListingIdEventEventIdPost operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsProductListingIdEventEventIdPostRequest {
    readonly productListingId: string

    readonly eventId: string

    readonly priceInEuroCents?: number
}

/**
 * Request parameters for adminProductsSearchGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSearchGetRequest {
    /**
     * The amount of items to skip
     */
    readonly offSet?: number

    /**
     * The maximum size of any individual subset
     */
    readonly pageSize?: number

    /**
     * Search query to be applied
     */
    readonly searchTerm?: string
}

/**
 * Request parameters for adminProductsSkuIdBidsGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdBidsGetRequest {
    /**
     * The id the sku for which bids should be fetched.
     */
    readonly skuId: string
}

/**
 * Request parameters for adminProductsSkuIdGet operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdGetRequest {
    /**
     * the id (guid) of the product which details are to be fetched
     */
    readonly skuId: string
}

/**
 * Request parameters for adminProductsSkuIdPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdPatchRequest {
    /**
     * 
     */
    readonly skuId: string

    /**
     * 
     */
    readonly updateProductSkuRequestDto: UpdateProductSkuRequestDto
}

/**
 * Request parameters for adminProductsSkuIdPricesPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdPricesPatchRequest {
    readonly skuId: string

    readonly updateProductPriceRequest: UpdateProductPriceRequest
}

/**
 * Request parameters for adminProductsSkuIdPublishPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdPublishPatchRequest {
    /**
     * The id of the event
     */
    readonly skuId: string
}

/**
 * Request parameters for adminProductsSkuIdUnpublishPatch operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsSkuIdUnpublishPatchRequest {
    readonly skuId: string

    readonly unpublishProductRequest: UnpublishProductRequest
}

/**
 * Request parameters for adminProductsUpgradePost operation in AdminProductsApi.
 */
export interface AdminProductsApiAdminProductsUpgradePostRequest {
    readonly createUpgradeProductRequest: CreateUpgradeProductRequest
}

/**
 * AdminProductsApi - object-oriented interface
 */
export class AdminProductsApi extends BaseAPI {
    /**
     * 
     * @summary Get product listings by athlete id
     * @param {AdminProductsApiAdminProductsAthletesAthleteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsAthletesAthleteIdGet(requestParameters: AdminProductsApiAdminProductsAthletesAthleteIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsAthletesAthleteIdGet(requestParameters.athleteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a replacement downgrade product for an existing product
     * @param {AdminProductsApiAdminProductsDowngradePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsDowngradePost(requestParameters: AdminProductsApiAdminProductsDowngradePostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsDowngradePost(requestParameters.createDowngradeProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get multiple events by product ids
     * @param {AdminProductsApiAdminProductsEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsEventsGet(requestParameters: AdminProductsApiAdminProductsEventsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsEventsGet(requestParameters.skuIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieves a paginated list of product listings with the ability to search and filter by various criteria. This endpoint is accessible only to admins and allows for listing visibility, event filtering, and sorting.
     * @param {AdminProductsApiAdminProductsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsGet(requestParameters: AdminProductsApiAdminProductsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsGet(requestParameters.xPlatformKey, requestParameters.searchTerm, requestParameters.productId, requestParameters.eventIds, requestParameters.categoryIds, requestParameters.eventStatuses, requestParameters.platformId, requestParameters.visibility, requestParameters.endDate, requestParameters.sortProductListingOn, requestParameters.sortDirection, requestParameters.salesMethodFilter, requestParameters.hasBids, requestParameters.priceRangeLower, requestParameters.priceRangeUpper, requestParameters.shippingOfficeIds, requestParameters.productTypeIds, requestParameters.storageLocationTypes, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk update products
     * @param {AdminProductsApiAdminProductsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsPatch(requestParameters: AdminProductsApiAdminProductsPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsPatch(requestParameters.adminUpdateMultipleProductListingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a product with a listing
     * @param {AdminProductsApiAdminProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsPost(requestParameters: AdminProductsApiAdminProductsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsPost(requestParameters.createProductListingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new listing for a product on an event
     * @param {AdminProductsApiAdminProductsProductIdListingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsProductIdListingsPost(requestParameters: AdminProductsApiAdminProductsProductIdListingsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsProductIdListingsPost(requestParameters.productId, requestParameters.createListingForProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the setup progress of a product created via the setup flow
     * @param {AdminProductsApiAdminProductsProductIdSetupProgressPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsProductIdSetupProgressPatch(requestParameters: AdminProductsApiAdminProductsProductIdSetupProgressPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsProductIdSetupProgressPatch(requestParameters.productId, requestParameters.updateProductSetupProgressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new product listing from an old product listing for a new event
     * @param {AdminProductsApiAdminProductsProductListingIdEventEventIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsProductListingIdEventEventIdPost(requestParameters: AdminProductsApiAdminProductsProductListingIdEventEventIdPostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsProductListingIdEventEventIdPost(requestParameters.productListingId, requestParameters.eventId, requestParameters.priceInEuroCents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search products for a given term.
     * @param {AdminProductsApiAdminProductsSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSearchGet(requestParameters: AdminProductsApiAdminProductsSearchGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSearchGet(requestParameters.offSet, requestParameters.pageSize, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] get bids by sku id
     * @param {AdminProductsApiAdminProductsSkuIdBidsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdBidsGet(requestParameters: AdminProductsApiAdminProductsSkuIdBidsGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdBidsGet(requestParameters.skuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get admin product sku by id
     * @param {AdminProductsApiAdminProductsSkuIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdGet(requestParameters: AdminProductsApiAdminProductsSkuIdGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdGet(requestParameters.skuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates some parts of the product
     * @param {AdminProductsApiAdminProductsSkuIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdPatch(requestParameters.skuId, requestParameters.updateProductSkuRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a products prices dictionary manually
     * @param {AdminProductsApiAdminProductsSkuIdPricesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdPricesPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPricesPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdPricesPatch(requestParameters.skuId, requestParameters.updateProductPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] publish a product
     * @param {AdminProductsApiAdminProductsSkuIdPublishPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdPublishPatch(requestParameters: AdminProductsApiAdminProductsSkuIdPublishPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdPublishPatch(requestParameters.skuId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] unpublish a product
     * @param {AdminProductsApiAdminProductsSkuIdUnpublishPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsSkuIdUnpublishPatch(requestParameters: AdminProductsApiAdminProductsSkuIdUnpublishPatchRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsSkuIdUnpublishPatch(requestParameters.skuId, requestParameters.unpublishProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a replacement upgrade product for an existing product
     * @param {AdminProductsApiAdminProductsUpgradePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminProductsUpgradePost(requestParameters: AdminProductsApiAdminProductsUpgradePostRequest, options?: RawAxiosRequestConfig) {
        return AdminProductsApiFp(this.configuration).adminProductsUpgradePost(requestParameters.createUpgradeProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminUploadsApi - axios parameter creator
 */
export const AdminUploadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [documentUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadProtectedUrlGet: async (documentUrl?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/download-protected-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (documentUrl !== undefined) {
                localVarQueryParameter['documentUrl'] = documentUrl;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Admin] Returns a presigned URL to upload a file to a temporary location. The url is valid for one hour.
         * @param {GeneratePreSignedUrlRequest} generatePreSignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadsPost: async (generatePreSignedUrlRequest: GeneratePreSignedUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generatePreSignedUrlRequest' is not null or undefined
            assertParamExists('adminUploadsPost', 'generatePreSignedUrlRequest', generatePreSignedUrlRequest)
            const localVarPath = `/admin/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatePreSignedUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUploadsApi - functional programming interface
 */
export const AdminUploadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUploadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [documentUrl] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminDownloadProtectedUrlGet(documentUrl?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminDownloadProtectedUrlGet(documentUrl, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUploadsApi.adminDownloadProtectedUrlGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Admin] Returns a presigned URL to upload a file to a temporary location. The url is valid for one hour.
         * @param {GeneratePreSignedUrlRequest} generatePreSignedUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUploadsPost(generatePreSignedUrlRequest: GeneratePreSignedUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUploadsPost(generatePreSignedUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUploadsApi.adminUploadsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUploadsApi - factory interface
 */
export const AdminUploadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUploadsApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminUploadsApiAdminDownloadProtectedUrlGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDownloadProtectedUrlGet(requestParameters: AdminUploadsApiAdminDownloadProtectedUrlGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminDownloadProtectedUrlGet(requestParameters.documentUrl, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Admin] Returns a presigned URL to upload a file to a temporary location. The url is valid for one hour.
         * @param {AdminUploadsApiAdminUploadsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadsPost(requestParameters: AdminUploadsApiAdminUploadsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminUploadsPost(requestParameters.generatePreSignedUrlRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminDownloadProtectedUrlGet operation in AdminUploadsApi.
 */
export interface AdminUploadsApiAdminDownloadProtectedUrlGetRequest {
    readonly documentUrl?: string
}

/**
 * Request parameters for adminUploadsPost operation in AdminUploadsApi.
 */
export interface AdminUploadsApiAdminUploadsPostRequest {
    /**
     * 
     */
    readonly generatePreSignedUrlRequest: GeneratePreSignedUrlRequest
}

/**
 * AdminUploadsApi - object-oriented interface
 */
export class AdminUploadsApi extends BaseAPI {
    /**
     * 
     * @param {AdminUploadsApiAdminDownloadProtectedUrlGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminDownloadProtectedUrlGet(requestParameters: AdminUploadsApiAdminDownloadProtectedUrlGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUploadsApiFp(this.configuration).adminDownloadProtectedUrlGet(requestParameters.documentUrl, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Admin] Returns a presigned URL to upload a file to a temporary location. The url is valid for one hour.
     * @param {AdminUploadsApiAdminUploadsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminUploadsPost(requestParameters: AdminUploadsApiAdminUploadsPostRequest, options?: RawAxiosRequestConfig) {
        return AdminUploadsApiFp(this.configuration).adminUploadsPost(requestParameters.generatePreSignedUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BeneficiaryApi - axios parameter creator
 */
export const BeneficiaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get all beneficiaries
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiariesGet: async (offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/beneficiaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BeneficiaryApi - functional programming interface
 */
export const BeneficiaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BeneficiaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get all beneficiaries
         * @param {number} [offSet] The amount of items to skip
         * @param {number} [pageSize] The maximum size of any individual subset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async beneficiariesGet(offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfBeneficiaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.beneficiariesGet(offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BeneficiaryApi.beneficiariesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BeneficiaryApi - factory interface
 */
export const BeneficiaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BeneficiaryApiFp(configuration)
    return {
        /**
         * 
         * @summary get all beneficiaries
         * @param {BeneficiaryApiBeneficiariesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        beneficiariesGet(requestParameters: BeneficiaryApiBeneficiariesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfBeneficiaryDto> {
            return localVarFp.beneficiariesGet(requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for beneficiariesGet operation in BeneficiaryApi.
 */
export interface BeneficiaryApiBeneficiariesGetRequest {
    /**
     * The amount of items to skip
     */
    readonly offSet?: number

    /**
     * The maximum size of any individual subset
     */
    readonly pageSize?: number
}

/**
 * BeneficiaryApi - object-oriented interface
 */
export class BeneficiaryApi extends BaseAPI {
    /**
     * 
     * @summary get all beneficiaries
     * @param {BeneficiaryApiBeneficiariesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public beneficiariesGet(requestParameters: BeneficiaryApiBeneficiariesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return BeneficiaryApiFp(this.configuration).beneficiariesGet(requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryHighlightedEventApi - axios parameter creator
 */
export const CategoryHighlightedEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} categoryId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdHighlightedEventsDelete: async (categoryId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdHighlightedEventsDelete', 'categoryId', categoryId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdHighlightedEventsDelete', 'body', body)
            const localVarPath = `/admin/categories/{categoryId}/highlighted-events`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdHighlightedEventsPost: async (categoryId: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdHighlightedEventsPost', 'categoryId', categoryId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminCategoriesCategoryIdHighlightedEventsPost', 'body', body)
            const localVarPath = `/admin/categories/{categoryId}/highlighted-events`
                .replace('{categoryId}', encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryHighlightedEventApi - functional programming interface
 */
export const CategoryHighlightedEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryHighlightedEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} categoryId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdHighlightedEventsDelete(categoryId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdHighlightedEventsDelete(categoryId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryHighlightedEventApi.adminCategoriesCategoryIdHighlightedEventsDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} categoryId 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminCategoriesCategoryIdHighlightedEventsPost(categoryId: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminCategoriesCategoryIdHighlightedEventsPost(categoryId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryHighlightedEventApi.adminCategoriesCategoryIdHighlightedEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryHighlightedEventApi - factory interface
 */
export const CategoryHighlightedEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryHighlightedEventApiFp(configuration)
    return {
        /**
         * 
         * @param {CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdHighlightedEventsDelete(requestParameters: CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCategoriesCategoryIdHighlightedEventsDelete(requestParameters.categoryId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCategoriesCategoryIdHighlightedEventsPost(requestParameters: CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminCategoriesCategoryIdHighlightedEventsPost(requestParameters.categoryId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminCategoriesCategoryIdHighlightedEventsDelete operation in CategoryHighlightedEventApi.
 */
export interface CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsDeleteRequest {
    readonly categoryId: string

    readonly body: string
}

/**
 * Request parameters for adminCategoriesCategoryIdHighlightedEventsPost operation in CategoryHighlightedEventApi.
 */
export interface CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsPostRequest {
    readonly categoryId: string

    readonly body: string
}

/**
 * CategoryHighlightedEventApi - object-oriented interface
 */
export class CategoryHighlightedEventApi extends BaseAPI {
    /**
     * 
     * @param {CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdHighlightedEventsDelete(requestParameters: CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsDeleteRequest, options?: RawAxiosRequestConfig) {
        return CategoryHighlightedEventApiFp(this.configuration).adminCategoriesCategoryIdHighlightedEventsDelete(requestParameters.categoryId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminCategoriesCategoryIdHighlightedEventsPost(requestParameters: CategoryHighlightedEventApiAdminCategoriesCategoryIdHighlightedEventsPostRequest, options?: RawAxiosRequestConfig) {
        return CategoryHighlightedEventApiFp(this.configuration).adminCategoriesCategoryIdHighlightedEventsPost(requestParameters.categoryId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChannableProductsApi - axios parameter creator
 */
export const ChannableProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channableEventsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/channable/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channableProductsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/channable/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChannableProductsApi - functional programming interface
 */
export const ChannableProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChannableProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async channableEventsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChannableEventFeedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.channableEventsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannableProductsApi.channableEventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async channableProductsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChannableProductFeedDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.channableProductsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChannableProductsApi.channableProductsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChannableProductsApi - factory interface
 */
export const ChannableProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChannableProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channableEventsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ChannableEventFeedDto>> {
            return localVarFp.channableEventsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns channable products json response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        channableProductsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ChannableProductFeedDto>> {
            return localVarFp.channableProductsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChannableProductsApi - object-oriented interface
 */
export class ChannableProductsApi extends BaseAPI {
    /**
     * 
     * @summary Returns channable products json response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public channableEventsGet(options?: RawAxiosRequestConfig) {
        return ChannableProductsApiFp(this.configuration).channableEventsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns channable products json response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public channableProductsGet(options?: RawAxiosRequestConfig) {
        return ChannableProductsApiFp(this.configuration).channableProductsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CronApi - axios parameter creator
 */
export const CronApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [CronJob] Create events and projects in Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventsAndProjectsInOdooPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/create-events-and-projects-in-odoo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] Expires offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireOffersPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/expire-offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] expire sold skus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiresoldskusPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/expiresoldskus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] finish events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finisheventsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/finishevents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] Recreate partner sandbox fixtures after a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayPartnerSandboxFixturesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/replay-partner-sandbox-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] send event ending emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendendingeventsemailsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sendendingeventsemails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] Snapshot the live events of partner sandbox partners before a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotPartnerSandboxFixturesPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/snapshot-partner-sandbox-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [CronJob] Updates quick bidder availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuickBidderAvailabilityPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/update-quick-bidder-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CronApi - functional programming interface
 */
export const CronApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CronApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [CronJob] Create events and projects in Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventsAndProjectsInOdooPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventsAndProjectsInOdooPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.createEventsAndProjectsInOdooPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] Expires offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expireOffersPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expireOffersPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.expireOffersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] expire sold skus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expiresoldskusPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expiresoldskusPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.expiresoldskusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] finish events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finisheventsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finisheventsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.finisheventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] Recreate partner sandbox fixtures after a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replayPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerSandboxReplaySummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replayPartnerSandboxFixturesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.replayPartnerSandboxFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] send event ending emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendendingeventsemailsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendendingeventsemailsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.sendendingeventsemailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] Snapshot the live events of partner sandbox partners before a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async snapshotPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerSandboxSnapshotSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.snapshotPartnerSandboxFixturesPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.snapshotPartnerSandboxFixturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [CronJob] Updates quick bidder availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuickBidderAvailabilityPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuickBidderAvailabilityPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CronApi.updateQuickBidderAvailabilityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CronApi - factory interface
 */
export const CronApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CronApiFp(configuration)
    return {
        /**
         * 
         * @summary [CronJob] Create events and projects in Odoo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventsAndProjectsInOdooPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createEventsAndProjectsInOdooPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] Expires offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireOffersPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.expireOffersPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] expire sold skus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expiresoldskusPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.expiresoldskusPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] finish events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finisheventsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.finisheventsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] Recreate partner sandbox fixtures after a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replayPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig): AxiosPromise<PartnerSandboxReplaySummary> {
            return localVarFp.replayPartnerSandboxFixturesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] send event ending emails
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendendingeventsemailsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendendingeventsemailsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] Snapshot the live events of partner sandbox partners before a staging restore; no-op elsewhere
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        snapshotPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig): AxiosPromise<PartnerSandboxSnapshotSummary> {
            return localVarFp.snapshotPartnerSandboxFixturesPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [CronJob] Updates quick bidder availability
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuickBidderAvailabilityPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateQuickBidderAvailabilityPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CronApi - object-oriented interface
 */
export class CronApi extends BaseAPI {
    /**
     * 
     * @summary [CronJob] Create events and projects in Odoo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEventsAndProjectsInOdooPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).createEventsAndProjectsInOdooPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] Expires offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public expireOffersPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).expireOffersPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] expire sold skus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public expiresoldskusPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).expiresoldskusPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] finish events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public finisheventsPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).finisheventsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] Recreate partner sandbox fixtures after a staging restore; no-op elsewhere
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public replayPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).replayPartnerSandboxFixturesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] send event ending emails
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sendendingeventsemailsPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).sendendingeventsemailsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] Snapshot the live events of partner sandbox partners before a staging restore; no-op elsewhere
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public snapshotPartnerSandboxFixturesPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).snapshotPartnerSandboxFixturesPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [CronJob] Updates quick bidder availability
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateQuickBidderAvailabilityPost(options?: RawAxiosRequestConfig) {
        return CronApiFp(this.configuration).updateQuickBidderAvailabilityPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeveloperEventsApi - axios parameter creator
 */
export const DeveloperEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [Developer] Trigger ExpireSoldSkusAsync cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsCronExpireSoldSkusPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/developer/events/cron/expireSoldSkus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Developer] Trigger FinishEvents cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsCronFinishEventsPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/developer/events/cron/finishEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Developer] Define what platforms an event should be published on
         * @param {string} eventId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsEventIdUpdatePlatformsPatch: async (eventId: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('developerEventsEventIdUpdatePlatformsPatch', 'eventId', eventId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('developerEventsEventIdUpdatePlatformsPatch', 'requestBody', requestBody)
            const localVarPath = `/developer/events/{eventId}/update-platforms`
                .replace('{eventId}', encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeveloperEventsApi - functional programming interface
 */
export const DeveloperEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeveloperEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [Developer] Trigger ExpireSoldSkusAsync cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerEventsCronExpireSoldSkusPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerEventsCronExpireSoldSkusPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperEventsApi.developerEventsCronExpireSoldSkusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Developer] Trigger FinishEvents cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerEventsCronFinishEventsPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerEventsCronFinishEventsPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperEventsApi.developerEventsCronFinishEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Developer] Define what platforms an event should be published on
         * @param {string} eventId 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async developerEventsEventIdUpdatePlatformsPatch(eventId: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.developerEventsEventIdUpdatePlatformsPatch(eventId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeveloperEventsApi.developerEventsEventIdUpdatePlatformsPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeveloperEventsApi - factory interface
 */
export const DeveloperEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeveloperEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary [Developer] Trigger ExpireSoldSkusAsync cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsCronExpireSoldSkusPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.developerEventsCronExpireSoldSkusPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Developer] Trigger FinishEvents cron job manually
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsCronFinishEventsPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.developerEventsCronFinishEventsPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Developer] Define what platforms an event should be published on
         * @param {DeveloperEventsApiDeveloperEventsEventIdUpdatePlatformsPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        developerEventsEventIdUpdatePlatformsPatch(requestParameters: DeveloperEventsApiDeveloperEventsEventIdUpdatePlatformsPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.developerEventsEventIdUpdatePlatformsPatch(requestParameters.eventId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for developerEventsEventIdUpdatePlatformsPatch operation in DeveloperEventsApi.
 */
export interface DeveloperEventsApiDeveloperEventsEventIdUpdatePlatformsPatchRequest {
    readonly eventId: string

    readonly requestBody: Array<string>
}

/**
 * DeveloperEventsApi - object-oriented interface
 */
export class DeveloperEventsApi extends BaseAPI {
    /**
     * 
     * @summary [Developer] Trigger ExpireSoldSkusAsync cron job manually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public developerEventsCronExpireSoldSkusPost(options?: RawAxiosRequestConfig) {
        return DeveloperEventsApiFp(this.configuration).developerEventsCronExpireSoldSkusPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Developer] Trigger FinishEvents cron job manually
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public developerEventsCronFinishEventsPost(options?: RawAxiosRequestConfig) {
        return DeveloperEventsApiFp(this.configuration).developerEventsCronFinishEventsPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Developer] Define what platforms an event should be published on
     * @param {DeveloperEventsApiDeveloperEventsEventIdUpdatePlatformsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public developerEventsEventIdUpdatePlatformsPatch(requestParameters: DeveloperEventsApiDeveloperEventsEventIdUpdatePlatformsPatchRequest, options?: RawAxiosRequestConfig) {
        return DeveloperEventsApiFp(this.configuration).developerEventsEventIdUpdatePlatformsPatch(requestParameters.eventId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsApi - axios parameter creator
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the events progress with contract
         * @param {string} contractId The id of the contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsContractContractIdProgressGet: async (contractId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('eventsContractContractIdProgressGet', 'contractId', contractId)
            const localVarPath = `/events/contract/{contractId}/progress`
                .replace('{contractId}', encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * accepts both both event id and slug returned DTO extends upon EventCategoryDto depending on which EventType is returned. The following types map to the following DTO: So it will have categories with the event
         * @summary get the details of a single event
         * @param {string} eventIdentifier The id or slug of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdentifierGet: async (eventIdentifier: string, xPlatformKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventIdentifier' is not null or undefined
            assertParamExists('eventsEventIdentifierGet', 'eventIdentifier', eventIdentifier)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('eventsEventIdentifierGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/events/{eventIdentifier}`
                .replace('{eventIdentifier}', encodeURIComponent(String(eventIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all published events with filters.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [isActive] 
         * @param {Date} [startAfter] 
         * @param {Date} [startBefore] 
         * @param {Date} [endAfter] 
         * @param {Date} [endBefore] 
         * @param {string} [eventIds] 
         * @param {string} [excludeIds] 
         * @param {string} [label] 
         * @param {string} [eventType] 
         * @param {string} [league] 
         * @param {string} [sportSlug] 
         * @param {string} [eventName] 
         * @param {string} [sortDirection] 
         * @param {string} [categoryId] 
         * @param {string} [categoryIds] 
         * @param {boolean} [homePageVisibility] 
         * @param {boolean} [nowLiveVisibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsGet: async (xPlatformKey: string, offset?: number, pageSize?: number, isActive?: boolean, startAfter?: Date, startBefore?: Date, endAfter?: Date, endBefore?: Date, eventIds?: string, excludeIds?: string, label?: string, eventType?: string, league?: string, sportSlug?: string, eventName?: string, sortDirection?: string, categoryId?: string, categoryIds?: string, homePageVisibility?: boolean, nowLiveVisibility?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('eventsGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }

            if (startAfter !== undefined) {
                localVarQueryParameter['StartAfter'] = (startAfter as any instanceof Date) ?
                    (startAfter as any).toISOString() :
                    startAfter;
            }

            if (startBefore !== undefined) {
                localVarQueryParameter['StartBefore'] = (startBefore as any instanceof Date) ?
                    (startBefore as any).toISOString() :
                    startBefore;
            }

            if (endAfter !== undefined) {
                localVarQueryParameter['EndAfter'] = (endAfter as any instanceof Date) ?
                    (endAfter as any).toISOString() :
                    endAfter;
            }

            if (endBefore !== undefined) {
                localVarQueryParameter['EndBefore'] = (endBefore as any instanceof Date) ?
                    (endBefore as any).toISOString() :
                    endBefore;
            }

            if (eventIds !== undefined) {
                localVarQueryParameter['EventIds'] = eventIds;
            }

            if (excludeIds !== undefined) {
                localVarQueryParameter['ExcludeIds'] = excludeIds;
            }

            if (label !== undefined) {
                localVarQueryParameter['Label'] = label;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['EventType'] = eventType;
            }

            if (league !== undefined) {
                localVarQueryParameter['League'] = league;
            }

            if (sportSlug !== undefined) {
                localVarQueryParameter['SportSlug'] = sportSlug;
            }

            if (eventName !== undefined) {
                localVarQueryParameter['EventName'] = eventName;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['SortDirection'] = sortDirection;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }

            if (categoryIds !== undefined) {
                localVarQueryParameter['CategoryIds'] = categoryIds;
            }

            if (homePageVisibility !== undefined) {
                localVarQueryParameter['HomePageVisibility'] = homePageVisibility;
            }

            if (nowLiveVisibility !== undefined) {
                localVarQueryParameter['NowLiveVisibility'] = nowLiveVisibility;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * accepts both team ids and team slugs
         * @summary get the events of a team
         * @param {string} teamIdentifier the id of the team or the slug of the team.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsTeamsTeamIdentifierGet: async (teamIdentifier: string, xPlatformKey: string, offSet?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamIdentifier' is not null or undefined
            assertParamExists('eventsTeamsTeamIdentifierGet', 'teamIdentifier', teamIdentifier)
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('eventsTeamsTeamIdentifierGet', 'xPlatformKey', xPlatformKey)
            const localVarPath = `/events/teams/{teamIdentifier}`
                .replace('{teamIdentifier}', encodeURIComponent(String(teamIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the events progress with contract
         * @param {string} contractId The id of the contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsContractContractIdProgressGet(contractId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventProgressResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsContractContractIdProgressGet(contractId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsContractContractIdProgressGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * accepts both both event id and slug returned DTO extends upon EventCategoryDto depending on which EventType is returned. The following types map to the following DTO: So it will have categories with the event
         * @summary get the details of a single event
         * @param {string} eventIdentifier The id or slug of the event
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsEventIdentifierGet(eventIdentifier: string, xPlatformKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsEventIdentifierGet(eventIdentifier, xPlatformKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsEventIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns all published events with filters.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset] 
         * @param {number} [pageSize] 
         * @param {boolean} [isActive] 
         * @param {Date} [startAfter] 
         * @param {Date} [startBefore] 
         * @param {Date} [endAfter] 
         * @param {Date} [endBefore] 
         * @param {string} [eventIds] 
         * @param {string} [excludeIds] 
         * @param {string} [label] 
         * @param {string} [eventType] 
         * @param {string} [league] 
         * @param {string} [sportSlug] 
         * @param {string} [eventName] 
         * @param {string} [sortDirection] 
         * @param {string} [categoryId] 
         * @param {string} [categoryIds] 
         * @param {boolean} [homePageVisibility] 
         * @param {boolean} [nowLiveVisibility] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsGet(xPlatformKey: string, offset?: number, pageSize?: number, isActive?: boolean, startAfter?: Date, startBefore?: Date, endAfter?: Date, endBefore?: Date, eventIds?: string, excludeIds?: string, label?: string, eventType?: string, league?: string, sportSlug?: string, eventName?: string, sortDirection?: string, categoryId?: string, categoryIds?: string, homePageVisibility?: boolean, nowLiveVisibility?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsGet(xPlatformKey, offset, pageSize, isActive, startAfter, startBefore, endAfter, endBefore, eventIds, excludeIds, label, eventType, league, sportSlug, eventName, sortDirection, categoryId, categoryIds, homePageVisibility, nowLiveVisibility, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * accepts both team ids and team slugs
         * @summary get the events of a team
         * @param {string} teamIdentifier the id of the team or the slug of the team.
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet] The amount of entities that should be skipped. Should be 0 or higher
         * @param {number} [pageSize] The amount of results to return per page. Should be 1 or higher
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventsTeamsTeamIdentifierGet(teamIdentifier: string, xPlatformKey: string, offSet?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedListOfEventDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventsTeamsTeamIdentifierGet(teamIdentifier, xPlatformKey, offSet, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsApi.eventsTeamsTeamIdentifierGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the events progress with contract
         * @param {EventsApiEventsContractContractIdProgressGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsContractContractIdProgressGet(requestParameters: EventsApiEventsContractContractIdProgressGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventProgressResponse>> {
            return localVarFp.eventsContractContractIdProgressGet(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         * accepts both both event id and slug returned DTO extends upon EventCategoryDto depending on which EventType is returned. The following types map to the following DTO: So it will have categories with the event
         * @summary get the details of a single event
         * @param {EventsApiEventsEventIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsEventIdentifierGet(requestParameters: EventsApiEventsEventIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<EventDetailsDto> {
            return localVarFp.eventsEventIdentifierGet(requestParameters.eventIdentifier, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns all published events with filters.
         * @param {EventsApiEventsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsGet(requestParameters: EventsApiEventsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfEventDto> {
            return localVarFp.eventsGet(requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, requestParameters.isActive, requestParameters.startAfter, requestParameters.startBefore, requestParameters.endAfter, requestParameters.endBefore, requestParameters.eventIds, requestParameters.excludeIds, requestParameters.label, requestParameters.eventType, requestParameters.league, requestParameters.sportSlug, requestParameters.eventName, requestParameters.sortDirection, requestParameters.categoryId, requestParameters.categoryIds, requestParameters.homePageVisibility, requestParameters.nowLiveVisibility, options).then((request) => request(axios, basePath));
        },
        /**
         * accepts both team ids and team slugs
         * @summary get the events of a team
         * @param {EventsApiEventsTeamsTeamIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventsTeamsTeamIdentifierGet(requestParameters: EventsApiEventsTeamsTeamIdentifierGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedListOfEventDto> {
            return localVarFp.eventsTeamsTeamIdentifierGet(requestParameters.teamIdentifier, requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for eventsContractContractIdProgressGet operation in EventsApi.
 */
export interface EventsApiEventsContractContractIdProgressGetRequest {
    /**
     * The id of the contract
     */
    readonly contractId: string
}

/**
 * Request parameters for eventsEventIdentifierGet operation in EventsApi.
 */
export interface EventsApiEventsEventIdentifierGetRequest {
    /**
     * The id or slug of the event
     */
    readonly eventIdentifier: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string
}

/**
 * Request parameters for eventsGet operation in EventsApi.
 */
export interface EventsApiEventsGetRequest {
    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    readonly offset?: number

    readonly pageSize?: number

    readonly isActive?: boolean

    readonly startAfter?: Date

    readonly startBefore?: Date

    readonly endAfter?: Date

    readonly endBefore?: Date

    readonly eventIds?: string

    readonly excludeIds?: string

    readonly label?: string

    readonly eventType?: string

    readonly league?: string

    readonly sportSlug?: string

    readonly eventName?: string

    readonly sortDirection?: string

    readonly categoryId?: string

    readonly categoryIds?: string

    readonly homePageVisibility?: boolean

    readonly nowLiveVisibility?: boolean
}

/**
 * Request parameters for eventsTeamsTeamIdentifierGet operation in EventsApi.
 */
export interface EventsApiEventsTeamsTeamIdentifierGetRequest {
    /**
     * the id of the team or the slug of the team.
     */
    readonly teamIdentifier: string

    /**
     * Select the platform.
     */
    readonly xPlatformKey: string

    /**
     * The amount of entities that should be skipped. Should be 0 or higher
     */
    readonly offSet?: number

    /**
     * The amount of results to return per page. Should be 1 or higher
     */
    readonly pageSize?: number
}

/**
 * EventsApi - object-oriented interface
 */
export class EventsApi extends BaseAPI {
    /**
     * 
     * @summary Get the events progress with contract
     * @param {EventsApiEventsContractContractIdProgressGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsContractContractIdProgressGet(requestParameters: EventsApiEventsContractContractIdProgressGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsContractContractIdProgressGet(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * accepts both both event id and slug returned DTO extends upon EventCategoryDto depending on which EventType is returned. The following types map to the following DTO: So it will have categories with the event
     * @summary get the details of a single event
     * @param {EventsApiEventsEventIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsEventIdentifierGet(requestParameters: EventsApiEventsEventIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsEventIdentifierGet(requestParameters.eventIdentifier, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns all published events with filters.
     * @param {EventsApiEventsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsGet(requestParameters: EventsApiEventsGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsGet(requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, requestParameters.isActive, requestParameters.startAfter, requestParameters.startBefore, requestParameters.endAfter, requestParameters.endBefore, requestParameters.eventIds, requestParameters.excludeIds, requestParameters.label, requestParameters.eventType, requestParameters.league, requestParameters.sportSlug, requestParameters.eventName, requestParameters.sortDirection, requestParameters.categoryId, requestParameters.categoryIds, requestParameters.homePageVisibility, requestParameters.nowLiveVisibility, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * accepts both team ids and team slugs
     * @summary get the events of a team
     * @param {EventsApiEventsTeamsTeamIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventsTeamsTeamIdentifierGet(requestParameters: EventsApiEventsTeamsTeamIdentifierGetRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).eventsTeamsTeamIdentifierGet(requestParameters.teamIdentifier, requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalProductsApi - axios parameter creator
 */
export const ExternalProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductId360Post: async (productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsProductId360Post', 'productId', productId)
            // verify required parameter 'addImageUrlToProductRequest' is not null or undefined
            assertParamExists('productsProductId360Post', 'addImageUrlToProductRequest', addImageUrlToProductRequest)
            const localVarPath = `/products/{productId}/360`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addImageUrlToProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdChannablePost: async (productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsProductIdChannablePost', 'productId', productId)
            // verify required parameter 'addImageUrlToProductRequest' is not null or undefined
            assertParamExists('productsProductIdChannablePost', 'addImageUrlToProductRequest', addImageUrlToProductRequest)
            const localVarPath = `/products/{productId}/channable`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addImageUrlToProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdImageUrlPost: async (productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('productsProductIdImageUrlPost', 'productId', productId)
            // verify required parameter 'addImageUrlToProductRequest' is not null or undefined
            assertParamExists('productsProductIdImageUrlPost', 'addImageUrlToProductRequest', addImageUrlToProductRequest)
            const localVarPath = `/products/{productId}/image-url`
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addImageUrlToProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalProductsApi - functional programming interface
 */
export const ExternalProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsProductId360Post(productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsProductId360Post(productId, addImageUrlToProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalProductsApi.productsProductId360Post']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsProductIdChannablePost(productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsProductIdChannablePost(productId, addImageUrlToProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalProductsApi.productsProductIdChannablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productId 
         * @param {AddImageUrlToProductRequest} addImageUrlToProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productsProductIdImageUrlPost(productId: string, addImageUrlToProductRequest: AddImageUrlToProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productsProductIdImageUrlPost(productId, addImageUrlToProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalProductsApi.productsProductIdImageUrlPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalProductsApi - factory interface
 */
export const ExternalProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalProductsApiProductsProductId360PostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductId360Post(requestParameters: ExternalProductsApiProductsProductId360PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsProductId360Post(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalProductsApiProductsProductIdChannablePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdChannablePost(requestParameters: ExternalProductsApiProductsProductIdChannablePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsProductIdChannablePost(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExternalProductsApiProductsProductIdImageUrlPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdImageUrlPost(requestParameters: ExternalProductsApiProductsProductIdImageUrlPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productsProductIdImageUrlPost(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productsProductId360Post operation in ExternalProductsApi.
 */
export interface ExternalProductsApiProductsProductId360PostRequest {
    readonly productId: string

    readonly addImageUrlToProductRequest: AddImageUrlToProductRequest
}

/**
 * Request parameters for productsProductIdChannablePost operation in ExternalProductsApi.
 */
export interface ExternalProductsApiProductsProductIdChannablePostRequest {
    readonly productId: string

    readonly addImageUrlToProductRequest: AddImageUrlToProductRequest
}

/**
 * Request parameters for productsProductIdImageUrlPost operation in ExternalProductsApi.
 */
export interface ExternalProductsApiProductsProductIdImageUrlPostRequest {
    readonly productId: string

    readonly addImageUrlToProductRequest: AddImageUrlToProductRequest
}

/**
 * ExternalProductsApi - object-oriented interface
 */
export class ExternalProductsApi extends BaseAPI {
    /**
     * 
     * @param {ExternalProductsApiProductsProductId360PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public productsProductId360Post(requestParameters: ExternalProductsApiProductsProductId360PostRequest, options?: RawAxiosRequestConfig) {
        return ExternalProductsApiFp(this.configuration).productsProductId360Post(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalProductsApiProductsProductIdChannablePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public productsProductIdChannablePost(requestParameters: ExternalProductsApiProductsProductIdChannablePostRequest, options?: RawAxiosRequestConfig) {
        return ExternalProductsApiFp(this.configuration).productsProductIdChannablePost(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExternalProductsApiProductsProductIdImageUrlPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public productsProductIdImageUrlPost(requestParameters: ExternalProductsApiProductsProductIdImageUrlPostRequest, options?: RawAxiosRequestConfig) {
        return ExternalProductsApiFp(this.configuration).productsProductIdImageUrlPost(requestParameters.productId, requestParameters.addImageUrlToProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalProductsApi - axios parameter creator
 */
export const InternalProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary [internal] Returns listing details by identifier
         * @param {string} listingId the id (guid) of the listing for which details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProductsListingIdGet: async (listingId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listingId' is not null or undefined
            assertParamExists('internalProductsListingIdGet', 'listingId', listingId)
            const localVarPath = `/internal/products/{listingId}`
                .replace('{listingId}', encodeURIComponent(String(listingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalProductsApi - functional programming interface
 */
export const InternalProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary [internal] Returns listing details by identifier
         * @param {string} listingId the id (guid) of the listing for which details are to be fetched
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async internalProductsListingIdGet(listingId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductSkuDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.internalProductsListingIdGet(listingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalProductsApi.internalProductsListingIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalProductsApi - factory interface
 */
export const InternalProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary [internal] Returns listing details by identifier
         * @param {InternalProductsApiInternalProductsListingIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalProductsListingIdGet(requestParameters: InternalProductsApiInternalProductsListingIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductSkuDto> {
            return localVarFp.internalProductsListingIdGet(requestParameters.listingId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for internalProductsListingIdGet operation in InternalProductsApi.
 */
export interface InternalProductsApiInternalProductsListingIdGetRequest {
    /**
     * the id (guid) of the listing for which details are to be fetched
     */
    readonly listingId: string
}

/**
 * InternalProductsApi - object-oriented interface
 */
export class InternalProductsApi extends BaseAPI {
    /**
     * 
     * @summary [internal] Returns listing details by identifier
     * @param {InternalProductsApiInternalProductsListingIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public internalProductsListingIdGet(requestParameters: InternalProductsApiInternalProductsListingIdGetRequest, options?: RawAxiosRequestConfig) {
        return InternalProductsApiFp(this.configuration).internalProductsListingIdGet(requestParameters.listingId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KitmanInboundProductApi - axios parameter creator
 */
export const KitmanInboundProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new product for an inbound report
         * @param {string} reportId 
         * @param {CreateInboundProductRequestV2} createInboundProductRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsPost: async (reportId: string, createInboundProductRequestV2: CreateInboundProductRequestV2, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsPost', 'reportId', reportId)
            // verify required parameter 'createInboundProductRequestV2' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsPost', 'createInboundProductRequestV2', createInboundProductRequestV2)
            const localVarPath = `/kit-man/inbound-reports/{reportId}/products`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInboundProductRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a product for an inbound report
         * @param {string} productId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsProductIdGet: async (productId: string, reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsProductIdGet', 'productId', productId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsProductIdGet', 'reportId', reportId)
            const localVarPath = `/kit-man/inbound-reports/{reportId}/products/{productId}`
                .replace('{productId}', encodeURIComponent(String(productId)))
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a product of an inbound report
         * @param {string} reportId 
         * @param {string} productId 
         * @param {UpdateInboundProductRequest} updateInboundProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsProductIdPut: async (reportId: string, productId: string, updateInboundProductRequest: UpdateInboundProductRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsProductIdPut', 'reportId', reportId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsProductIdPut', 'productId', productId)
            // verify required parameter 'updateInboundProductRequest' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdProductsProductIdPut', 'updateInboundProductRequest', updateInboundProductRequest)
            const localVarPath = `/kit-man/inbound-reports/{reportId}/products/{productId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)))
                .replace('{productId}', encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInboundProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KitmanInboundProductApi - functional programming interface
 */
export const KitmanInboundProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KitmanInboundProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new product for an inbound report
         * @param {string} reportId 
         * @param {CreateInboundProductRequestV2} createInboundProductRequestV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kitManInboundReportsReportIdProductsPost(reportId: string, createInboundProductRequestV2: CreateInboundProductRequestV2, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kitManInboundReportsReportIdProductsPost(reportId, createInboundProductRequestV2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitmanInboundProductApi.kitManInboundReportsReportIdProductsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a product for an inbound report
         * @param {string} productId 
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kitManInboundReportsReportIdProductsProductIdGet(productId: string, reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitmanInboundProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kitManInboundReportsReportIdProductsProductIdGet(productId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitmanInboundProductApi.kitManInboundReportsReportIdProductsProductIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a product of an inbound report
         * @param {string} reportId 
         * @param {string} productId 
         * @param {UpdateInboundProductRequest} updateInboundProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kitManInboundReportsReportIdProductsProductIdPut(reportId: string, productId: string, updateInboundProductRequest: UpdateInboundProductRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kitManInboundReportsReportIdProductsProductIdPut(reportId, productId, updateInboundProductRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitmanInboundProductApi.kitManInboundReportsReportIdProductsProductIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KitmanInboundProductApi - factory interface
 */
export const KitmanInboundProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KitmanInboundProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new product for an inbound report
         * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsPost(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.kitManInboundReportsReportIdProductsPost(requestParameters.reportId, requestParameters.createInboundProductRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a product for an inbound report
         * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsProductIdGet(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<KitmanInboundProductResponse> {
            return localVarFp.kitManInboundReportsReportIdProductsProductIdGet(requestParameters.productId, requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a product of an inbound report
         * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdProductsProductIdPut(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.kitManInboundReportsReportIdProductsProductIdPut(requestParameters.reportId, requestParameters.productId, requestParameters.updateInboundProductRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for kitManInboundReportsReportIdProductsPost operation in KitmanInboundProductApi.
 */
export interface KitmanInboundProductApiKitManInboundReportsReportIdProductsPostRequest {
    readonly reportId: string

    readonly createInboundProductRequestV2: CreateInboundProductRequestV2
}

/**
 * Request parameters for kitManInboundReportsReportIdProductsProductIdGet operation in KitmanInboundProductApi.
 */
export interface KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdGetRequest {
    readonly productId: string

    readonly reportId: string
}

/**
 * Request parameters for kitManInboundReportsReportIdProductsProductIdPut operation in KitmanInboundProductApi.
 */
export interface KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdPutRequest {
    readonly reportId: string

    readonly productId: string

    readonly updateInboundProductRequest: UpdateInboundProductRequest
}

/**
 * KitmanInboundProductApi - object-oriented interface
 */
export class KitmanInboundProductApi extends BaseAPI {
    /**
     * 
     * @summary Create a new product for an inbound report
     * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kitManInboundReportsReportIdProductsPost(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsPostRequest, options?: RawAxiosRequestConfig) {
        return KitmanInboundProductApiFp(this.configuration).kitManInboundReportsReportIdProductsPost(requestParameters.reportId, requestParameters.createInboundProductRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a product for an inbound report
     * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kitManInboundReportsReportIdProductsProductIdGet(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdGetRequest, options?: RawAxiosRequestConfig) {
        return KitmanInboundProductApiFp(this.configuration).kitManInboundReportsReportIdProductsProductIdGet(requestParameters.productId, requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a product of an inbound report
     * @param {KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kitManInboundReportsReportIdProductsProductIdPut(requestParameters: KitmanInboundProductApiKitManInboundReportsReportIdProductsProductIdPutRequest, options?: RawAxiosRequestConfig) {
        return KitmanInboundProductApiFp(this.configuration).kitManInboundReportsReportIdProductsProductIdPut(requestParameters.reportId, requestParameters.productId, requestParameters.updateInboundProductRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KitmanInboundReportApi - axios parameter creator
 */
export const KitmanInboundReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get an inbound report for kit man
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdGet: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdGet', 'reportId', reportId)
            const localVarPath = `/kit-man/inbound-reports/{reportId}`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Submit an inbound report for kit man
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdSubmitPut: async (reportId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('kitManInboundReportsReportIdSubmitPut', 'reportId', reportId)
            const localVarPath = `/kit-man/inbound-reports/{reportId}/submit`
                .replace('{reportId}', encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KitmanInboundReportApi - functional programming interface
 */
export const KitmanInboundReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KitmanInboundReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get an inbound report for kit man
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kitManInboundReportsReportIdGet(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KitmanInboundReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kitManInboundReportsReportIdGet(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitmanInboundReportApi.kitManInboundReportsReportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Submit an inbound report for kit man
         * @param {string} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kitManInboundReportsReportIdSubmitPut(reportId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kitManInboundReportsReportIdSubmitPut(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KitmanInboundReportApi.kitManInboundReportsReportIdSubmitPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KitmanInboundReportApi - factory interface
 */
export const KitmanInboundReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KitmanInboundReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Get an inbound report for kit man
         * @param {KitmanInboundReportApiKitManInboundReportsReportIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdGet(requestParameters: KitmanInboundReportApiKitManInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<KitmanInboundReportResponse> {
            return localVarFp.kitManInboundReportsReportIdGet(requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Submit an inbound report for kit man
         * @param {KitmanInboundReportApiKitManInboundReportsReportIdSubmitPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kitManInboundReportsReportIdSubmitPut(requestParameters: KitmanInboundReportApiKitManInboundReportsReportIdSubmitPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.kitManInboundReportsReportIdSubmitPut(requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for kitManInboundReportsReportIdGet operation in KitmanInboundReportApi.
 */
export interface KitmanInboundReportApiKitManInboundReportsReportIdGetRequest {
    readonly reportId: string
}

/**
 * Request parameters for kitManInboundReportsReportIdSubmitPut operation in KitmanInboundReportApi.
 */
export interface KitmanInboundReportApiKitManInboundReportsReportIdSubmitPutRequest {
    readonly reportId: string
}

/**
 * KitmanInboundReportApi - object-oriented interface
 */
export class KitmanInboundReportApi extends BaseAPI {
    /**
     * 
     * @summary Get an inbound report for kit man
     * @param {KitmanInboundReportApiKitManInboundReportsReportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kitManInboundReportsReportIdGet(requestParameters: KitmanInboundReportApiKitManInboundReportsReportIdGetRequest, options?: RawAxiosRequestConfig) {
        return KitmanInboundReportApiFp(this.configuration).kitManInboundReportsReportIdGet(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Submit an inbound report for kit man
     * @param {KitmanInboundReportApiKitManInboundReportsReportIdSubmitPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public kitManInboundReportsReportIdSubmitPut(requestParameters: KitmanInboundReportApiKitManInboundReportsReportIdSubmitPutRequest, options?: RawAxiosRequestConfig) {
        return KitmanInboundReportApiFp(this.configuration).kitManInboundReportsReportIdSubmitPut(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LabelsApi - axios parameter creator
 */
export const LabelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get all labels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LabelsApi - functional programming interface
 */
export const LabelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LabelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get all labels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async labelsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LabelDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.labelsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LabelsApi.labelsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LabelsApi - factory interface
 */
export const LabelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LabelsApiFp(configuration)
    return {
        /**
         * 
         * @summary get all labels
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        labelsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<LabelDto>> {
            return localVarFp.labelsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LabelsApi - object-oriented interface
 */
export class LabelsApi extends BaseAPI {
    /**
     * 
     * @summary get all labels
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public labelsGet(options?: RawAxiosRequestConfig) {
        return LabelsApiFp(this.configuration).labelsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PreferencesApi - axios parameter creator
 */
export const PreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Controller triggered by the cronjob to send out auction live messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerauctionlivePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/triggerauctionlive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Controller triggered by the cronjob to send out daily messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggereventsoverviewPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/triggereventsoverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreferencesApi - functional programming interface
 */
export const PreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Controller triggered by the cronjob to send out auction live messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerauctionlivePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerauctionlivePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.triggerauctionlivePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Controller triggered by the cronjob to send out daily messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggereventsoverviewPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggereventsoverviewPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.triggereventsoverviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreferencesApi - factory interface
 */
export const PreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Controller triggered by the cronjob to send out auction live messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerauctionlivePost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggerauctionlivePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Controller triggered by the cronjob to send out daily messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggereventsoverviewPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.triggereventsoverviewPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreferencesApi - object-oriented interface
 */
export class PreferencesApi extends BaseAPI {
    /**
     * 
     * @summary Controller triggered by the cronjob to send out auction live messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggerauctionlivePost(options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).triggerauctionlivePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Controller triggered by the cronjob to send out daily messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public triggereventsoverviewPost(options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).triggereventsoverviewPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserProfileApi - axios parameter creator
 */
export const UserProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint is called by the finance service which is the entry point for the \"user stats\" as shown on the my profile page. The user stats section contains a combination of data from the finance and catalog service, so a catalog-specific endpoint is needed to provide the catalog data.
         * @summary [User] Endpoint for fetching catalog-specific stats for the user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCurrentProfileGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/current/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json,text/json,text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserProfileApi - functional programming interface
 */
export const UserProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint is called by the finance service which is the entry point for the \"user stats\" as shown on the my profile page. The user stats section contains a combination of data from the finance and catalog service, so a catalog-specific endpoint is needed to provide the catalog data.
         * @summary [User] Endpoint for fetching catalog-specific stats for the user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersCurrentProfileGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersCurrentProfileGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserProfileApi.usersCurrentProfileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserProfileApi - factory interface
 */
export const UserProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserProfileApiFp(configuration)
    return {
        /**
         * This endpoint is called by the finance service which is the entry point for the \"user stats\" as shown on the my profile page. The user stats section contains a combination of data from the finance and catalog service, so a catalog-specific endpoint is needed to provide the catalog data.
         * @summary [User] Endpoint for fetching catalog-specific stats for the user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersCurrentProfileGet(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileStatsDto> {
            return localVarFp.usersCurrentProfileGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserProfileApi - object-oriented interface
 */
export class UserProfileApi extends BaseAPI {
    /**
     * This endpoint is called by the finance service which is the entry point for the \"user stats\" as shown on the my profile page. The user stats section contains a combination of data from the finance and catalog service, so a catalog-specific endpoint is needed to provide the catalog data.
     * @summary [User] Endpoint for fetching catalog-specific stats for the user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersCurrentProfileGet(options?: RawAxiosRequestConfig) {
        return UserProfileApiFp(this.configuration).usersCurrentProfileGet(options).then((request) => request(this.axios, this.basePath));
    }
}



